var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a2, b2) => {
  for (var prop in b2 || (b2 = {}))
    if (__hasOwnProp.call(b2, prop))
      __defNormalProp(a2, prop, b2[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b2)) {
      if (__propIsEnum.call(b2, prop))
        __defNormalProp(a2, prop, b2[prop]);
    }
  return a2;
};
var __spreadProps = (a2, b2) => __defProps(a2, __getOwnPropDescs(b2));
var __objRest = (source4, exclude) => {
  var target = {};
  for (var prop in source4)
    if (__hasOwnProp.call(source4, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source4[prop];
  if (source4 != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source4)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source4, prop))
        target[prop] = source4[prop];
    }
  return target;
};
var __accessCheck = (obj, member, msg) => {
  if (!member.has(obj))
    throw TypeError("Cannot " + msg);
};
var __privateGet = (obj, member, getter) => {
  __accessCheck(obj, member, "read from private field");
  return getter ? getter.call(obj) : member.get(obj);
};
var __privateAdd = (obj, member, value) => {
  if (member.has(obj))
    throw TypeError("Cannot add the same private member more than once");
  member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
};
var __privateSet = (obj, member, value, setter) => {
  __accessCheck(obj, member, "write to private field");
  setter ? setter.call(obj, value) : member.set(obj, value);
  return value;
};
var _interpreter, _channel, _subscriptions, _client;
import * as React from "react";
import React__default, { useLayoutEffect, useRef, useEffect, useCallback, useState, useMemo, createContext, useContext } from "react";
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
var __assign$1 = function() {
  __assign$1 = Object.assign || function __assign2(t2) {
    for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
      s2 = arguments[i2];
      for (var p2 in s2)
        if (Object.prototype.hasOwnProperty.call(s2, p2))
          t2[p2] = s2[p2];
    }
    return t2;
  };
  return __assign$1.apply(this, arguments);
};
function __rest$1(s2, e2) {
  var t2 = {};
  for (var p2 in s2)
    if (Object.prototype.hasOwnProperty.call(s2, p2) && e2.indexOf(p2) < 0)
      t2[p2] = s2[p2];
  if (s2 != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i2 = 0, p2 = Object.getOwnPropertySymbols(s2); i2 < p2.length; i2++) {
      if (e2.indexOf(p2[i2]) < 0 && Object.prototype.propertyIsEnumerable.call(s2, p2[i2]))
        t2[p2[i2]] = s2[p2[i2]];
    }
  return t2;
}
function __values$1(o2) {
  var s2 = typeof Symbol === "function" && Symbol.iterator, m2 = s2 && o2[s2], i2 = 0;
  if (m2)
    return m2.call(o2);
  if (o2 && typeof o2.length === "number")
    return {
      next: function() {
        if (o2 && i2 >= o2.length)
          o2 = void 0;
        return { value: o2 && o2[i2++], done: !o2 };
      }
    };
  throw new TypeError(s2 ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read$4(o2, n2) {
  var m2 = typeof Symbol === "function" && o2[Symbol.iterator];
  if (!m2)
    return o2;
  var i2 = m2.call(o2), r2, ar = [], e2;
  try {
    while ((n2 === void 0 || n2-- > 0) && !(r2 = i2.next()).done)
      ar.push(r2.value);
  } catch (error2) {
    e2 = { error: error2 };
  } finally {
    try {
      if (r2 && !r2.done && (m2 = i2["return"]))
        m2.call(i2);
    } finally {
      if (e2)
        throw e2.error;
    }
  }
  return ar;
}
function __spreadArray$1(to, from, pack) {
  if (pack || arguments.length === 2)
    for (var i2 = 0, l2 = from.length, ar; i2 < l2; i2++) {
      if (ar || !(i2 in from)) {
        if (!ar)
          ar = Array.prototype.slice.call(from, 0, i2);
        ar[i2] = from[i2];
      }
    }
  return to.concat(ar || Array.prototype.slice.call(from));
}
var ActionTypes;
(function(ActionTypes2) {
  ActionTypes2["Start"] = "xstate.start";
  ActionTypes2["Stop"] = "xstate.stop";
  ActionTypes2["Raise"] = "xstate.raise";
  ActionTypes2["Send"] = "xstate.send";
  ActionTypes2["Cancel"] = "xstate.cancel";
  ActionTypes2["NullEvent"] = "";
  ActionTypes2["Assign"] = "xstate.assign";
  ActionTypes2["After"] = "xstate.after";
  ActionTypes2["DoneState"] = "done.state";
  ActionTypes2["DoneInvoke"] = "done.invoke";
  ActionTypes2["Log"] = "xstate.log";
  ActionTypes2["Init"] = "xstate.init";
  ActionTypes2["Invoke"] = "xstate.invoke";
  ActionTypes2["ErrorExecution"] = "error.execution";
  ActionTypes2["ErrorCommunication"] = "error.communication";
  ActionTypes2["ErrorPlatform"] = "error.platform";
  ActionTypes2["ErrorCustom"] = "xstate.error";
  ActionTypes2["Update"] = "xstate.update";
  ActionTypes2["Pure"] = "xstate.pure";
  ActionTypes2["Choose"] = "xstate.choose";
})(ActionTypes || (ActionTypes = {}));
var SpecialTargets;
(function(SpecialTargets2) {
  SpecialTargets2["Parent"] = "#_parent";
  SpecialTargets2["Internal"] = "#_internal";
})(SpecialTargets || (SpecialTargets = {}));
var start$1 = ActionTypes.Start;
var stop$1 = ActionTypes.Stop;
var raise$1 = ActionTypes.Raise;
var send$2 = ActionTypes.Send;
var cancel$1 = ActionTypes.Cancel;
var nullEvent = ActionTypes.NullEvent;
var assign$3 = ActionTypes.Assign;
ActionTypes.After;
ActionTypes.DoneState;
var log = ActionTypes.Log;
var init$1 = ActionTypes.Init;
var invoke = ActionTypes.Invoke;
ActionTypes.ErrorExecution;
var errorPlatform = ActionTypes.ErrorPlatform;
var error$1 = ActionTypes.ErrorCustom;
var update = ActionTypes.Update;
var choose = ActionTypes.Choose;
var pure = ActionTypes.Pure;
var STATE_DELIMITER = ".";
var EMPTY_ACTIVITY_MAP = {};
var DEFAULT_GUARD_TYPE = "xstate.guard";
var TARGETLESS_KEY = "";
var IS_PRODUCTION = true;
var _a;
function matchesState(parentStateId, childStateId, delimiter) {
  if (delimiter === void 0) {
    delimiter = STATE_DELIMITER;
  }
  var parentStateValue = toStateValue(parentStateId, delimiter);
  var childStateValue = toStateValue(childStateId, delimiter);
  if (isString$3(childStateValue)) {
    if (isString$3(parentStateValue)) {
      return childStateValue === parentStateValue;
    }
    return false;
  }
  if (isString$3(parentStateValue)) {
    return parentStateValue in childStateValue;
  }
  return Object.keys(parentStateValue).every(function(key) {
    if (!(key in childStateValue)) {
      return false;
    }
    return matchesState(parentStateValue[key], childStateValue[key]);
  });
}
function getEventType(event) {
  try {
    return isString$3(event) || typeof event === "number" ? "".concat(event) : event.type;
  } catch (e2) {
    throw new Error("Events must be strings or objects with a string event.type property.");
  }
}
function toStatePath(stateId, delimiter) {
  try {
    if (isArray$3(stateId)) {
      return stateId;
    }
    return stateId.toString().split(delimiter);
  } catch (e2) {
    throw new Error("'".concat(stateId, "' is not a valid state path."));
  }
}
function isStateLike(state) {
  return typeof state === "object" && "value" in state && "context" in state && "event" in state && "_event" in state;
}
function toStateValue(stateValue, delimiter) {
  if (isStateLike(stateValue)) {
    return stateValue.value;
  }
  if (isArray$3(stateValue)) {
    return pathToStateValue(stateValue);
  }
  if (typeof stateValue !== "string") {
    return stateValue;
  }
  var statePath = toStatePath(stateValue, delimiter);
  return pathToStateValue(statePath);
}
function pathToStateValue(statePath) {
  if (statePath.length === 1) {
    return statePath[0];
  }
  var value = {};
  var marker = value;
  for (var i2 = 0; i2 < statePath.length - 1; i2++) {
    if (i2 === statePath.length - 2) {
      marker[statePath[i2]] = statePath[i2 + 1];
    } else {
      marker[statePath[i2]] = {};
      marker = marker[statePath[i2]];
    }
  }
  return value;
}
function mapValues(collection, iteratee) {
  var result = {};
  var collectionKeys = Object.keys(collection);
  for (var i2 = 0; i2 < collectionKeys.length; i2++) {
    var key = collectionKeys[i2];
    result[key] = iteratee(collection[key], key, collection, i2);
  }
  return result;
}
function mapFilterValues(collection, iteratee, predicate) {
  var e_1, _a2;
  var result = {};
  try {
    for (var _b = __values$1(Object.keys(collection)), _c = _b.next(); !_c.done; _c = _b.next()) {
      var key = _c.value;
      var item = collection[key];
      if (!predicate(item)) {
        continue;
      }
      result[key] = iteratee(item, key, collection);
    }
  } catch (e_1_1) {
    e_1 = {
      error: e_1_1
    };
  } finally {
    try {
      if (_c && !_c.done && (_a2 = _b.return))
        _a2.call(_b);
    } finally {
      if (e_1)
        throw e_1.error;
    }
  }
  return result;
}
var path = function(props) {
  return function(object) {
    var e_2, _a2;
    var result = object;
    try {
      for (var props_1 = __values$1(props), props_1_1 = props_1.next(); !props_1_1.done; props_1_1 = props_1.next()) {
        var prop = props_1_1.value;
        result = result[prop];
      }
    } catch (e_2_1) {
      e_2 = {
        error: e_2_1
      };
    } finally {
      try {
        if (props_1_1 && !props_1_1.done && (_a2 = props_1.return))
          _a2.call(props_1);
      } finally {
        if (e_2)
          throw e_2.error;
      }
    }
    return result;
  };
};
function nestedPath(props, accessorProp) {
  return function(object) {
    var e_3, _a2;
    var result = object;
    try {
      for (var props_2 = __values$1(props), props_2_1 = props_2.next(); !props_2_1.done; props_2_1 = props_2.next()) {
        var prop = props_2_1.value;
        result = result[accessorProp][prop];
      }
    } catch (e_3_1) {
      e_3 = {
        error: e_3_1
      };
    } finally {
      try {
        if (props_2_1 && !props_2_1.done && (_a2 = props_2.return))
          _a2.call(props_2);
      } finally {
        if (e_3)
          throw e_3.error;
      }
    }
    return result;
  };
}
function toStatePaths(stateValue) {
  if (!stateValue) {
    return [[]];
  }
  if (isString$3(stateValue)) {
    return [[stateValue]];
  }
  var result = flatten(Object.keys(stateValue).map(function(key) {
    var subStateValue = stateValue[key];
    if (typeof subStateValue !== "string" && (!subStateValue || !Object.keys(subStateValue).length)) {
      return [[key]];
    }
    return toStatePaths(stateValue[key]).map(function(subPath) {
      return [key].concat(subPath);
    });
  }));
  return result;
}
function flatten(array) {
  var _a2;
  return (_a2 = []).concat.apply(_a2, __spreadArray$1([], __read$4(array), false));
}
function toArrayStrict(value) {
  if (isArray$3(value)) {
    return value;
  }
  return [value];
}
function toArray(value) {
  if (value === void 0) {
    return [];
  }
  return toArrayStrict(value);
}
function mapContext(mapper, context, _event) {
  var e_5, _a2;
  if (isFunction$3(mapper)) {
    return mapper(context, _event.data);
  }
  var result = {};
  try {
    for (var _b = __values$1(Object.keys(mapper)), _c = _b.next(); !_c.done; _c = _b.next()) {
      var key = _c.value;
      var subMapper = mapper[key];
      if (isFunction$3(subMapper)) {
        result[key] = subMapper(context, _event.data);
      } else {
        result[key] = subMapper;
      }
    }
  } catch (e_5_1) {
    e_5 = {
      error: e_5_1
    };
  } finally {
    try {
      if (_c && !_c.done && (_a2 = _b.return))
        _a2.call(_b);
    } finally {
      if (e_5)
        throw e_5.error;
    }
  }
  return result;
}
function isBuiltInEvent(eventType) {
  return /^(done|error)\./.test(eventType);
}
function isPromiseLike(value) {
  if (value instanceof Promise) {
    return true;
  }
  if (value !== null && (isFunction$3(value) || typeof value === "object") && isFunction$3(value.then)) {
    return true;
  }
  return false;
}
function isBehavior(value) {
  return value !== null && typeof value === "object" && "transition" in value && typeof value.transition === "function";
}
function partition$1(items, predicate) {
  var e_6, _a2;
  var _b = __read$4([[], []], 2), truthy = _b[0], falsy = _b[1];
  try {
    for (var items_1 = __values$1(items), items_1_1 = items_1.next(); !items_1_1.done; items_1_1 = items_1.next()) {
      var item = items_1_1.value;
      if (predicate(item)) {
        truthy.push(item);
      } else {
        falsy.push(item);
      }
    }
  } catch (e_6_1) {
    e_6 = {
      error: e_6_1
    };
  } finally {
    try {
      if (items_1_1 && !items_1_1.done && (_a2 = items_1.return))
        _a2.call(items_1);
    } finally {
      if (e_6)
        throw e_6.error;
    }
  }
  return [truthy, falsy];
}
function updateHistoryStates(hist, stateValue) {
  return mapValues(hist.states, function(subHist, key) {
    if (!subHist) {
      return void 0;
    }
    var subStateValue = (isString$3(stateValue) ? void 0 : stateValue[key]) || (subHist ? subHist.current : void 0);
    if (!subStateValue) {
      return void 0;
    }
    return {
      current: subStateValue,
      states: updateHistoryStates(subHist, subStateValue)
    };
  });
}
function updateHistoryValue(hist, stateValue) {
  return {
    current: stateValue,
    states: updateHistoryStates(hist, stateValue)
  };
}
function updateContext(context, _event, assignActions, state) {
  var updatedContext = context ? assignActions.reduce(function(acc, assignAction) {
    var e_7, _a2;
    var assignment = assignAction.assignment;
    var meta = {
      state,
      action: assignAction,
      _event
    };
    var partialUpdate = {};
    if (isFunction$3(assignment)) {
      partialUpdate = assignment(acc, _event.data, meta);
    } else {
      try {
        for (var _b = __values$1(Object.keys(assignment)), _c = _b.next(); !_c.done; _c = _b.next()) {
          var key = _c.value;
          var propAssignment = assignment[key];
          partialUpdate[key] = isFunction$3(propAssignment) ? propAssignment(acc, _event.data, meta) : propAssignment;
        }
      } catch (e_7_1) {
        e_7 = {
          error: e_7_1
        };
      } finally {
        try {
          if (_c && !_c.done && (_a2 = _b.return))
            _a2.call(_b);
        } finally {
          if (e_7)
            throw e_7.error;
        }
      }
    }
    return Object.assign({}, acc, partialUpdate);
  }, context) : context;
  return updatedContext;
}
var warn = function() {
};
function isArray$3(value) {
  return Array.isArray(value);
}
function isFunction$3(value) {
  return typeof value === "function";
}
function isString$3(value) {
  return typeof value === "string";
}
function toGuard(condition, guardMap) {
  if (!condition) {
    return void 0;
  }
  if (isString$3(condition)) {
    return {
      type: DEFAULT_GUARD_TYPE,
      name: condition,
      predicate: guardMap ? guardMap[condition] : void 0
    };
  }
  if (isFunction$3(condition)) {
    return {
      type: DEFAULT_GUARD_TYPE,
      name: condition.name,
      predicate: condition
    };
  }
  return condition;
}
function isObservable(value) {
  try {
    return "subscribe" in value && isFunction$3(value.subscribe);
  } catch (e2) {
    return false;
  }
}
var symbolObservable = /* @__PURE__ */ function() {
  return typeof Symbol === "function" && Symbol.observable || "@@observable";
}();
_a = {}, _a[symbolObservable] = function() {
  return this;
}, _a[Symbol.observable] = function() {
  return this;
}, _a;
function isMachine(value) {
  return !!value && "__xstatenode" in value;
}
function isActor$1(value) {
  return !!value && typeof value.send === "function";
}
function toEventObject(event, payload) {
  if (isString$3(event) || typeof event === "number") {
    return __assign$1({
      type: event
    }, payload);
  }
  return event;
}
function toSCXMLEvent(event, scxmlEvent) {
  if (!isString$3(event) && "$$type" in event && event.$$type === "scxml") {
    return event;
  }
  var eventObject = toEventObject(event);
  return __assign$1({
    name: eventObject.type,
    data: eventObject,
    $$type: "scxml",
    type: "external"
  }, scxmlEvent);
}
function toTransitionConfigArray(event, configLike) {
  var transitions = toArrayStrict(configLike).map(function(transitionLike) {
    if (typeof transitionLike === "undefined" || typeof transitionLike === "string" || isMachine(transitionLike)) {
      return {
        target: transitionLike,
        event
      };
    }
    return __assign$1(__assign$1({}, transitionLike), {
      event
    });
  });
  return transitions;
}
function normalizeTarget(target) {
  if (target === void 0 || target === TARGETLESS_KEY) {
    return void 0;
  }
  return toArray(target);
}
function evaluateGuard(machine, guard, context, _event, state) {
  var guards = machine.options.guards;
  var guardMeta = {
    state,
    cond: guard,
    _event
  };
  if (guard.type === DEFAULT_GUARD_TYPE) {
    return ((guards === null || guards === void 0 ? void 0 : guards[guard.name]) || guard.predicate)(context, _event.data, guardMeta);
  }
  var condFn = guards === null || guards === void 0 ? void 0 : guards[guard.type];
  if (!condFn) {
    throw new Error("Guard '".concat(guard.type, "' is not implemented on machine '").concat(machine.id, "'."));
  }
  return condFn(context, _event.data, guardMeta);
}
function toInvokeSource$1(src) {
  if (typeof src === "string") {
    return {
      type: src
    };
  }
  return src;
}
function toObserver$1(nextHandler, errorHandler, completionHandler) {
  if (typeof nextHandler === "object") {
    return nextHandler;
  }
  var noop = function() {
    return void 0;
  };
  return {
    next: nextHandler,
    error: errorHandler || noop,
    complete: completionHandler || noop
  };
}
function createInvokeId(stateNodeId, index2) {
  return "".concat(stateNodeId, ":invocation[").concat(index2, "]");
}
var initEvent = /* @__PURE__ */ toSCXMLEvent({
  type: init$1
});
function getActionFunction(actionType, actionFunctionMap) {
  return actionFunctionMap ? actionFunctionMap[actionType] || void 0 : void 0;
}
function toActionObject(action, actionFunctionMap) {
  var actionObject;
  if (isString$3(action) || typeof action === "number") {
    var exec = getActionFunction(action, actionFunctionMap);
    if (isFunction$3(exec)) {
      actionObject = {
        type: action,
        exec
      };
    } else if (exec) {
      actionObject = exec;
    } else {
      actionObject = {
        type: action,
        exec: void 0
      };
    }
  } else if (isFunction$3(action)) {
    actionObject = {
      type: action.name || action.toString(),
      exec: action
    };
  } else {
    var exec = getActionFunction(action.type, actionFunctionMap);
    if (isFunction$3(exec)) {
      actionObject = __assign$1(__assign$1({}, action), {
        exec
      });
    } else if (exec) {
      var actionType = exec.type || action.type;
      actionObject = __assign$1(__assign$1(__assign$1({}, exec), action), {
        type: actionType
      });
    } else {
      actionObject = action;
    }
  }
  return actionObject;
}
var toActionObjects = function(action, actionFunctionMap) {
  if (!action) {
    return [];
  }
  var actions = isArray$3(action) ? action : [action];
  return actions.map(function(subAction) {
    return toActionObject(subAction, actionFunctionMap);
  });
};
function toActivityDefinition(action) {
  var actionObject = toActionObject(action);
  return __assign$1(__assign$1({
    id: isString$3(action) ? action : actionObject.id
  }, actionObject), {
    type: actionObject.type
  });
}
function raise(event) {
  if (!isString$3(event)) {
    return send$1(event, {
      to: SpecialTargets.Internal
    });
  }
  return {
    type: raise$1,
    event
  };
}
function resolveRaise(action) {
  return {
    type: raise$1,
    _event: toSCXMLEvent(action.event)
  };
}
function send$1(event, options) {
  return {
    to: options ? options.to : void 0,
    type: send$2,
    event: isFunction$3(event) ? event : toEventObject(event),
    delay: options ? options.delay : void 0,
    id: options && options.id !== void 0 ? options.id : isFunction$3(event) ? event.name : getEventType(event)
  };
}
function resolveSend(action, ctx, _event, delaysMap) {
  var meta = {
    _event
  };
  var resolvedEvent = toSCXMLEvent(isFunction$3(action.event) ? action.event(ctx, _event.data, meta) : action.event);
  var resolvedDelay;
  if (isString$3(action.delay)) {
    var configDelay = delaysMap && delaysMap[action.delay];
    resolvedDelay = isFunction$3(configDelay) ? configDelay(ctx, _event.data, meta) : configDelay;
  } else {
    resolvedDelay = isFunction$3(action.delay) ? action.delay(ctx, _event.data, meta) : action.delay;
  }
  var resolvedTarget = isFunction$3(action.to) ? action.to(ctx, _event.data, meta) : action.to;
  return __assign$1(__assign$1({}, action), {
    to: resolvedTarget,
    _event: resolvedEvent,
    event: resolvedEvent.data,
    delay: resolvedDelay
  });
}
var resolveLog = function(action, ctx, _event) {
  return __assign$1(__assign$1({}, action), {
    value: isString$3(action.expr) ? action.expr : action.expr(ctx, _event.data, {
      _event
    })
  });
};
var cancel = function(sendId) {
  return {
    type: cancel$1,
    sendId
  };
};
function start(activity) {
  var activityDef = toActivityDefinition(activity);
  return {
    type: ActionTypes.Start,
    activity: activityDef,
    exec: void 0
  };
}
function stop(actorRef) {
  var activity = isFunction$3(actorRef) ? actorRef : toActivityDefinition(actorRef);
  return {
    type: ActionTypes.Stop,
    activity,
    exec: void 0
  };
}
function resolveStop(action, context, _event) {
  var actorRefOrString = isFunction$3(action.activity) ? action.activity(context, _event.data) : action.activity;
  var resolvedActorRef = typeof actorRefOrString === "string" ? {
    id: actorRefOrString
  } : actorRefOrString;
  var actionObject = {
    type: ActionTypes.Stop,
    activity: resolvedActorRef
  };
  return actionObject;
}
var assign$2 = function(assignment) {
  return {
    type: assign$3,
    assignment
  };
};
function after(delayRef, id) {
  var idSuffix = id ? "#".concat(id) : "";
  return "".concat(ActionTypes.After, "(").concat(delayRef, ")").concat(idSuffix);
}
function done(id, data2) {
  var type2 = "".concat(ActionTypes.DoneState, ".").concat(id);
  var eventObject = {
    type: type2,
    data: data2
  };
  eventObject.toString = function() {
    return type2;
  };
  return eventObject;
}
function doneInvoke(id, data2) {
  var type2 = "".concat(ActionTypes.DoneInvoke, ".").concat(id);
  var eventObject = {
    type: type2,
    data: data2
  };
  eventObject.toString = function() {
    return type2;
  };
  return eventObject;
}
function error(id, data2) {
  var type2 = "".concat(ActionTypes.ErrorPlatform, ".").concat(id);
  var eventObject = {
    type: type2,
    data: data2
  };
  eventObject.toString = function() {
    return type2;
  };
  return eventObject;
}
function resolveActions(machine, currentState, currentContext, _event, actions, preserveActionOrder) {
  if (preserveActionOrder === void 0) {
    preserveActionOrder = false;
  }
  var _a2 = __read$4(preserveActionOrder ? [[], actions] : partition$1(actions, function(action) {
    return action.type === assign$3;
  }), 2), assignActions = _a2[0], otherActions = _a2[1];
  var updatedContext = assignActions.length ? updateContext(currentContext, _event, assignActions, currentState) : currentContext;
  var preservedContexts = preserveActionOrder ? [currentContext] : void 0;
  var resolvedActions = flatten(otherActions.map(function(actionObject) {
    var _a3;
    switch (actionObject.type) {
      case raise$1:
        return resolveRaise(actionObject);
      case send$2:
        var sendAction = resolveSend(actionObject, updatedContext, _event, machine.options.delays);
        return sendAction;
      case log:
        return resolveLog(actionObject, updatedContext, _event);
      case choose: {
        var chooseAction = actionObject;
        var matchedActions = (_a3 = chooseAction.conds.find(function(condition) {
          var guard = toGuard(condition.cond, machine.options.guards);
          return !guard || evaluateGuard(machine, guard, updatedContext, _event, currentState);
        })) === null || _a3 === void 0 ? void 0 : _a3.actions;
        if (!matchedActions) {
          return [];
        }
        var _b = __read$4(resolveActions(machine, currentState, updatedContext, _event, toActionObjects(toArray(matchedActions), machine.options.actions), preserveActionOrder), 2), resolvedActionsFromChoose = _b[0], resolvedContextFromChoose = _b[1];
        updatedContext = resolvedContextFromChoose;
        preservedContexts === null || preservedContexts === void 0 ? void 0 : preservedContexts.push(updatedContext);
        return resolvedActionsFromChoose;
      }
      case pure: {
        var matchedActions = actionObject.get(updatedContext, _event.data);
        if (!matchedActions) {
          return [];
        }
        var _c = __read$4(resolveActions(machine, currentState, updatedContext, _event, toActionObjects(toArray(matchedActions), machine.options.actions), preserveActionOrder), 2), resolvedActionsFromPure = _c[0], resolvedContext = _c[1];
        updatedContext = resolvedContext;
        preservedContexts === null || preservedContexts === void 0 ? void 0 : preservedContexts.push(updatedContext);
        return resolvedActionsFromPure;
      }
      case stop$1: {
        return resolveStop(actionObject, updatedContext, _event);
      }
      case assign$3: {
        updatedContext = updateContext(updatedContext, _event, [actionObject], currentState);
        preservedContexts === null || preservedContexts === void 0 ? void 0 : preservedContexts.push(updatedContext);
        break;
      }
      default:
        var resolvedActionObject = toActionObject(actionObject, machine.options.actions);
        var exec_1 = resolvedActionObject.exec;
        if (exec_1 && preservedContexts) {
          var contextIndex_1 = preservedContexts.length - 1;
          resolvedActionObject = __assign$1(__assign$1({}, resolvedActionObject), {
            exec: function(_ctx) {
              var args = [];
              for (var _i = 1; _i < arguments.length; _i++) {
                args[_i - 1] = arguments[_i];
              }
              exec_1.apply(void 0, __spreadArray$1([preservedContexts[contextIndex_1]], __read$4(args), false));
            }
          });
        }
        return resolvedActionObject;
    }
  }).filter(function(a2) {
    return !!a2;
  }));
  return [resolvedActions, updatedContext];
}
var provide = function(service, fn2) {
  var result = fn2(service);
  return result;
};
function createNullActor(id) {
  var _a2;
  return _a2 = {
    id,
    send: function() {
      return void 0;
    },
    subscribe: function() {
      return {
        unsubscribe: function() {
          return void 0;
        }
      };
    },
    getSnapshot: function() {
      return void 0;
    },
    toJSON: function() {
      return {
        id
      };
    }
  }, _a2[symbolObservable] = function() {
    return this;
  }, _a2;
}
function createInvocableActor(invokeDefinition, machine, context, _event) {
  var _a2;
  var invokeSrc = toInvokeSource$1(invokeDefinition.src);
  var serviceCreator = (_a2 = machine === null || machine === void 0 ? void 0 : machine.options.services) === null || _a2 === void 0 ? void 0 : _a2[invokeSrc.type];
  var resolvedData = invokeDefinition.data ? mapContext(invokeDefinition.data, context, _event) : void 0;
  var tempActor = serviceCreator ? createDeferredActor(serviceCreator, invokeDefinition.id, resolvedData) : createNullActor(invokeDefinition.id);
  tempActor.meta = invokeDefinition;
  return tempActor;
}
function createDeferredActor(entity, id, data2) {
  var tempActor = createNullActor(id);
  tempActor.deferred = true;
  if (isMachine(entity)) {
    var initialState_1 = tempActor.state = provide(void 0, function() {
      return (data2 ? entity.withContext(data2) : entity).initialState;
    });
    tempActor.getSnapshot = function() {
      return initialState_1;
    };
  }
  return tempActor;
}
function isActor(item) {
  try {
    return typeof item.send === "function";
  } catch (e2) {
    return false;
  }
}
function isSpawnedActor(item) {
  return isActor(item) && "id" in item;
}
function toActorRef(actorRefLike) {
  var _a2;
  return __assign$1((_a2 = {
    subscribe: function() {
      return {
        unsubscribe: function() {
          return void 0;
        }
      };
    },
    id: "anonymous",
    getSnapshot: function() {
      return void 0;
    }
  }, _a2[symbolObservable] = function() {
    return this;
  }, _a2), actorRefLike);
}
var isLeafNode = function(stateNode) {
  return stateNode.type === "atomic" || stateNode.type === "final";
};
function getChildren(stateNode) {
  return Object.keys(stateNode.states).map(function(key) {
    return stateNode.states[key];
  });
}
function getAllStateNodes(stateNode) {
  var stateNodes = [stateNode];
  if (isLeafNode(stateNode)) {
    return stateNodes;
  }
  return stateNodes.concat(flatten(getChildren(stateNode).map(getAllStateNodes)));
}
function getConfiguration(prevStateNodes, stateNodes) {
  var e_1, _a2, e_2, _b, e_3, _c, e_4, _d;
  var prevConfiguration = new Set(prevStateNodes);
  var prevAdjList = getAdjList(prevConfiguration);
  var configuration = new Set(stateNodes);
  try {
    for (var configuration_1 = __values$1(configuration), configuration_1_1 = configuration_1.next(); !configuration_1_1.done; configuration_1_1 = configuration_1.next()) {
      var s2 = configuration_1_1.value;
      var m2 = s2.parent;
      while (m2 && !configuration.has(m2)) {
        configuration.add(m2);
        m2 = m2.parent;
      }
    }
  } catch (e_1_1) {
    e_1 = {
      error: e_1_1
    };
  } finally {
    try {
      if (configuration_1_1 && !configuration_1_1.done && (_a2 = configuration_1.return))
        _a2.call(configuration_1);
    } finally {
      if (e_1)
        throw e_1.error;
    }
  }
  var adjList = getAdjList(configuration);
  try {
    for (var configuration_2 = __values$1(configuration), configuration_2_1 = configuration_2.next(); !configuration_2_1.done; configuration_2_1 = configuration_2.next()) {
      var s2 = configuration_2_1.value;
      if (s2.type === "compound" && (!adjList.get(s2) || !adjList.get(s2).length)) {
        if (prevAdjList.get(s2)) {
          prevAdjList.get(s2).forEach(function(sn) {
            return configuration.add(sn);
          });
        } else {
          s2.initialStateNodes.forEach(function(sn) {
            return configuration.add(sn);
          });
        }
      } else {
        if (s2.type === "parallel") {
          try {
            for (var _e = (e_3 = void 0, __values$1(getChildren(s2))), _f = _e.next(); !_f.done; _f = _e.next()) {
              var child = _f.value;
              if (child.type === "history") {
                continue;
              }
              if (!configuration.has(child)) {
                configuration.add(child);
                if (prevAdjList.get(child)) {
                  prevAdjList.get(child).forEach(function(sn) {
                    return configuration.add(sn);
                  });
                } else {
                  child.initialStateNodes.forEach(function(sn) {
                    return configuration.add(sn);
                  });
                }
              }
            }
          } catch (e_3_1) {
            e_3 = {
              error: e_3_1
            };
          } finally {
            try {
              if (_f && !_f.done && (_c = _e.return))
                _c.call(_e);
            } finally {
              if (e_3)
                throw e_3.error;
            }
          }
        }
      }
    }
  } catch (e_2_1) {
    e_2 = {
      error: e_2_1
    };
  } finally {
    try {
      if (configuration_2_1 && !configuration_2_1.done && (_b = configuration_2.return))
        _b.call(configuration_2);
    } finally {
      if (e_2)
        throw e_2.error;
    }
  }
  try {
    for (var configuration_3 = __values$1(configuration), configuration_3_1 = configuration_3.next(); !configuration_3_1.done; configuration_3_1 = configuration_3.next()) {
      var s2 = configuration_3_1.value;
      var m2 = s2.parent;
      while (m2 && !configuration.has(m2)) {
        configuration.add(m2);
        m2 = m2.parent;
      }
    }
  } catch (e_4_1) {
    e_4 = {
      error: e_4_1
    };
  } finally {
    try {
      if (configuration_3_1 && !configuration_3_1.done && (_d = configuration_3.return))
        _d.call(configuration_3);
    } finally {
      if (e_4)
        throw e_4.error;
    }
  }
  return configuration;
}
function getValueFromAdj(baseNode, adjList) {
  var childStateNodes = adjList.get(baseNode);
  if (!childStateNodes) {
    return {};
  }
  if (baseNode.type === "compound") {
    var childStateNode = childStateNodes[0];
    if (childStateNode) {
      if (isLeafNode(childStateNode)) {
        return childStateNode.key;
      }
    } else {
      return {};
    }
  }
  var stateValue = {};
  childStateNodes.forEach(function(csn) {
    stateValue[csn.key] = getValueFromAdj(csn, adjList);
  });
  return stateValue;
}
function getAdjList(configuration) {
  var e_5, _a2;
  var adjList = /* @__PURE__ */ new Map();
  try {
    for (var configuration_4 = __values$1(configuration), configuration_4_1 = configuration_4.next(); !configuration_4_1.done; configuration_4_1 = configuration_4.next()) {
      var s2 = configuration_4_1.value;
      if (!adjList.has(s2)) {
        adjList.set(s2, []);
      }
      if (s2.parent) {
        if (!adjList.has(s2.parent)) {
          adjList.set(s2.parent, []);
        }
        adjList.get(s2.parent).push(s2);
      }
    }
  } catch (e_5_1) {
    e_5 = {
      error: e_5_1
    };
  } finally {
    try {
      if (configuration_4_1 && !configuration_4_1.done && (_a2 = configuration_4.return))
        _a2.call(configuration_4);
    } finally {
      if (e_5)
        throw e_5.error;
    }
  }
  return adjList;
}
function getValue(rootNode, configuration) {
  var config = getConfiguration([rootNode], configuration);
  return getValueFromAdj(rootNode, getAdjList(config));
}
function has(iterable, item) {
  if (Array.isArray(iterable)) {
    return iterable.some(function(member) {
      return member === item;
    });
  }
  if (iterable instanceof Set) {
    return iterable.has(item);
  }
  return false;
}
function nextEvents(configuration) {
  return __spreadArray$1([], __read$4(new Set(flatten(__spreadArray$1([], __read$4(configuration.map(function(sn) {
    return sn.ownEvents;
  })), false)))), false);
}
function isInFinalState(configuration, stateNode) {
  if (stateNode.type === "compound") {
    return getChildren(stateNode).some(function(s2) {
      return s2.type === "final" && has(configuration, s2);
    });
  }
  if (stateNode.type === "parallel") {
    return getChildren(stateNode).every(function(sn) {
      return isInFinalState(configuration, sn);
    });
  }
  return false;
}
function getMeta(configuration) {
  if (configuration === void 0) {
    configuration = [];
  }
  return configuration.reduce(function(acc, stateNode) {
    if (stateNode.meta !== void 0) {
      acc[stateNode.id] = stateNode.meta;
    }
    return acc;
  }, {});
}
function getTagsFromConfiguration(configuration) {
  return new Set(flatten(configuration.map(function(sn) {
    return sn.tags;
  })));
}
function stateValuesEqual(a2, b2) {
  if (a2 === b2) {
    return true;
  }
  if (a2 === void 0 || b2 === void 0) {
    return false;
  }
  if (isString$3(a2) || isString$3(b2)) {
    return a2 === b2;
  }
  var aKeys = Object.keys(a2);
  var bKeys = Object.keys(b2);
  return aKeys.length === bKeys.length && aKeys.every(function(key) {
    return stateValuesEqual(a2[key], b2[key]);
  });
}
function isStateConfig(state) {
  if (typeof state !== "object" || state === null) {
    return false;
  }
  return "value" in state && "_event" in state;
}
function bindActionToState(action, state) {
  var exec = action.exec;
  var boundAction = __assign$1(__assign$1({}, action), {
    exec: exec !== void 0 ? function() {
      return exec(state.context, state.event, {
        action,
        state,
        _event: state._event
      });
    } : void 0
  });
  return boundAction;
}
var State = /* @__PURE__ */ function() {
  function State2(config) {
    var _this = this;
    var _a2;
    this.actions = [];
    this.activities = EMPTY_ACTIVITY_MAP;
    this.meta = {};
    this.events = [];
    this.value = config.value;
    this.context = config.context;
    this._event = config._event;
    this._sessionid = config._sessionid;
    this.event = this._event.data;
    this.historyValue = config.historyValue;
    this.history = config.history;
    this.actions = config.actions || [];
    this.activities = config.activities || EMPTY_ACTIVITY_MAP;
    this.meta = getMeta(config.configuration);
    this.events = config.events || [];
    this.matches = this.matches.bind(this);
    this.toStrings = this.toStrings.bind(this);
    this.configuration = config.configuration;
    this.transitions = config.transitions;
    this.children = config.children;
    this.done = !!config.done;
    this.tags = (_a2 = Array.isArray(config.tags) ? new Set(config.tags) : config.tags) !== null && _a2 !== void 0 ? _a2 : /* @__PURE__ */ new Set();
    this.machine = config.machine;
    Object.defineProperty(this, "nextEvents", {
      get: function() {
        return nextEvents(_this.configuration);
      }
    });
  }
  State2.from = function(stateValue, context) {
    if (stateValue instanceof State2) {
      if (stateValue.context !== context) {
        return new State2({
          value: stateValue.value,
          context,
          _event: stateValue._event,
          _sessionid: null,
          historyValue: stateValue.historyValue,
          history: stateValue.history,
          actions: [],
          activities: stateValue.activities,
          meta: {},
          events: [],
          configuration: [],
          transitions: [],
          children: {}
        });
      }
      return stateValue;
    }
    var _event = initEvent;
    return new State2({
      value: stateValue,
      context,
      _event,
      _sessionid: null,
      historyValue: void 0,
      history: void 0,
      actions: [],
      activities: void 0,
      meta: void 0,
      events: [],
      configuration: [],
      transitions: [],
      children: {}
    });
  };
  State2.create = function(config) {
    return new State2(config);
  };
  State2.inert = function(stateValue, context) {
    if (stateValue instanceof State2) {
      if (!stateValue.actions.length) {
        return stateValue;
      }
      var _event = initEvent;
      return new State2({
        value: stateValue.value,
        context,
        _event,
        _sessionid: null,
        historyValue: stateValue.historyValue,
        history: stateValue.history,
        activities: stateValue.activities,
        configuration: stateValue.configuration,
        transitions: [],
        children: {}
      });
    }
    return State2.from(stateValue, context);
  };
  State2.prototype.toStrings = function(stateValue, delimiter) {
    var _this = this;
    if (stateValue === void 0) {
      stateValue = this.value;
    }
    if (delimiter === void 0) {
      delimiter = ".";
    }
    if (isString$3(stateValue)) {
      return [stateValue];
    }
    var valueKeys = Object.keys(stateValue);
    return valueKeys.concat.apply(valueKeys, __spreadArray$1([], __read$4(valueKeys.map(function(key) {
      return _this.toStrings(stateValue[key], delimiter).map(function(s2) {
        return key + delimiter + s2;
      });
    })), false));
  };
  State2.prototype.toJSON = function() {
    var _a2 = this;
    _a2.configuration;
    _a2.transitions;
    var tags = _a2.tags;
    _a2.machine;
    var jsonValues = __rest$1(_a2, ["configuration", "transitions", "tags", "machine"]);
    return __assign$1(__assign$1({}, jsonValues), {
      tags: Array.from(tags)
    });
  };
  State2.prototype.matches = function(parentStateValue) {
    return matchesState(parentStateValue, this.value);
  };
  State2.prototype.hasTag = function(tag) {
    return this.tags.has(tag);
  };
  State2.prototype.can = function(event) {
    var _a2;
    {
      warn(!!this.machine);
    }
    var transitionData = (_a2 = this.machine) === null || _a2 === void 0 ? void 0 : _a2.getTransitionData(this, event);
    return !!(transitionData === null || transitionData === void 0 ? void 0 : transitionData.transitions.length) && transitionData.transitions.some(function(t2) {
      return t2.target !== void 0 || t2.actions.length;
    });
  };
  return State2;
}();
var defaultOptions = {
  deferEvents: false
};
var Scheduler = /* @__PURE__ */ function() {
  function Scheduler2(options) {
    this.processingEvent = false;
    this.queue = [];
    this.initialized = false;
    this.options = __assign$1(__assign$1({}, defaultOptions), options);
  }
  Scheduler2.prototype.initialize = function(callback) {
    this.initialized = true;
    if (callback) {
      if (!this.options.deferEvents) {
        this.schedule(callback);
        return;
      }
      this.process(callback);
    }
    this.flushEvents();
  };
  Scheduler2.prototype.schedule = function(task) {
    if (!this.initialized || this.processingEvent) {
      this.queue.push(task);
      return;
    }
    if (this.queue.length !== 0) {
      throw new Error("Event queue should be empty when it is not processing events");
    }
    this.process(task);
    this.flushEvents();
  };
  Scheduler2.prototype.clear = function() {
    this.queue = [];
  };
  Scheduler2.prototype.flushEvents = function() {
    var nextCallback = this.queue.shift();
    while (nextCallback) {
      this.process(nextCallback);
      nextCallback = this.queue.shift();
    }
  };
  Scheduler2.prototype.process = function(callback) {
    this.processingEvent = true;
    try {
      callback();
    } catch (e2) {
      this.clear();
      throw e2;
    } finally {
      this.processingEvent = false;
    }
  };
  return Scheduler2;
}();
var children = /* @__PURE__ */ new Map();
var sessionIdIndex = 0;
var registry = {
  bookId: function() {
    return "x:".concat(sessionIdIndex++);
  },
  register: function(id, actor) {
    children.set(id, actor);
    return id;
  },
  get: function(id) {
    return children.get(id);
  },
  free: function(id) {
    children.delete(id);
  }
};
function getGlobal() {
  if (typeof globalThis !== "undefined") {
    return globalThis;
  }
  if (typeof self !== "undefined") {
    return self;
  }
  if (typeof window !== "undefined") {
    return window;
  }
  if (typeof global !== "undefined") {
    return global;
  }
}
function getDevTools() {
  var global2 = getGlobal();
  if (global2 && "__xstate__" in global2) {
    return global2.__xstate__;
  }
  return void 0;
}
function registerService(service) {
  if (!getGlobal()) {
    return;
  }
  var devTools = getDevTools();
  if (devTools) {
    devTools.register(service);
  }
}
function spawnBehavior(behavior, options) {
  if (options === void 0) {
    options = {};
  }
  var state = behavior.initialState;
  var observers = /* @__PURE__ */ new Set();
  var mailbox = [];
  var flushing = false;
  var flush = function() {
    if (flushing) {
      return;
    }
    flushing = true;
    while (mailbox.length > 0) {
      var event_1 = mailbox.shift();
      state = behavior.transition(state, event_1, actorCtx);
      observers.forEach(function(observer) {
        return observer.next(state);
      });
    }
    flushing = false;
  };
  var actor = toActorRef({
    id: options.id,
    send: function(event) {
      mailbox.push(event);
      flush();
    },
    getSnapshot: function() {
      return state;
    },
    subscribe: function(next, handleError, complete) {
      var observer = toObserver$1(next, handleError, complete);
      observers.add(observer);
      observer.next(state);
      return {
        unsubscribe: function() {
          observers.delete(observer);
        }
      };
    }
  });
  var actorCtx = {
    parent: options.parent,
    self: actor,
    id: options.id || "anonymous",
    observers
  };
  state = behavior.start ? behavior.start(actorCtx) : state;
  return actor;
}
var DEFAULT_SPAWN_OPTIONS = {
  sync: false,
  autoForward: false
};
var InterpreterStatus;
(function(InterpreterStatus2) {
  InterpreterStatus2[InterpreterStatus2["NotStarted"] = 0] = "NotStarted";
  InterpreterStatus2[InterpreterStatus2["Running"] = 1] = "Running";
  InterpreterStatus2[InterpreterStatus2["Stopped"] = 2] = "Stopped";
})(InterpreterStatus || (InterpreterStatus = {}));
var Interpreter = /* @__PURE__ */ function() {
  function Interpreter2(machine, options) {
    var _this = this;
    if (options === void 0) {
      options = Interpreter2.defaultOptions;
    }
    this.machine = machine;
    this.scheduler = new Scheduler();
    this.delayedEventsMap = {};
    this.listeners = /* @__PURE__ */ new Set();
    this.contextListeners = /* @__PURE__ */ new Set();
    this.stopListeners = /* @__PURE__ */ new Set();
    this.doneListeners = /* @__PURE__ */ new Set();
    this.eventListeners = /* @__PURE__ */ new Set();
    this.sendListeners = /* @__PURE__ */ new Set();
    this.initialized = false;
    this.status = InterpreterStatus.NotStarted;
    this.children = /* @__PURE__ */ new Map();
    this.forwardTo = /* @__PURE__ */ new Set();
    this.init = this.start;
    this.send = function(event, payload) {
      if (isArray$3(event)) {
        _this.batch(event);
        return _this.state;
      }
      var _event = toSCXMLEvent(toEventObject(event, payload));
      if (_this.status === InterpreterStatus.Stopped) {
        return _this.state;
      }
      if (_this.status !== InterpreterStatus.Running && !_this.options.deferEvents) {
        throw new Error('Event "'.concat(_event.name, '" was sent to uninitialized service "').concat(_this.machine.id, '". Make sure .start() is called for this service, or set { deferEvents: true } in the service options.\nEvent: ').concat(JSON.stringify(_event.data)));
      }
      _this.scheduler.schedule(function() {
        _this.forward(_event);
        var nextState = _this.nextState(_event);
        _this.update(nextState, _event);
      });
      return _this._state;
    };
    this.sendTo = function(event, to) {
      var isParent = _this.parent && (to === SpecialTargets.Parent || _this.parent.id === to);
      var target = isParent ? _this.parent : isString$3(to) ? _this.children.get(to) || registry.get(to) : isActor$1(to) ? to : void 0;
      if (!target) {
        if (!isParent) {
          throw new Error("Unable to send event to child '".concat(to, "' from service '").concat(_this.id, "'."));
        }
        return;
      }
      if ("machine" in target) {
        target.send(__assign$1(__assign$1({}, event), {
          name: event.name === error$1 ? "".concat(error(_this.id)) : event.name,
          origin: _this.sessionId
        }));
      } else {
        target.send(event.data);
      }
    };
    var resolvedOptions = __assign$1(__assign$1({}, Interpreter2.defaultOptions), options);
    var clock = resolvedOptions.clock, logger = resolvedOptions.logger, parent = resolvedOptions.parent, id = resolvedOptions.id;
    var resolvedId = id !== void 0 ? id : machine.id;
    this.id = resolvedId;
    this.logger = logger;
    this.clock = clock;
    this.parent = parent;
    this.options = resolvedOptions;
    this.scheduler = new Scheduler({
      deferEvents: this.options.deferEvents
    });
    this.sessionId = registry.bookId();
  }
  Object.defineProperty(Interpreter2.prototype, "initialState", {
    get: function() {
      var _this = this;
      if (this._initialState) {
        return this._initialState;
      }
      return provide(this, function() {
        _this._initialState = _this.machine.initialState;
        return _this._initialState;
      });
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(Interpreter2.prototype, "state", {
    get: function() {
      return this._state;
    },
    enumerable: false,
    configurable: true
  });
  Interpreter2.prototype.execute = function(state, actionsConfig) {
    var e_1, _a2;
    try {
      for (var _b = __values$1(state.actions), _c = _b.next(); !_c.done; _c = _b.next()) {
        var action = _c.value;
        this.exec(action, state, actionsConfig);
      }
    } catch (e_1_1) {
      e_1 = {
        error: e_1_1
      };
    } finally {
      try {
        if (_c && !_c.done && (_a2 = _b.return))
          _a2.call(_b);
      } finally {
        if (e_1)
          throw e_1.error;
      }
    }
  };
  Interpreter2.prototype.update = function(state, _event) {
    var e_2, _a2, e_3, _b, e_4, _c, e_5, _d;
    var _this = this;
    state._sessionid = this.sessionId;
    this._state = state;
    if (this.options.execute) {
      this.execute(this.state);
    }
    this.children.forEach(function(child) {
      _this.state.children[child.id] = child;
    });
    if (this.devTools) {
      this.devTools.send(_event.data, state);
    }
    if (state.event) {
      try {
        for (var _e = __values$1(this.eventListeners), _f = _e.next(); !_f.done; _f = _e.next()) {
          var listener = _f.value;
          listener(state.event);
        }
      } catch (e_2_1) {
        e_2 = {
          error: e_2_1
        };
      } finally {
        try {
          if (_f && !_f.done && (_a2 = _e.return))
            _a2.call(_e);
        } finally {
          if (e_2)
            throw e_2.error;
        }
      }
    }
    try {
      for (var _g = __values$1(this.listeners), _h = _g.next(); !_h.done; _h = _g.next()) {
        var listener = _h.value;
        listener(state, state.event);
      }
    } catch (e_3_1) {
      e_3 = {
        error: e_3_1
      };
    } finally {
      try {
        if (_h && !_h.done && (_b = _g.return))
          _b.call(_g);
      } finally {
        if (e_3)
          throw e_3.error;
      }
    }
    try {
      for (var _j = __values$1(this.contextListeners), _k = _j.next(); !_k.done; _k = _j.next()) {
        var contextListener = _k.value;
        contextListener(this.state.context, this.state.history ? this.state.history.context : void 0);
      }
    } catch (e_4_1) {
      e_4 = {
        error: e_4_1
      };
    } finally {
      try {
        if (_k && !_k.done && (_c = _j.return))
          _c.call(_j);
      } finally {
        if (e_4)
          throw e_4.error;
      }
    }
    var isDone = isInFinalState(state.configuration || [], this.machine);
    if (this.state.configuration && isDone) {
      var finalChildStateNode = state.configuration.find(function(sn) {
        return sn.type === "final" && sn.parent === _this.machine;
      });
      var doneData = finalChildStateNode && finalChildStateNode.doneData ? mapContext(finalChildStateNode.doneData, state.context, _event) : void 0;
      try {
        for (var _l = __values$1(this.doneListeners), _m = _l.next(); !_m.done; _m = _l.next()) {
          var listener = _m.value;
          listener(doneInvoke(this.id, doneData));
        }
      } catch (e_5_1) {
        e_5 = {
          error: e_5_1
        };
      } finally {
        try {
          if (_m && !_m.done && (_d = _l.return))
            _d.call(_l);
        } finally {
          if (e_5)
            throw e_5.error;
        }
      }
      this.stop();
    }
  };
  Interpreter2.prototype.onTransition = function(listener) {
    this.listeners.add(listener);
    if (this.status === InterpreterStatus.Running) {
      listener(this.state, this.state.event);
    }
    return this;
  };
  Interpreter2.prototype.subscribe = function(nextListenerOrObserver, _2, completeListener) {
    var _this = this;
    if (!nextListenerOrObserver) {
      return {
        unsubscribe: function() {
          return void 0;
        }
      };
    }
    var listener;
    var resolvedCompleteListener = completeListener;
    if (typeof nextListenerOrObserver === "function") {
      listener = nextListenerOrObserver;
    } else {
      listener = nextListenerOrObserver.next.bind(nextListenerOrObserver);
      resolvedCompleteListener = nextListenerOrObserver.complete.bind(nextListenerOrObserver);
    }
    this.listeners.add(listener);
    if (this.status === InterpreterStatus.Running) {
      listener(this.state);
    }
    if (resolvedCompleteListener) {
      this.onDone(resolvedCompleteListener);
    }
    return {
      unsubscribe: function() {
        listener && _this.listeners.delete(listener);
        resolvedCompleteListener && _this.doneListeners.delete(resolvedCompleteListener);
      }
    };
  };
  Interpreter2.prototype.onEvent = function(listener) {
    this.eventListeners.add(listener);
    return this;
  };
  Interpreter2.prototype.onSend = function(listener) {
    this.sendListeners.add(listener);
    return this;
  };
  Interpreter2.prototype.onChange = function(listener) {
    this.contextListeners.add(listener);
    return this;
  };
  Interpreter2.prototype.onStop = function(listener) {
    this.stopListeners.add(listener);
    return this;
  };
  Interpreter2.prototype.onDone = function(listener) {
    this.doneListeners.add(listener);
    return this;
  };
  Interpreter2.prototype.off = function(listener) {
    this.listeners.delete(listener);
    this.eventListeners.delete(listener);
    this.sendListeners.delete(listener);
    this.stopListeners.delete(listener);
    this.doneListeners.delete(listener);
    this.contextListeners.delete(listener);
    return this;
  };
  Interpreter2.prototype.start = function(initialState) {
    var _this = this;
    if (this.status === InterpreterStatus.Running) {
      return this;
    }
    this.machine._init();
    registry.register(this.sessionId, this);
    this.initialized = true;
    this.status = InterpreterStatus.Running;
    var resolvedState = initialState === void 0 ? this.initialState : provide(this, function() {
      return isStateConfig(initialState) ? _this.machine.resolveState(initialState) : _this.machine.resolveState(State.from(initialState, _this.machine.context));
    });
    if (this.options.devTools) {
      this.attachDev();
    }
    this.scheduler.initialize(function() {
      _this.update(resolvedState, initEvent);
    });
    return this;
  };
  Interpreter2.prototype.stop = function() {
    var e_6, _a2, e_7, _b, e_8, _c, e_9, _d, e_10, _e;
    var _this = this;
    try {
      for (var _f = __values$1(this.listeners), _g = _f.next(); !_g.done; _g = _f.next()) {
        var listener = _g.value;
        this.listeners.delete(listener);
      }
    } catch (e_6_1) {
      e_6 = {
        error: e_6_1
      };
    } finally {
      try {
        if (_g && !_g.done && (_a2 = _f.return))
          _a2.call(_f);
      } finally {
        if (e_6)
          throw e_6.error;
      }
    }
    try {
      for (var _h = __values$1(this.stopListeners), _j = _h.next(); !_j.done; _j = _h.next()) {
        var listener = _j.value;
        listener();
        this.stopListeners.delete(listener);
      }
    } catch (e_7_1) {
      e_7 = {
        error: e_7_1
      };
    } finally {
      try {
        if (_j && !_j.done && (_b = _h.return))
          _b.call(_h);
      } finally {
        if (e_7)
          throw e_7.error;
      }
    }
    try {
      for (var _k = __values$1(this.contextListeners), _l = _k.next(); !_l.done; _l = _k.next()) {
        var listener = _l.value;
        this.contextListeners.delete(listener);
      }
    } catch (e_8_1) {
      e_8 = {
        error: e_8_1
      };
    } finally {
      try {
        if (_l && !_l.done && (_c = _k.return))
          _c.call(_k);
      } finally {
        if (e_8)
          throw e_8.error;
      }
    }
    try {
      for (var _m = __values$1(this.doneListeners), _o = _m.next(); !_o.done; _o = _m.next()) {
        var listener = _o.value;
        this.doneListeners.delete(listener);
      }
    } catch (e_9_1) {
      e_9 = {
        error: e_9_1
      };
    } finally {
      try {
        if (_o && !_o.done && (_d = _m.return))
          _d.call(_m);
      } finally {
        if (e_9)
          throw e_9.error;
      }
    }
    if (!this.initialized) {
      return this;
    }
    __spreadArray$1([], __read$4(this.state.configuration), false).sort(function(a2, b2) {
      return b2.order - a2.order;
    }).forEach(function(stateNode) {
      var e_11, _a3;
      try {
        for (var _b2 = __values$1(stateNode.definition.exit), _c2 = _b2.next(); !_c2.done; _c2 = _b2.next()) {
          var action = _c2.value;
          _this.exec(action, _this.state);
        }
      } catch (e_11_1) {
        e_11 = {
          error: e_11_1
        };
      } finally {
        try {
          if (_c2 && !_c2.done && (_a3 = _b2.return))
            _a3.call(_b2);
        } finally {
          if (e_11)
            throw e_11.error;
        }
      }
    });
    this.children.forEach(function(child) {
      if (isFunction$3(child.stop)) {
        child.stop();
      }
    });
    try {
      for (var _p = __values$1(Object.keys(this.delayedEventsMap)), _q = _p.next(); !_q.done; _q = _p.next()) {
        var key = _q.value;
        this.clock.clearTimeout(this.delayedEventsMap[key]);
      }
    } catch (e_10_1) {
      e_10 = {
        error: e_10_1
      };
    } finally {
      try {
        if (_q && !_q.done && (_e = _p.return))
          _e.call(_p);
      } finally {
        if (e_10)
          throw e_10.error;
      }
    }
    this.scheduler.clear();
    this.initialized = false;
    this.status = InterpreterStatus.Stopped;
    registry.free(this.sessionId);
    return this;
  };
  Interpreter2.prototype.batch = function(events) {
    var _this = this;
    if (this.status === InterpreterStatus.NotStarted && this.options.deferEvents)
      ;
    else if (this.status !== InterpreterStatus.Running) {
      throw new Error("".concat(events.length, ' event(s) were sent to uninitialized service "').concat(this.machine.id, '". Make sure .start() is called for this service, or set { deferEvents: true } in the service options.'));
    }
    this.scheduler.schedule(function() {
      var e_12, _a2;
      var nextState = _this.state;
      var batchChanged = false;
      var batchedActions = [];
      var _loop_1 = function(event_12) {
        var _event = toSCXMLEvent(event_12);
        _this.forward(_event);
        nextState = provide(_this, function() {
          return _this.machine.transition(nextState, _event);
        });
        batchedActions.push.apply(batchedActions, __spreadArray$1([], __read$4(nextState.actions.map(function(a2) {
          return bindActionToState(a2, nextState);
        })), false));
        batchChanged = batchChanged || !!nextState.changed;
      };
      try {
        for (var events_1 = __values$1(events), events_1_1 = events_1.next(); !events_1_1.done; events_1_1 = events_1.next()) {
          var event_1 = events_1_1.value;
          _loop_1(event_1);
        }
      } catch (e_12_1) {
        e_12 = {
          error: e_12_1
        };
      } finally {
        try {
          if (events_1_1 && !events_1_1.done && (_a2 = events_1.return))
            _a2.call(events_1);
        } finally {
          if (e_12)
            throw e_12.error;
        }
      }
      nextState.changed = batchChanged;
      nextState.actions = batchedActions;
      _this.update(nextState, toSCXMLEvent(events[events.length - 1]));
    });
  };
  Interpreter2.prototype.sender = function(event) {
    return this.send.bind(this, event);
  };
  Interpreter2.prototype.nextState = function(event) {
    var _this = this;
    var _event = toSCXMLEvent(event);
    if (_event.name.indexOf(errorPlatform) === 0 && !this.state.nextEvents.some(function(nextEvent) {
      return nextEvent.indexOf(errorPlatform) === 0;
    })) {
      throw _event.data.data;
    }
    var nextState = provide(this, function() {
      return _this.machine.transition(_this.state, _event);
    });
    return nextState;
  };
  Interpreter2.prototype.forward = function(event) {
    var e_13, _a2;
    try {
      for (var _b = __values$1(this.forwardTo), _c = _b.next(); !_c.done; _c = _b.next()) {
        var id = _c.value;
        var child = this.children.get(id);
        if (!child) {
          throw new Error("Unable to forward event '".concat(event, "' from interpreter '").concat(this.id, "' to nonexistant child '").concat(id, "'."));
        }
        child.send(event);
      }
    } catch (e_13_1) {
      e_13 = {
        error: e_13_1
      };
    } finally {
      try {
        if (_c && !_c.done && (_a2 = _b.return))
          _a2.call(_b);
      } finally {
        if (e_13)
          throw e_13.error;
      }
    }
  };
  Interpreter2.prototype.defer = function(sendAction) {
    var _this = this;
    this.delayedEventsMap[sendAction.id] = this.clock.setTimeout(function() {
      if (sendAction.to) {
        _this.sendTo(sendAction._event, sendAction.to);
      } else {
        _this.send(sendAction._event);
      }
    }, sendAction.delay);
  };
  Interpreter2.prototype.cancel = function(sendId) {
    this.clock.clearTimeout(this.delayedEventsMap[sendId]);
    delete this.delayedEventsMap[sendId];
  };
  Interpreter2.prototype.exec = function(action, state, actionFunctionMap) {
    if (actionFunctionMap === void 0) {
      actionFunctionMap = this.machine.options.actions;
    }
    var context = state.context, _event = state._event;
    var actionOrExec = action.exec || getActionFunction(action.type, actionFunctionMap);
    var exec = isFunction$3(actionOrExec) ? actionOrExec : actionOrExec ? actionOrExec.exec : action.exec;
    if (exec) {
      try {
        return exec(context, _event.data, {
          action,
          state: this.state,
          _event
        });
      } catch (err) {
        if (this.parent) {
          this.parent.send({
            type: "xstate.error",
            data: err
          });
        }
        throw err;
      }
    }
    switch (action.type) {
      case send$2:
        var sendAction = action;
        if (typeof sendAction.delay === "number") {
          this.defer(sendAction);
          return;
        } else {
          if (sendAction.to) {
            this.sendTo(sendAction._event, sendAction.to);
          } else {
            this.send(sendAction._event);
          }
        }
        break;
      case cancel$1:
        this.cancel(action.sendId);
        break;
      case start$1: {
        if (this.status !== InterpreterStatus.Running) {
          return;
        }
        var activity = action.activity;
        if (!this.state.activities[activity.id || activity.type]) {
          break;
        }
        if (activity.type === ActionTypes.Invoke) {
          var invokeSource = toInvokeSource$1(activity.src);
          var serviceCreator = this.machine.options.services ? this.machine.options.services[invokeSource.type] : void 0;
          var id = activity.id, data2 = activity.data;
          var autoForward = "autoForward" in activity ? activity.autoForward : !!activity.forward;
          if (!serviceCreator) {
            return;
          }
          var resolvedData = data2 ? mapContext(data2, context, _event) : void 0;
          if (typeof serviceCreator === "string") {
            return;
          }
          var source4 = isFunction$3(serviceCreator) ? serviceCreator(context, _event.data, {
            data: resolvedData,
            src: invokeSource,
            meta: activity.meta
          }) : serviceCreator;
          if (!source4) {
            return;
          }
          var options = void 0;
          if (isMachine(source4)) {
            source4 = resolvedData ? source4.withContext(resolvedData) : source4;
            options = {
              autoForward
            };
          }
          this.spawn(source4, id, options);
        } else {
          this.spawnActivity(activity);
        }
        break;
      }
      case stop$1: {
        this.stopChild(action.activity.id);
        break;
      }
      case log:
        var label = action.label, value = action.value;
        if (label) {
          this.logger(label, value);
        } else {
          this.logger(value);
        }
        break;
    }
    return void 0;
  };
  Interpreter2.prototype.removeChild = function(childId) {
    var _a2;
    this.children.delete(childId);
    this.forwardTo.delete(childId);
    (_a2 = this.state) === null || _a2 === void 0 ? true : delete _a2.children[childId];
  };
  Interpreter2.prototype.stopChild = function(childId) {
    var child = this.children.get(childId);
    if (!child) {
      return;
    }
    this.removeChild(childId);
    if (isFunction$3(child.stop)) {
      child.stop();
    }
  };
  Interpreter2.prototype.spawn = function(entity, name2, options) {
    if (isPromiseLike(entity)) {
      return this.spawnPromise(Promise.resolve(entity), name2);
    } else if (isFunction$3(entity)) {
      return this.spawnCallback(entity, name2);
    } else if (isSpawnedActor(entity)) {
      return this.spawnActor(entity, name2);
    } else if (isObservable(entity)) {
      return this.spawnObservable(entity, name2);
    } else if (isMachine(entity)) {
      return this.spawnMachine(entity, __assign$1(__assign$1({}, options), {
        id: name2
      }));
    } else if (isBehavior(entity)) {
      return this.spawnBehavior(entity, name2);
    } else {
      throw new Error('Unable to spawn entity "'.concat(name2, '" of type "').concat(typeof entity, '".'));
    }
  };
  Interpreter2.prototype.spawnMachine = function(machine, options) {
    var _this = this;
    if (options === void 0) {
      options = {};
    }
    var childService = new Interpreter2(machine, __assign$1(__assign$1({}, this.options), {
      parent: this,
      id: options.id || machine.id
    }));
    var resolvedOptions = __assign$1(__assign$1({}, DEFAULT_SPAWN_OPTIONS), options);
    if (resolvedOptions.sync) {
      childService.onTransition(function(state) {
        _this.send(update, {
          state,
          id: childService.id
        });
      });
    }
    var actor = childService;
    this.children.set(childService.id, actor);
    if (resolvedOptions.autoForward) {
      this.forwardTo.add(childService.id);
    }
    childService.onDone(function(doneEvent) {
      _this.removeChild(childService.id);
      _this.send(toSCXMLEvent(doneEvent, {
        origin: childService.id
      }));
    }).start();
    return actor;
  };
  Interpreter2.prototype.spawnBehavior = function(behavior, id) {
    var actorRef = spawnBehavior(behavior, {
      id,
      parent: this
    });
    this.children.set(id, actorRef);
    return actorRef;
  };
  Interpreter2.prototype.spawnPromise = function(promise, id) {
    var _a2;
    var _this = this;
    var canceled = false;
    var resolvedData;
    promise.then(function(response) {
      if (!canceled) {
        resolvedData = response;
        _this.removeChild(id);
        _this.send(toSCXMLEvent(doneInvoke(id, response), {
          origin: id
        }));
      }
    }, function(errorData) {
      if (!canceled) {
        _this.removeChild(id);
        var errorEvent = error(id, errorData);
        try {
          _this.send(toSCXMLEvent(errorEvent, {
            origin: id
          }));
        } catch (error2) {
          if (_this.devTools) {
            _this.devTools.send(errorEvent, _this.state);
          }
          if (_this.machine.strict) {
            _this.stop();
          }
        }
      }
    });
    var actor = (_a2 = {
      id,
      send: function() {
        return void 0;
      },
      subscribe: function(next, handleError, complete) {
        var observer = toObserver$1(next, handleError, complete);
        var unsubscribed = false;
        promise.then(function(response) {
          if (unsubscribed) {
            return;
          }
          observer.next(response);
          if (unsubscribed) {
            return;
          }
          observer.complete();
        }, function(err) {
          if (unsubscribed) {
            return;
          }
          observer.error(err);
        });
        return {
          unsubscribe: function() {
            return unsubscribed = true;
          }
        };
      },
      stop: function() {
        canceled = true;
      },
      toJSON: function() {
        return {
          id
        };
      },
      getSnapshot: function() {
        return resolvedData;
      }
    }, _a2[symbolObservable] = function() {
      return this;
    }, _a2);
    this.children.set(id, actor);
    return actor;
  };
  Interpreter2.prototype.spawnCallback = function(callback, id) {
    var _a2;
    var _this = this;
    var canceled = false;
    var receivers = /* @__PURE__ */ new Set();
    var listeners = /* @__PURE__ */ new Set();
    var emitted;
    var receive = function(e2) {
      emitted = e2;
      listeners.forEach(function(listener) {
        return listener(e2);
      });
      if (canceled) {
        return;
      }
      _this.send(toSCXMLEvent(e2, {
        origin: id
      }));
    };
    var callbackStop;
    try {
      callbackStop = callback(receive, function(newListener) {
        receivers.add(newListener);
      });
    } catch (err) {
      this.send(error(id, err));
    }
    if (isPromiseLike(callbackStop)) {
      return this.spawnPromise(callbackStop, id);
    }
    var actor = (_a2 = {
      id,
      send: function(event) {
        return receivers.forEach(function(receiver) {
          return receiver(event);
        });
      },
      subscribe: function(next) {
        var observer = toObserver$1(next);
        listeners.add(observer.next);
        return {
          unsubscribe: function() {
            listeners.delete(observer.next);
          }
        };
      },
      stop: function() {
        canceled = true;
        if (isFunction$3(callbackStop)) {
          callbackStop();
        }
      },
      toJSON: function() {
        return {
          id
        };
      },
      getSnapshot: function() {
        return emitted;
      }
    }, _a2[symbolObservable] = function() {
      return this;
    }, _a2);
    this.children.set(id, actor);
    return actor;
  };
  Interpreter2.prototype.spawnObservable = function(source4, id) {
    var _a2;
    var _this = this;
    var emitted;
    var subscription = source4.subscribe(function(value) {
      emitted = value;
      _this.send(toSCXMLEvent(value, {
        origin: id
      }));
    }, function(err) {
      _this.removeChild(id);
      _this.send(toSCXMLEvent(error(id, err), {
        origin: id
      }));
    }, function() {
      _this.removeChild(id);
      _this.send(toSCXMLEvent(doneInvoke(id), {
        origin: id
      }));
    });
    var actor = (_a2 = {
      id,
      send: function() {
        return void 0;
      },
      subscribe: function(next, handleError, complete) {
        return source4.subscribe(next, handleError, complete);
      },
      stop: function() {
        return subscription.unsubscribe();
      },
      getSnapshot: function() {
        return emitted;
      },
      toJSON: function() {
        return {
          id
        };
      }
    }, _a2[symbolObservable] = function() {
      return this;
    }, _a2);
    this.children.set(id, actor);
    return actor;
  };
  Interpreter2.prototype.spawnActor = function(actor, name2) {
    this.children.set(name2, actor);
    return actor;
  };
  Interpreter2.prototype.spawnActivity = function(activity) {
    var implementation = this.machine.options && this.machine.options.activities ? this.machine.options.activities[activity.type] : void 0;
    if (!implementation) {
      return;
    }
    var dispose = implementation(this.state.context, activity);
    this.spawnEffect(activity.id, dispose);
  };
  Interpreter2.prototype.spawnEffect = function(id, dispose) {
    var _a2;
    this.children.set(id, (_a2 = {
      id,
      send: function() {
        return void 0;
      },
      subscribe: function() {
        return {
          unsubscribe: function() {
            return void 0;
          }
        };
      },
      stop: dispose || void 0,
      getSnapshot: function() {
        return void 0;
      },
      toJSON: function() {
        return {
          id
        };
      }
    }, _a2[symbolObservable] = function() {
      return this;
    }, _a2));
  };
  Interpreter2.prototype.attachDev = function() {
    var global2 = getGlobal();
    if (this.options.devTools && global2) {
      if (global2.__REDUX_DEVTOOLS_EXTENSION__) {
        var devToolsOptions = typeof this.options.devTools === "object" ? this.options.devTools : void 0;
        this.devTools = global2.__REDUX_DEVTOOLS_EXTENSION__.connect(__assign$1(__assign$1({
          name: this.id,
          autoPause: true,
          stateSanitizer: function(state) {
            return {
              value: state.value,
              context: state.context,
              actions: state.actions
            };
          }
        }, devToolsOptions), {
          features: __assign$1({
            jump: false,
            skip: false
          }, devToolsOptions ? devToolsOptions.features : void 0)
        }), this.machine);
        this.devTools.init(this.state);
      }
      registerService(this);
    }
  };
  Interpreter2.prototype.toJSON = function() {
    return {
      id: this.id
    };
  };
  Interpreter2.prototype[symbolObservable] = function() {
    return this;
  };
  Interpreter2.prototype.getSnapshot = function() {
    if (this.status === InterpreterStatus.NotStarted) {
      return this.initialState;
    }
    return this._state;
  };
  Interpreter2.defaultOptions = {
    execute: true,
    deferEvents: true,
    clock: {
      setTimeout: function(fn2, ms) {
        return setTimeout(fn2, ms);
      },
      clearTimeout: function(id) {
        return clearTimeout(id);
      }
    },
    logger: /* @__PURE__ */ console.log.bind(console),
    devTools: false
  };
  Interpreter2.interpret = interpret;
  return Interpreter2;
}();
function interpret(machine, options) {
  var interpreter = new Interpreter(machine, options);
  return interpreter;
}
function toInvokeSource(src) {
  if (typeof src === "string") {
    var simpleSrc = {
      type: src
    };
    simpleSrc.toString = function() {
      return src;
    };
    return simpleSrc;
  }
  return src;
}
function toInvokeDefinition(invokeConfig) {
  return __assign$1(__assign$1({
    type: invoke
  }, invokeConfig), {
    toJSON: function() {
      invokeConfig.onDone;
      invokeConfig.onError;
      var invokeDef = __rest$1(invokeConfig, ["onDone", "onError"]);
      return __assign$1(__assign$1({}, invokeDef), {
        type: invoke,
        src: toInvokeSource(invokeConfig.src)
      });
    }
  });
}
var NULL_EVENT = "";
var STATE_IDENTIFIER = "#";
var WILDCARD = "*";
var EMPTY_OBJECT = {};
var isStateId = function(str) {
  return str[0] === STATE_IDENTIFIER;
};
var createDefaultOptions = function() {
  return {
    actions: {},
    guards: {},
    services: {},
    activities: {},
    delays: {}
  };
};
var validateArrayifiedTransitions = function(stateNode, event, transitions) {
  var hasNonLastUnguardedTarget = transitions.slice(0, -1).some(function(transition) {
    return !("cond" in transition) && !("in" in transition) && (isString$3(transition.target) || isMachine(transition.target));
  });
  var eventText = event === NULL_EVENT ? "the transient event" : "event '".concat(event, "'");
  warn(!hasNonLastUnguardedTarget, "One or more transitions for ".concat(eventText, " on state '").concat(stateNode.id, "' are unreachable. ") + "Make sure that the default transition is the last one defined.");
};
var StateNode = /* @__PURE__ */ function() {
  function StateNode2(config, options, _context, _stateInfo) {
    var _this = this;
    if (_context === void 0) {
      _context = "context" in config ? config.context : void 0;
    }
    var _a2;
    this.config = config;
    this._context = _context;
    this.order = -1;
    this.__xstatenode = true;
    this.__cache = {
      events: void 0,
      relativeValue: /* @__PURE__ */ new Map(),
      initialStateValue: void 0,
      initialState: void 0,
      on: void 0,
      transitions: void 0,
      candidates: {},
      delayedTransitions: void 0
    };
    this.idMap = {};
    this.tags = [];
    this.options = Object.assign(createDefaultOptions(), options);
    this.parent = _stateInfo === null || _stateInfo === void 0 ? void 0 : _stateInfo.parent;
    this.key = this.config.key || (_stateInfo === null || _stateInfo === void 0 ? void 0 : _stateInfo.key) || this.config.id || "(machine)";
    this.machine = this.parent ? this.parent.machine : this;
    this.path = this.parent ? this.parent.path.concat(this.key) : [];
    this.delimiter = this.config.delimiter || (this.parent ? this.parent.delimiter : STATE_DELIMITER);
    this.id = this.config.id || __spreadArray$1([this.machine.key], __read$4(this.path), false).join(this.delimiter);
    this.version = this.parent ? this.parent.version : this.config.version;
    this.type = this.config.type || (this.config.parallel ? "parallel" : this.config.states && Object.keys(this.config.states).length ? "compound" : this.config.history ? "history" : "atomic");
    this.schema = this.parent ? this.machine.schema : (_a2 = this.config.schema) !== null && _a2 !== void 0 ? _a2 : {};
    this.description = this.config.description;
    this.initial = this.config.initial;
    this.states = this.config.states ? mapValues(this.config.states, function(stateConfig, key) {
      var _a3;
      var stateNode = new StateNode2(stateConfig, {}, void 0, {
        parent: _this,
        key
      });
      Object.assign(_this.idMap, __assign$1((_a3 = {}, _a3[stateNode.id] = stateNode, _a3), stateNode.idMap));
      return stateNode;
    }) : EMPTY_OBJECT;
    var order = 0;
    function dfs(stateNode) {
      var e_1, _a3;
      stateNode.order = order++;
      try {
        for (var _b = __values$1(getChildren(stateNode)), _c = _b.next(); !_c.done; _c = _b.next()) {
          var child = _c.value;
          dfs(child);
        }
      } catch (e_1_1) {
        e_1 = {
          error: e_1_1
        };
      } finally {
        try {
          if (_c && !_c.done && (_a3 = _b.return))
            _a3.call(_b);
        } finally {
          if (e_1)
            throw e_1.error;
        }
      }
    }
    dfs(this);
    this.history = this.config.history === true ? "shallow" : this.config.history || false;
    this._transient = !!this.config.always || (!this.config.on ? false : Array.isArray(this.config.on) ? this.config.on.some(function(_a3) {
      var event = _a3.event;
      return event === NULL_EVENT;
    }) : NULL_EVENT in this.config.on);
    this.strict = !!this.config.strict;
    this.onEntry = toArray(this.config.entry || this.config.onEntry).map(function(action) {
      return toActionObject(action);
    });
    this.onExit = toArray(this.config.exit || this.config.onExit).map(function(action) {
      return toActionObject(action);
    });
    this.meta = this.config.meta;
    this.doneData = this.type === "final" ? this.config.data : void 0;
    this.invoke = toArray(this.config.invoke).map(function(invokeConfig, i2) {
      var _a3, _b;
      if (isMachine(invokeConfig)) {
        var invokeId = createInvokeId(_this.id, i2);
        _this.machine.options.services = __assign$1((_a3 = {}, _a3[invokeId] = invokeConfig, _a3), _this.machine.options.services);
        return toInvokeDefinition({
          src: invokeId,
          id: invokeId
        });
      } else if (isString$3(invokeConfig.src)) {
        var invokeId = invokeConfig.id || createInvokeId(_this.id, i2);
        return toInvokeDefinition(__assign$1(__assign$1({}, invokeConfig), {
          id: invokeId,
          src: invokeConfig.src
        }));
      } else if (isMachine(invokeConfig.src) || isFunction$3(invokeConfig.src)) {
        var invokeId = invokeConfig.id || createInvokeId(_this.id, i2);
        _this.machine.options.services = __assign$1((_b = {}, _b[invokeId] = invokeConfig.src, _b), _this.machine.options.services);
        return toInvokeDefinition(__assign$1(__assign$1({
          id: invokeId
        }, invokeConfig), {
          src: invokeId
        }));
      } else {
        var invokeSource = invokeConfig.src;
        return toInvokeDefinition(__assign$1(__assign$1({
          id: createInvokeId(_this.id, i2)
        }, invokeConfig), {
          src: invokeSource
        }));
      }
    });
    this.activities = toArray(this.config.activities).concat(this.invoke).map(function(activity) {
      return toActivityDefinition(activity);
    });
    this.transition = this.transition.bind(this);
    this.tags = toArray(this.config.tags);
  }
  StateNode2.prototype._init = function() {
    if (this.__cache.transitions) {
      return;
    }
    getAllStateNodes(this).forEach(function(stateNode) {
      return stateNode.on;
    });
  };
  StateNode2.prototype.withConfig = function(options, context) {
    var _a2 = this.options, actions = _a2.actions, activities = _a2.activities, guards = _a2.guards, services = _a2.services, delays = _a2.delays;
    return new StateNode2(this.config, {
      actions: __assign$1(__assign$1({}, actions), options.actions),
      activities: __assign$1(__assign$1({}, activities), options.activities),
      guards: __assign$1(__assign$1({}, guards), options.guards),
      services: __assign$1(__assign$1({}, services), options.services),
      delays: __assign$1(__assign$1({}, delays), options.delays)
    }, context !== null && context !== void 0 ? context : this.context);
  };
  StateNode2.prototype.withContext = function(context) {
    return new StateNode2(this.config, this.options, context);
  };
  Object.defineProperty(StateNode2.prototype, "context", {
    get: function() {
      return isFunction$3(this._context) ? this._context() : this._context;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(StateNode2.prototype, "definition", {
    get: function() {
      return {
        id: this.id,
        key: this.key,
        version: this.version,
        context: this.context,
        type: this.type,
        initial: this.initial,
        history: this.history,
        states: mapValues(this.states, function(state) {
          return state.definition;
        }),
        on: this.on,
        transitions: this.transitions,
        entry: this.onEntry,
        exit: this.onExit,
        activities: this.activities || [],
        meta: this.meta,
        order: this.order || -1,
        data: this.doneData,
        invoke: this.invoke,
        description: this.description,
        tags: this.tags
      };
    },
    enumerable: false,
    configurable: true
  });
  StateNode2.prototype.toJSON = function() {
    return this.definition;
  };
  Object.defineProperty(StateNode2.prototype, "on", {
    get: function() {
      if (this.__cache.on) {
        return this.__cache.on;
      }
      var transitions = this.transitions;
      return this.__cache.on = transitions.reduce(function(map, transition) {
        map[transition.eventType] = map[transition.eventType] || [];
        map[transition.eventType].push(transition);
        return map;
      }, {});
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(StateNode2.prototype, "after", {
    get: function() {
      return this.__cache.delayedTransitions || (this.__cache.delayedTransitions = this.getDelayedTransitions(), this.__cache.delayedTransitions);
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(StateNode2.prototype, "transitions", {
    get: function() {
      return this.__cache.transitions || (this.__cache.transitions = this.formatTransitions(), this.__cache.transitions);
    },
    enumerable: false,
    configurable: true
  });
  StateNode2.prototype.getCandidates = function(eventName) {
    if (this.__cache.candidates[eventName]) {
      return this.__cache.candidates[eventName];
    }
    var transient = eventName === NULL_EVENT;
    var candidates = this.transitions.filter(function(transition) {
      var sameEventType = transition.eventType === eventName;
      return transient ? sameEventType : sameEventType || transition.eventType === WILDCARD;
    });
    this.__cache.candidates[eventName] = candidates;
    return candidates;
  };
  StateNode2.prototype.getDelayedTransitions = function() {
    var _this = this;
    var afterConfig = this.config.after;
    if (!afterConfig) {
      return [];
    }
    var mutateEntryExit = function(delay, i2) {
      var delayRef = isFunction$3(delay) ? "".concat(_this.id, ":delay[").concat(i2, "]") : delay;
      var eventType = after(delayRef, _this.id);
      _this.onEntry.push(send$1(eventType, {
        delay
      }));
      _this.onExit.push(cancel(eventType));
      return eventType;
    };
    var delayedTransitions = isArray$3(afterConfig) ? afterConfig.map(function(transition, i2) {
      var eventType = mutateEntryExit(transition.delay, i2);
      return __assign$1(__assign$1({}, transition), {
        event: eventType
      });
    }) : flatten(Object.keys(afterConfig).map(function(delay, i2) {
      var configTransition = afterConfig[delay];
      var resolvedTransition = isString$3(configTransition) ? {
        target: configTransition
      } : configTransition;
      var resolvedDelay = !isNaN(+delay) ? +delay : delay;
      var eventType = mutateEntryExit(resolvedDelay, i2);
      return toArray(resolvedTransition).map(function(transition) {
        return __assign$1(__assign$1({}, transition), {
          event: eventType,
          delay: resolvedDelay
        });
      });
    }));
    return delayedTransitions.map(function(delayedTransition) {
      var delay = delayedTransition.delay;
      return __assign$1(__assign$1({}, _this.formatTransition(delayedTransition)), {
        delay
      });
    });
  };
  StateNode2.prototype.getStateNodes = function(state) {
    var _a2;
    var _this = this;
    if (!state) {
      return [];
    }
    var stateValue = state instanceof State ? state.value : toStateValue(state, this.delimiter);
    if (isString$3(stateValue)) {
      var initialStateValue = this.getStateNode(stateValue).initial;
      return initialStateValue !== void 0 ? this.getStateNodes((_a2 = {}, _a2[stateValue] = initialStateValue, _a2)) : [this, this.states[stateValue]];
    }
    var subStateKeys = Object.keys(stateValue);
    var subStateNodes = [this];
    subStateNodes.push.apply(subStateNodes, __spreadArray$1([], __read$4(flatten(subStateKeys.map(function(subStateKey) {
      return _this.getStateNode(subStateKey).getStateNodes(stateValue[subStateKey]);
    }))), false));
    return subStateNodes;
  };
  StateNode2.prototype.handles = function(event) {
    var eventType = getEventType(event);
    return this.events.includes(eventType);
  };
  StateNode2.prototype.resolveState = function(state) {
    var stateFromConfig = state instanceof State ? state : State.create(state);
    var configuration = Array.from(getConfiguration([], this.getStateNodes(stateFromConfig.value)));
    return new State(__assign$1(__assign$1({}, stateFromConfig), {
      value: this.resolve(stateFromConfig.value),
      configuration,
      done: isInFinalState(configuration, this),
      tags: getTagsFromConfiguration(configuration),
      machine: this.machine
    }));
  };
  StateNode2.prototype.transitionLeafNode = function(stateValue, state, _event) {
    var stateNode = this.getStateNode(stateValue);
    var next = stateNode.next(state, _event);
    if (!next || !next.transitions.length) {
      return this.next(state, _event);
    }
    return next;
  };
  StateNode2.prototype.transitionCompoundNode = function(stateValue, state, _event) {
    var subStateKeys = Object.keys(stateValue);
    var stateNode = this.getStateNode(subStateKeys[0]);
    var next = stateNode._transition(stateValue[subStateKeys[0]], state, _event);
    if (!next || !next.transitions.length) {
      return this.next(state, _event);
    }
    return next;
  };
  StateNode2.prototype.transitionParallelNode = function(stateValue, state, _event) {
    var e_2, _a2;
    var transitionMap = {};
    try {
      for (var _b = __values$1(Object.keys(stateValue)), _c = _b.next(); !_c.done; _c = _b.next()) {
        var subStateKey = _c.value;
        var subStateValue = stateValue[subStateKey];
        if (!subStateValue) {
          continue;
        }
        var subStateNode = this.getStateNode(subStateKey);
        var next = subStateNode._transition(subStateValue, state, _event);
        if (next) {
          transitionMap[subStateKey] = next;
        }
      }
    } catch (e_2_1) {
      e_2 = {
        error: e_2_1
      };
    } finally {
      try {
        if (_c && !_c.done && (_a2 = _b.return))
          _a2.call(_b);
      } finally {
        if (e_2)
          throw e_2.error;
      }
    }
    var stateTransitions = Object.keys(transitionMap).map(function(key) {
      return transitionMap[key];
    });
    var enabledTransitions = flatten(stateTransitions.map(function(st) {
      return st.transitions;
    }));
    var willTransition = stateTransitions.some(function(st) {
      return st.transitions.length > 0;
    });
    if (!willTransition) {
      return this.next(state, _event);
    }
    var entryNodes = flatten(stateTransitions.map(function(t2) {
      return t2.entrySet;
    }));
    var configuration = flatten(Object.keys(transitionMap).map(function(key) {
      return transitionMap[key].configuration;
    }));
    return {
      transitions: enabledTransitions,
      entrySet: entryNodes,
      exitSet: flatten(stateTransitions.map(function(t2) {
        return t2.exitSet;
      })),
      configuration,
      source: state,
      actions: flatten(Object.keys(transitionMap).map(function(key) {
        return transitionMap[key].actions;
      }))
    };
  };
  StateNode2.prototype._transition = function(stateValue, state, _event) {
    if (isString$3(stateValue)) {
      return this.transitionLeafNode(stateValue, state, _event);
    }
    if (Object.keys(stateValue).length === 1) {
      return this.transitionCompoundNode(stateValue, state, _event);
    }
    return this.transitionParallelNode(stateValue, state, _event);
  };
  StateNode2.prototype.getTransitionData = function(state, event) {
    return this._transition(state.value, state, toSCXMLEvent(event));
  };
  StateNode2.prototype.next = function(state, _event) {
    var e_3, _a2;
    var _this = this;
    var eventName = _event.name;
    var actions = [];
    var nextStateNodes = [];
    var selectedTransition;
    try {
      for (var _b = __values$1(this.getCandidates(eventName)), _c = _b.next(); !_c.done; _c = _b.next()) {
        var candidate = _c.value;
        var cond = candidate.cond, stateIn = candidate.in;
        var resolvedContext = state.context;
        var isInState = stateIn ? isString$3(stateIn) && isStateId(stateIn) ? state.matches(toStateValue(this.getStateNodeById(stateIn).path, this.delimiter)) : matchesState(toStateValue(stateIn, this.delimiter), path(this.path.slice(0, -2))(state.value)) : true;
        var guardPassed = false;
        try {
          guardPassed = !cond || evaluateGuard(this.machine, cond, resolvedContext, _event, state);
        } catch (err) {
          throw new Error("Unable to evaluate guard '".concat(cond.name || cond.type, "' in transition for event '").concat(eventName, "' in state node '").concat(this.id, "':\n").concat(err.message));
        }
        if (guardPassed && isInState) {
          if (candidate.target !== void 0) {
            nextStateNodes = candidate.target;
          }
          actions.push.apply(actions, __spreadArray$1([], __read$4(candidate.actions), false));
          selectedTransition = candidate;
          break;
        }
      }
    } catch (e_3_1) {
      e_3 = {
        error: e_3_1
      };
    } finally {
      try {
        if (_c && !_c.done && (_a2 = _b.return))
          _a2.call(_b);
      } finally {
        if (e_3)
          throw e_3.error;
      }
    }
    if (!selectedTransition) {
      return void 0;
    }
    if (!nextStateNodes.length) {
      return {
        transitions: [selectedTransition],
        entrySet: [],
        exitSet: [],
        configuration: state.value ? [this] : [],
        source: state,
        actions
      };
    }
    var allNextStateNodes = flatten(nextStateNodes.map(function(stateNode) {
      return _this.getRelativeStateNodes(stateNode, state.historyValue);
    }));
    var isInternal = !!selectedTransition.internal;
    var reentryNodes = isInternal ? [] : flatten(allNextStateNodes.map(function(n2) {
      return _this.nodesFromChild(n2);
    }));
    return {
      transitions: [selectedTransition],
      entrySet: reentryNodes,
      exitSet: isInternal ? [] : [this],
      configuration: allNextStateNodes,
      source: state,
      actions
    };
  };
  StateNode2.prototype.nodesFromChild = function(childStateNode) {
    if (childStateNode.escapes(this)) {
      return [];
    }
    var nodes = [];
    var marker = childStateNode;
    while (marker && marker !== this) {
      nodes.push(marker);
      marker = marker.parent;
    }
    nodes.push(this);
    return nodes;
  };
  StateNode2.prototype.escapes = function(stateNode) {
    if (this === stateNode) {
      return false;
    }
    var parent = this.parent;
    while (parent) {
      if (parent === stateNode) {
        return false;
      }
      parent = parent.parent;
    }
    return true;
  };
  StateNode2.prototype.getActions = function(transition, currentContext, _event, prevState) {
    var e_4, _a2, e_5, _b;
    var prevConfig = getConfiguration([], prevState ? this.getStateNodes(prevState.value) : [this]);
    var resolvedConfig = transition.configuration.length ? getConfiguration(prevConfig, transition.configuration) : prevConfig;
    try {
      for (var resolvedConfig_1 = __values$1(resolvedConfig), resolvedConfig_1_1 = resolvedConfig_1.next(); !resolvedConfig_1_1.done; resolvedConfig_1_1 = resolvedConfig_1.next()) {
        var sn = resolvedConfig_1_1.value;
        if (!has(prevConfig, sn)) {
          transition.entrySet.push(sn);
        }
      }
    } catch (e_4_1) {
      e_4 = {
        error: e_4_1
      };
    } finally {
      try {
        if (resolvedConfig_1_1 && !resolvedConfig_1_1.done && (_a2 = resolvedConfig_1.return))
          _a2.call(resolvedConfig_1);
      } finally {
        if (e_4)
          throw e_4.error;
      }
    }
    try {
      for (var prevConfig_1 = __values$1(prevConfig), prevConfig_1_1 = prevConfig_1.next(); !prevConfig_1_1.done; prevConfig_1_1 = prevConfig_1.next()) {
        var sn = prevConfig_1_1.value;
        if (!has(resolvedConfig, sn) || has(transition.exitSet, sn.parent)) {
          transition.exitSet.push(sn);
        }
      }
    } catch (e_5_1) {
      e_5 = {
        error: e_5_1
      };
    } finally {
      try {
        if (prevConfig_1_1 && !prevConfig_1_1.done && (_b = prevConfig_1.return))
          _b.call(prevConfig_1);
      } finally {
        if (e_5)
          throw e_5.error;
      }
    }
    var doneEvents = flatten(transition.entrySet.map(function(sn2) {
      var events = [];
      if (sn2.type !== "final") {
        return events;
      }
      var parent = sn2.parent;
      if (!parent.parent) {
        return events;
      }
      events.push(done(sn2.id, sn2.doneData), done(parent.id, sn2.doneData ? mapContext(sn2.doneData, currentContext, _event) : void 0));
      var grandparent = parent.parent;
      if (grandparent.type === "parallel") {
        if (getChildren(grandparent).every(function(parentNode) {
          return isInFinalState(transition.configuration, parentNode);
        })) {
          events.push(done(grandparent.id));
        }
      }
      return events;
    }));
    transition.exitSet.sort(function(a2, b2) {
      return b2.order - a2.order;
    });
    transition.entrySet.sort(function(a2, b2) {
      return a2.order - b2.order;
    });
    var entryStates = new Set(transition.entrySet);
    var exitStates = new Set(transition.exitSet);
    var _c = __read$4([flatten(Array.from(entryStates).map(function(stateNode) {
      return __spreadArray$1(__spreadArray$1([], __read$4(stateNode.activities.map(function(activity) {
        return start(activity);
      })), false), __read$4(stateNode.onEntry), false);
    })).concat(doneEvents.map(raise)), flatten(Array.from(exitStates).map(function(stateNode) {
      return __spreadArray$1(__spreadArray$1([], __read$4(stateNode.onExit), false), __read$4(stateNode.activities.map(function(activity) {
        return stop(activity);
      })), false);
    }))], 2), entryActions = _c[0], exitActions = _c[1];
    var actions = toActionObjects(exitActions.concat(transition.actions).concat(entryActions), this.machine.options.actions);
    return actions;
  };
  StateNode2.prototype.transition = function(state, event, context) {
    if (state === void 0) {
      state = this.initialState;
    }
    var _event = toSCXMLEvent(event);
    var currentState;
    if (state instanceof State) {
      currentState = context === void 0 ? state : this.resolveState(State.from(state, context));
    } else {
      var resolvedStateValue = isString$3(state) ? this.resolve(pathToStateValue(this.getResolvedPath(state))) : this.resolve(state);
      var resolvedContext = context !== null && context !== void 0 ? context : this.machine.context;
      currentState = this.resolveState(State.from(resolvedStateValue, resolvedContext));
    }
    if (!IS_PRODUCTION && _event.name === WILDCARD) {
      throw new Error("An event cannot have the wildcard type ('".concat(WILDCARD, "')"));
    }
    if (this.strict) {
      if (!this.events.includes(_event.name) && !isBuiltInEvent(_event.name)) {
        throw new Error("Machine '".concat(this.id, "' does not accept event '").concat(_event.name, "'"));
      }
    }
    var stateTransition = this._transition(currentState.value, currentState, _event) || {
      transitions: [],
      configuration: [],
      entrySet: [],
      exitSet: [],
      source: currentState,
      actions: []
    };
    var prevConfig = getConfiguration([], this.getStateNodes(currentState.value));
    var resolvedConfig = stateTransition.configuration.length ? getConfiguration(prevConfig, stateTransition.configuration) : prevConfig;
    stateTransition.configuration = __spreadArray$1([], __read$4(resolvedConfig), false);
    return this.resolveTransition(stateTransition, currentState, currentState.context, _event);
  };
  StateNode2.prototype.resolveRaisedTransition = function(state, _event, originalEvent) {
    var _a2;
    var currentActions = state.actions;
    state = this.transition(state, _event);
    state._event = originalEvent;
    state.event = originalEvent.data;
    (_a2 = state.actions).unshift.apply(_a2, __spreadArray$1([], __read$4(currentActions), false));
    return state;
  };
  StateNode2.prototype.resolveTransition = function(stateTransition, currentState, context, _event) {
    var e_6, _a2;
    var _this = this;
    if (_event === void 0) {
      _event = initEvent;
    }
    var configuration = stateTransition.configuration;
    var willTransition = !currentState || stateTransition.transitions.length > 0;
    var resolvedStateValue = willTransition ? getValue(this.machine, configuration) : void 0;
    var historyValue = currentState ? currentState.historyValue ? currentState.historyValue : stateTransition.source ? this.machine.historyValue(currentState.value) : void 0 : void 0;
    var actions = this.getActions(stateTransition, context, _event, currentState);
    var activities = currentState ? __assign$1({}, currentState.activities) : {};
    try {
      for (var actions_1 = __values$1(actions), actions_1_1 = actions_1.next(); !actions_1_1.done; actions_1_1 = actions_1.next()) {
        var action = actions_1_1.value;
        if (action.type === start$1) {
          activities[action.activity.id || action.activity.type] = action;
        } else if (action.type === stop$1) {
          activities[action.activity.id || action.activity.type] = false;
        }
      }
    } catch (e_6_1) {
      e_6 = {
        error: e_6_1
      };
    } finally {
      try {
        if (actions_1_1 && !actions_1_1.done && (_a2 = actions_1.return))
          _a2.call(actions_1);
      } finally {
        if (e_6)
          throw e_6.error;
      }
    }
    var _b = __read$4(resolveActions(this, currentState, context, _event, actions, this.machine.config.preserveActionOrder), 2), resolvedActions = _b[0], updatedContext = _b[1];
    var _c = __read$4(partition$1(resolvedActions, function(action2) {
      return action2.type === raise$1 || action2.type === send$2 && action2.to === SpecialTargets.Internal;
    }), 2), raisedEvents = _c[0], nonRaisedActions = _c[1];
    var invokeActions = resolvedActions.filter(function(action2) {
      var _a3;
      return action2.type === start$1 && ((_a3 = action2.activity) === null || _a3 === void 0 ? void 0 : _a3.type) === invoke;
    });
    var children2 = invokeActions.reduce(function(acc, action2) {
      acc[action2.activity.id] = createInvocableActor(action2.activity, _this.machine, updatedContext, _event);
      return acc;
    }, currentState ? __assign$1({}, currentState.children) : {});
    var resolvedConfiguration = willTransition ? stateTransition.configuration : currentState ? currentState.configuration : [];
    var isDone = isInFinalState(resolvedConfiguration, this);
    var nextState = new State({
      value: resolvedStateValue || currentState.value,
      context: updatedContext,
      _event,
      _sessionid: currentState ? currentState._sessionid : null,
      historyValue: resolvedStateValue ? historyValue ? updateHistoryValue(historyValue, resolvedStateValue) : void 0 : currentState ? currentState.historyValue : void 0,
      history: !resolvedStateValue || stateTransition.source ? currentState : void 0,
      actions: resolvedStateValue ? nonRaisedActions : [],
      activities: resolvedStateValue ? activities : currentState ? currentState.activities : {},
      events: [],
      configuration: resolvedConfiguration,
      transitions: stateTransition.transitions,
      children: children2,
      done: isDone,
      tags: currentState === null || currentState === void 0 ? void 0 : currentState.tags,
      machine: this
    });
    var didUpdateContext = context !== updatedContext;
    nextState.changed = _event.name === update || didUpdateContext;
    var history = nextState.history;
    if (history) {
      delete history.history;
    }
    var isTransient = !isDone && (this._transient || configuration.some(function(stateNode) {
      return stateNode._transient;
    }));
    if (!willTransition && (!isTransient || _event.name === NULL_EVENT)) {
      return nextState;
    }
    var maybeNextState = nextState;
    if (!isDone) {
      if (isTransient) {
        maybeNextState = this.resolveRaisedTransition(maybeNextState, {
          type: nullEvent
        }, _event);
      }
      while (raisedEvents.length) {
        var raisedEvent = raisedEvents.shift();
        maybeNextState = this.resolveRaisedTransition(maybeNextState, raisedEvent._event, _event);
      }
    }
    var changed = maybeNextState.changed || (history ? !!maybeNextState.actions.length || didUpdateContext || typeof history.value !== typeof maybeNextState.value || !stateValuesEqual(maybeNextState.value, history.value) : void 0);
    maybeNextState.changed = changed;
    maybeNextState.history = history;
    maybeNextState.tags = getTagsFromConfiguration(maybeNextState.configuration);
    return maybeNextState;
  };
  StateNode2.prototype.getStateNode = function(stateKey) {
    if (isStateId(stateKey)) {
      return this.machine.getStateNodeById(stateKey);
    }
    if (!this.states) {
      throw new Error("Unable to retrieve child state '".concat(stateKey, "' from '").concat(this.id, "'; no child states exist."));
    }
    var result = this.states[stateKey];
    if (!result) {
      throw new Error("Child state '".concat(stateKey, "' does not exist on '").concat(this.id, "'"));
    }
    return result;
  };
  StateNode2.prototype.getStateNodeById = function(stateId) {
    var resolvedStateId = isStateId(stateId) ? stateId.slice(STATE_IDENTIFIER.length) : stateId;
    if (resolvedStateId === this.id) {
      return this;
    }
    var stateNode = this.machine.idMap[resolvedStateId];
    if (!stateNode) {
      throw new Error("Child state node '#".concat(resolvedStateId, "' does not exist on machine '").concat(this.id, "'"));
    }
    return stateNode;
  };
  StateNode2.prototype.getStateNodeByPath = function(statePath) {
    if (typeof statePath === "string" && isStateId(statePath)) {
      try {
        return this.getStateNodeById(statePath.slice(1));
      } catch (e2) {
      }
    }
    var arrayStatePath = toStatePath(statePath, this.delimiter).slice();
    var currentStateNode = this;
    while (arrayStatePath.length) {
      var key = arrayStatePath.shift();
      if (!key.length) {
        break;
      }
      currentStateNode = currentStateNode.getStateNode(key);
    }
    return currentStateNode;
  };
  StateNode2.prototype.resolve = function(stateValue) {
    var _a2;
    var _this = this;
    if (!stateValue) {
      return this.initialStateValue || EMPTY_OBJECT;
    }
    switch (this.type) {
      case "parallel":
        return mapValues(this.initialStateValue, function(subStateValue, subStateKey) {
          return subStateValue ? _this.getStateNode(subStateKey).resolve(stateValue[subStateKey] || subStateValue) : EMPTY_OBJECT;
        });
      case "compound":
        if (isString$3(stateValue)) {
          var subStateNode = this.getStateNode(stateValue);
          if (subStateNode.type === "parallel" || subStateNode.type === "compound") {
            return _a2 = {}, _a2[stateValue] = subStateNode.initialStateValue, _a2;
          }
          return stateValue;
        }
        if (!Object.keys(stateValue).length) {
          return this.initialStateValue || {};
        }
        return mapValues(stateValue, function(subStateValue, subStateKey) {
          return subStateValue ? _this.getStateNode(subStateKey).resolve(subStateValue) : EMPTY_OBJECT;
        });
      default:
        return stateValue || EMPTY_OBJECT;
    }
  };
  StateNode2.prototype.getResolvedPath = function(stateIdentifier) {
    if (isStateId(stateIdentifier)) {
      var stateNode = this.machine.idMap[stateIdentifier.slice(STATE_IDENTIFIER.length)];
      if (!stateNode) {
        throw new Error("Unable to find state node '".concat(stateIdentifier, "'"));
      }
      return stateNode.path;
    }
    return toStatePath(stateIdentifier, this.delimiter);
  };
  Object.defineProperty(StateNode2.prototype, "initialStateValue", {
    get: function() {
      var _a2;
      if (this.__cache.initialStateValue) {
        return this.__cache.initialStateValue;
      }
      var initialStateValue;
      if (this.type === "parallel") {
        initialStateValue = mapFilterValues(this.states, function(state) {
          return state.initialStateValue || EMPTY_OBJECT;
        }, function(stateNode) {
          return !(stateNode.type === "history");
        });
      } else if (this.initial !== void 0) {
        if (!this.states[this.initial]) {
          throw new Error("Initial state '".concat(this.initial, "' not found on '").concat(this.key, "'"));
        }
        initialStateValue = isLeafNode(this.states[this.initial]) ? this.initial : (_a2 = {}, _a2[this.initial] = this.states[this.initial].initialStateValue, _a2);
      } else {
        initialStateValue = {};
      }
      this.__cache.initialStateValue = initialStateValue;
      return this.__cache.initialStateValue;
    },
    enumerable: false,
    configurable: true
  });
  StateNode2.prototype.getInitialState = function(stateValue, context) {
    this._init();
    var configuration = this.getStateNodes(stateValue);
    return this.resolveTransition({
      configuration,
      entrySet: configuration,
      exitSet: [],
      transitions: [],
      source: void 0,
      actions: []
    }, void 0, context !== null && context !== void 0 ? context : this.machine.context, void 0);
  };
  Object.defineProperty(StateNode2.prototype, "initialState", {
    get: function() {
      var initialStateValue = this.initialStateValue;
      if (!initialStateValue) {
        throw new Error("Cannot retrieve initial state from simple state '".concat(this.id, "'."));
      }
      return this.getInitialState(initialStateValue);
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(StateNode2.prototype, "target", {
    get: function() {
      var target;
      if (this.type === "history") {
        var historyConfig = this.config;
        if (isString$3(historyConfig.target)) {
          target = isStateId(historyConfig.target) ? pathToStateValue(this.machine.getStateNodeById(historyConfig.target).path.slice(this.path.length - 1)) : historyConfig.target;
        } else {
          target = historyConfig.target;
        }
      }
      return target;
    },
    enumerable: false,
    configurable: true
  });
  StateNode2.prototype.getRelativeStateNodes = function(relativeStateId, historyValue, resolve) {
    if (resolve === void 0) {
      resolve = true;
    }
    return resolve ? relativeStateId.type === "history" ? relativeStateId.resolveHistory(historyValue) : relativeStateId.initialStateNodes : [relativeStateId];
  };
  Object.defineProperty(StateNode2.prototype, "initialStateNodes", {
    get: function() {
      var _this = this;
      if (isLeafNode(this)) {
        return [this];
      }
      if (this.type === "compound" && !this.initial) {
        if (!IS_PRODUCTION) {
          warn(false, "Compound state node '".concat(this.id, "' has no initial state."));
        }
        return [this];
      }
      var initialStateNodePaths = toStatePaths(this.initialStateValue);
      return flatten(initialStateNodePaths.map(function(initialPath) {
        return _this.getFromRelativePath(initialPath);
      }));
    },
    enumerable: false,
    configurable: true
  });
  StateNode2.prototype.getFromRelativePath = function(relativePath) {
    if (!relativePath.length) {
      return [this];
    }
    var _a2 = __read$4(relativePath), stateKey = _a2[0], childStatePath = _a2.slice(1);
    if (!this.states) {
      throw new Error("Cannot retrieve subPath '".concat(stateKey, "' from node with no states"));
    }
    var childStateNode = this.getStateNode(stateKey);
    if (childStateNode.type === "history") {
      return childStateNode.resolveHistory();
    }
    if (!this.states[stateKey]) {
      throw new Error("Child state '".concat(stateKey, "' does not exist on '").concat(this.id, "'"));
    }
    return this.states[stateKey].getFromRelativePath(childStatePath);
  };
  StateNode2.prototype.historyValue = function(relativeStateValue) {
    if (!Object.keys(this.states).length) {
      return void 0;
    }
    return {
      current: relativeStateValue || this.initialStateValue,
      states: mapFilterValues(this.states, function(stateNode, key) {
        if (!relativeStateValue) {
          return stateNode.historyValue();
        }
        var subStateValue = isString$3(relativeStateValue) ? void 0 : relativeStateValue[key];
        return stateNode.historyValue(subStateValue || stateNode.initialStateValue);
      }, function(stateNode) {
        return !stateNode.history;
      })
    };
  };
  StateNode2.prototype.resolveHistory = function(historyValue) {
    var _this = this;
    if (this.type !== "history") {
      return [this];
    }
    var parent = this.parent;
    if (!historyValue) {
      var historyTarget = this.target;
      return historyTarget ? flatten(toStatePaths(historyTarget).map(function(relativeChildPath) {
        return parent.getFromRelativePath(relativeChildPath);
      })) : parent.initialStateNodes;
    }
    var subHistoryValue = nestedPath(parent.path, "states")(historyValue).current;
    if (isString$3(subHistoryValue)) {
      return [parent.getStateNode(subHistoryValue)];
    }
    return flatten(toStatePaths(subHistoryValue).map(function(subStatePath) {
      return _this.history === "deep" ? parent.getFromRelativePath(subStatePath) : [parent.states[subStatePath[0]]];
    }));
  };
  Object.defineProperty(StateNode2.prototype, "stateIds", {
    get: function() {
      var _this = this;
      var childStateIds = flatten(Object.keys(this.states).map(function(stateKey) {
        return _this.states[stateKey].stateIds;
      }));
      return [this.id].concat(childStateIds);
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(StateNode2.prototype, "events", {
    get: function() {
      var e_7, _a2, e_8, _b;
      if (this.__cache.events) {
        return this.__cache.events;
      }
      var states = this.states;
      var events = new Set(this.ownEvents);
      if (states) {
        try {
          for (var _c = __values$1(Object.keys(states)), _d = _c.next(); !_d.done; _d = _c.next()) {
            var stateId = _d.value;
            var state = states[stateId];
            if (state.states) {
              try {
                for (var _e = (e_8 = void 0, __values$1(state.events)), _f = _e.next(); !_f.done; _f = _e.next()) {
                  var event_1 = _f.value;
                  events.add("".concat(event_1));
                }
              } catch (e_8_1) {
                e_8 = {
                  error: e_8_1
                };
              } finally {
                try {
                  if (_f && !_f.done && (_b = _e.return))
                    _b.call(_e);
                } finally {
                  if (e_8)
                    throw e_8.error;
                }
              }
            }
          }
        } catch (e_7_1) {
          e_7 = {
            error: e_7_1
          };
        } finally {
          try {
            if (_d && !_d.done && (_a2 = _c.return))
              _a2.call(_c);
          } finally {
            if (e_7)
              throw e_7.error;
          }
        }
      }
      return this.__cache.events = Array.from(events);
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(StateNode2.prototype, "ownEvents", {
    get: function() {
      var events = new Set(this.transitions.filter(function(transition) {
        return !(!transition.target && !transition.actions.length && transition.internal);
      }).map(function(transition) {
        return transition.eventType;
      }));
      return Array.from(events);
    },
    enumerable: false,
    configurable: true
  });
  StateNode2.prototype.resolveTarget = function(_target) {
    var _this = this;
    if (_target === void 0) {
      return void 0;
    }
    return _target.map(function(target) {
      if (!isString$3(target)) {
        return target;
      }
      var isInternalTarget = target[0] === _this.delimiter;
      if (isInternalTarget && !_this.parent) {
        return _this.getStateNodeByPath(target.slice(1));
      }
      var resolvedTarget = isInternalTarget ? _this.key + target : target;
      if (_this.parent) {
        try {
          var targetStateNode = _this.parent.getStateNodeByPath(resolvedTarget);
          return targetStateNode;
        } catch (err) {
          throw new Error("Invalid transition definition for state node '".concat(_this.id, "':\n").concat(err.message));
        }
      } else {
        return _this.getStateNodeByPath(resolvedTarget);
      }
    });
  };
  StateNode2.prototype.formatTransition = function(transitionConfig) {
    var _this = this;
    var normalizedTarget = normalizeTarget(transitionConfig.target);
    var internal = "internal" in transitionConfig ? transitionConfig.internal : normalizedTarget ? normalizedTarget.some(function(_target) {
      return isString$3(_target) && _target[0] === _this.delimiter;
    }) : true;
    var guards = this.machine.options.guards;
    var target = this.resolveTarget(normalizedTarget);
    var transition = __assign$1(__assign$1({}, transitionConfig), {
      actions: toActionObjects(toArray(transitionConfig.actions)),
      cond: toGuard(transitionConfig.cond, guards),
      target,
      source: this,
      internal,
      eventType: transitionConfig.event,
      toJSON: function() {
        return __assign$1(__assign$1({}, transition), {
          target: transition.target ? transition.target.map(function(t2) {
            return "#".concat(t2.id);
          }) : void 0,
          source: "#".concat(_this.id)
        });
      }
    });
    return transition;
  };
  StateNode2.prototype.formatTransitions = function() {
    var e_9, _a2;
    var _this = this;
    var onConfig;
    if (!this.config.on) {
      onConfig = [];
    } else if (Array.isArray(this.config.on)) {
      onConfig = this.config.on;
    } else {
      var _b = this.config.on, _c = WILDCARD, _d = _b[_c], wildcardConfigs = _d === void 0 ? [] : _d, strictTransitionConfigs_1 = __rest$1(_b, [typeof _c === "symbol" ? _c : _c + ""]);
      onConfig = flatten(Object.keys(strictTransitionConfigs_1).map(function(key) {
        if (!IS_PRODUCTION && key === NULL_EVENT) {
          warn(false, "Empty string transition configs (e.g., `{ on: { '': ... }}`) for transient transitions are deprecated. Specify the transition in the `{ always: ... }` property instead. " + 'Please check the `on` configuration for "#'.concat(_this.id, '".'));
        }
        var transitionConfigArray = toTransitionConfigArray(key, strictTransitionConfigs_1[key]);
        if (!IS_PRODUCTION) {
          validateArrayifiedTransitions(_this, key, transitionConfigArray);
        }
        return transitionConfigArray;
      }).concat(toTransitionConfigArray(WILDCARD, wildcardConfigs)));
    }
    var eventlessConfig = this.config.always ? toTransitionConfigArray("", this.config.always) : [];
    var doneConfig = this.config.onDone ? toTransitionConfigArray(String(done(this.id)), this.config.onDone) : [];
    if (!IS_PRODUCTION) {
      warn(!(this.config.onDone && !this.parent), 'Root nodes cannot have an ".onDone" transition. Please check the config of "'.concat(this.id, '".'));
    }
    var invokeConfig = flatten(this.invoke.map(function(invokeDef) {
      var settleTransitions = [];
      if (invokeDef.onDone) {
        settleTransitions.push.apply(settleTransitions, __spreadArray$1([], __read$4(toTransitionConfigArray(String(doneInvoke(invokeDef.id)), invokeDef.onDone)), false));
      }
      if (invokeDef.onError) {
        settleTransitions.push.apply(settleTransitions, __spreadArray$1([], __read$4(toTransitionConfigArray(String(error(invokeDef.id)), invokeDef.onError)), false));
      }
      return settleTransitions;
    }));
    var delayedTransitions = this.after;
    var formattedTransitions = flatten(__spreadArray$1(__spreadArray$1(__spreadArray$1(__spreadArray$1([], __read$4(doneConfig), false), __read$4(invokeConfig), false), __read$4(onConfig), false), __read$4(eventlessConfig), false).map(function(transitionConfig) {
      return toArray(transitionConfig).map(function(transition) {
        return _this.formatTransition(transition);
      });
    }));
    try {
      for (var delayedTransitions_1 = __values$1(delayedTransitions), delayedTransitions_1_1 = delayedTransitions_1.next(); !delayedTransitions_1_1.done; delayedTransitions_1_1 = delayedTransitions_1.next()) {
        var delayedTransition = delayedTransitions_1_1.value;
        formattedTransitions.push(delayedTransition);
      }
    } catch (e_9_1) {
      e_9 = {
        error: e_9_1
      };
    } finally {
      try {
        if (delayedTransitions_1_1 && !delayedTransitions_1_1.done && (_a2 = delayedTransitions_1.return))
          _a2.call(delayedTransitions_1);
      } finally {
        if (e_9)
          throw e_9.error;
      }
    }
    return formattedTransitions;
  };
  return StateNode2;
}();
function createMachine(config, options) {
  return new StateNode(config, options);
}
var assign$1 = assign$2, send = send$1;
function isPromise(obj) {
  if (obj && typeof obj.then === "function") {
    return true;
  } else {
    return false;
  }
}
Promise.resolve(false);
Promise.resolve(true);
var PROMISE_RESOLVED_VOID = Promise.resolve();
function sleep(time, resolveWith) {
  if (!time)
    time = 0;
  return new Promise(function(res) {
    return setTimeout(function() {
      return res(resolveWith);
    }, time);
  });
}
function randomInt(min, max) {
  return Math.floor(Math.random() * (max - min + 1) + min);
}
function randomToken() {
  return Math.random().toString(36).substring(2);
}
var lastMs = 0;
var additional = 0;
function microSeconds$4() {
  var ms = new Date().getTime();
  if (ms === lastMs) {
    additional++;
    return ms * 1e3 + additional;
  } else {
    lastMs = ms;
    additional = 0;
    return ms * 1e3;
  }
}
var isNode = Object.prototype.toString.call(typeof process !== "undefined" ? process : 0) === "[object process]";
var microSeconds$3 = microSeconds$4;
var type$3 = "native";
function create$3(channelName) {
  var state = {
    messagesCallback: null,
    bc: new BroadcastChannel(channelName),
    subFns: []
  };
  state.bc.onmessage = function(msg) {
    if (state.messagesCallback) {
      state.messagesCallback(msg.data);
    }
  };
  return state;
}
function close$3(channelState) {
  channelState.bc.close();
  channelState.subFns = [];
}
function postMessage$3(channelState, messageJson) {
  try {
    channelState.bc.postMessage(messageJson, false);
    return PROMISE_RESOLVED_VOID;
  } catch (err) {
    return Promise.reject(err);
  }
}
function onMessage$3(channelState, fn2) {
  channelState.messagesCallback = fn2;
}
function canBeUsed$3() {
  if (isNode && typeof window === "undefined")
    return false;
  if (typeof BroadcastChannel === "function") {
    if (BroadcastChannel._pubkey) {
      throw new Error("BroadcastChannel: Do not overwrite window.BroadcastChannel with this module, this is not a polyfill");
    }
    return true;
  } else
    return false;
}
function averageResponseTime$3() {
  return 150;
}
var NativeMethod = {
  create: create$3,
  close: close$3,
  onMessage: onMessage$3,
  postMessage: postMessage$3,
  canBeUsed: canBeUsed$3,
  type: type$3,
  averageResponseTime: averageResponseTime$3,
  microSeconds: microSeconds$3
};
var ObliviousSet = function() {
  function ObliviousSet2(ttl) {
    this.ttl = ttl;
    this.set = /* @__PURE__ */ new Set();
    this.timeMap = /* @__PURE__ */ new Map();
  }
  ObliviousSet2.prototype.has = function(value) {
    return this.set.has(value);
  };
  ObliviousSet2.prototype.add = function(value) {
    var _this = this;
    this.timeMap.set(value, now());
    this.set.add(value);
    setTimeout(function() {
      removeTooOldValues(_this);
    }, 0);
  };
  ObliviousSet2.prototype.clear = function() {
    this.set.clear();
    this.timeMap.clear();
  };
  return ObliviousSet2;
}();
function removeTooOldValues(obliviousSet) {
  var olderThen = now() - obliviousSet.ttl;
  var iterator = obliviousSet.set[Symbol.iterator]();
  while (true) {
    var value = iterator.next().value;
    if (!value) {
      return;
    }
    var time = obliviousSet.timeMap.get(value);
    if (time < olderThen) {
      obliviousSet.timeMap.delete(value);
      obliviousSet.set.delete(value);
    } else {
      return;
    }
  }
}
function now() {
  return new Date().getTime();
}
function fillOptionsWithDefaults() {
  var originalOptions = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
  var options = JSON.parse(JSON.stringify(originalOptions));
  if (typeof options.webWorkerSupport === "undefined")
    options.webWorkerSupport = true;
  if (!options.idb)
    options.idb = {};
  if (!options.idb.ttl)
    options.idb.ttl = 1e3 * 45;
  if (!options.idb.fallbackInterval)
    options.idb.fallbackInterval = 150;
  if (originalOptions.idb && typeof originalOptions.idb.onclose === "function")
    options.idb.onclose = originalOptions.idb.onclose;
  if (!options.localstorage)
    options.localstorage = {};
  if (!options.localstorage.removeTimeout)
    options.localstorage.removeTimeout = 1e3 * 60;
  if (originalOptions.methods)
    options.methods = originalOptions.methods;
  if (!options.node)
    options.node = {};
  if (!options.node.ttl)
    options.node.ttl = 1e3 * 60 * 2;
  if (!options.node.maxParallelWrites)
    options.node.maxParallelWrites = 2048;
  if (typeof options.node.useFastPath === "undefined")
    options.node.useFastPath = true;
  return options;
}
var microSeconds$2 = microSeconds$4;
var DB_PREFIX = "pubkey.broadcast-channel-0-";
var OBJECT_STORE_ID = "messages";
var type$2 = "idb";
function getIdb() {
  if (typeof indexedDB !== "undefined")
    return indexedDB;
  if (typeof window !== "undefined") {
    if (typeof window.mozIndexedDB !== "undefined")
      return window.mozIndexedDB;
    if (typeof window.webkitIndexedDB !== "undefined")
      return window.webkitIndexedDB;
    if (typeof window.msIndexedDB !== "undefined")
      return window.msIndexedDB;
  }
  return false;
}
function createDatabase(channelName) {
  var IndexedDB = getIdb();
  var dbName = DB_PREFIX + channelName;
  var openRequest = IndexedDB.open(dbName, 1);
  openRequest.onupgradeneeded = function(ev) {
    var db = ev.target.result;
    db.createObjectStore(OBJECT_STORE_ID, {
      keyPath: "id",
      autoIncrement: true
    });
  };
  var dbPromise = new Promise(function(res, rej) {
    openRequest.onerror = function(ev) {
      return rej(ev);
    };
    openRequest.onsuccess = function() {
      res(openRequest.result);
    };
  });
  return dbPromise;
}
function writeMessage(db, readerUuid, messageJson) {
  var time = new Date().getTime();
  var writeObject = {
    uuid: readerUuid,
    time,
    data: messageJson
  };
  var transaction = db.transaction([OBJECT_STORE_ID], "readwrite");
  return new Promise(function(res, rej) {
    transaction.oncomplete = function() {
      return res();
    };
    transaction.onerror = function(ev) {
      return rej(ev);
    };
    var objectStore = transaction.objectStore(OBJECT_STORE_ID);
    objectStore.add(writeObject);
  });
}
function getMessagesHigherThan(db, lastCursorId) {
  var objectStore = db.transaction(OBJECT_STORE_ID).objectStore(OBJECT_STORE_ID);
  var ret = [];
  function openCursor() {
    try {
      var keyRangeValue = IDBKeyRange.bound(lastCursorId + 1, Infinity);
      return objectStore.openCursor(keyRangeValue);
    } catch (e2) {
      return objectStore.openCursor();
    }
  }
  return new Promise(function(res) {
    openCursor().onsuccess = function(ev) {
      var cursor = ev.target.result;
      if (cursor) {
        if (cursor.value.id < lastCursorId + 1) {
          cursor["continue"](lastCursorId + 1);
        } else {
          ret.push(cursor.value);
          cursor["continue"]();
        }
      } else {
        res(ret);
      }
    };
  });
}
function removeMessageById(db, id) {
  var request4 = db.transaction([OBJECT_STORE_ID], "readwrite").objectStore(OBJECT_STORE_ID)["delete"](id);
  return new Promise(function(res) {
    request4.onsuccess = function() {
      return res();
    };
  });
}
function getOldMessages(db, ttl) {
  var olderThen = new Date().getTime() - ttl;
  var objectStore = db.transaction(OBJECT_STORE_ID).objectStore(OBJECT_STORE_ID);
  var ret = [];
  return new Promise(function(res) {
    objectStore.openCursor().onsuccess = function(ev) {
      var cursor = ev.target.result;
      if (cursor) {
        var msgObk = cursor.value;
        if (msgObk.time < olderThen) {
          ret.push(msgObk);
          cursor["continue"]();
        } else {
          res(ret);
          return;
        }
      } else {
        res(ret);
      }
    };
  });
}
function cleanOldMessages(db, ttl) {
  return getOldMessages(db, ttl).then(function(tooOld) {
    return Promise.all(tooOld.map(function(msgObj) {
      return removeMessageById(db, msgObj.id);
    }));
  });
}
function create$2(channelName, options) {
  options = fillOptionsWithDefaults(options);
  return createDatabase(channelName).then(function(db) {
    var state = {
      closed: false,
      lastCursorId: 0,
      channelName,
      options,
      uuid: randomToken(),
      eMIs: new ObliviousSet(options.idb.ttl * 2),
      writeBlockPromise: PROMISE_RESOLVED_VOID,
      messagesCallback: null,
      readQueuePromises: [],
      db
    };
    db.onclose = function() {
      state.closed = true;
      if (options.idb.onclose)
        options.idb.onclose();
    };
    _readLoop(state);
    return state;
  });
}
function _readLoop(state) {
  if (state.closed)
    return;
  readNewMessages(state).then(function() {
    return sleep(state.options.idb.fallbackInterval);
  }).then(function() {
    return _readLoop(state);
  });
}
function _filterMessage(msgObj, state) {
  if (msgObj.uuid === state.uuid)
    return false;
  if (state.eMIs.has(msgObj.id))
    return false;
  if (msgObj.data.time < state.messagesCallbackTime)
    return false;
  return true;
}
function readNewMessages(state) {
  if (state.closed)
    return PROMISE_RESOLVED_VOID;
  if (!state.messagesCallback)
    return PROMISE_RESOLVED_VOID;
  return getMessagesHigherThan(state.db, state.lastCursorId).then(function(newerMessages) {
    var useMessages = newerMessages.filter(function(msgObj) {
      return !!msgObj;
    }).map(function(msgObj) {
      if (msgObj.id > state.lastCursorId) {
        state.lastCursorId = msgObj.id;
      }
      return msgObj;
    }).filter(function(msgObj) {
      return _filterMessage(msgObj, state);
    }).sort(function(msgObjA, msgObjB) {
      return msgObjA.time - msgObjB.time;
    });
    useMessages.forEach(function(msgObj) {
      if (state.messagesCallback) {
        state.eMIs.add(msgObj.id);
        state.messagesCallback(msgObj.data);
      }
    });
    return PROMISE_RESOLVED_VOID;
  });
}
function close$2(channelState) {
  channelState.closed = true;
  channelState.db.close();
}
function postMessage$2(channelState, messageJson) {
  channelState.writeBlockPromise = channelState.writeBlockPromise.then(function() {
    return writeMessage(channelState.db, channelState.uuid, messageJson);
  }).then(function() {
    if (randomInt(0, 10) === 0) {
      cleanOldMessages(channelState.db, channelState.options.idb.ttl);
    }
  });
  return channelState.writeBlockPromise;
}
function onMessage$2(channelState, fn2, time) {
  channelState.messagesCallbackTime = time;
  channelState.messagesCallback = fn2;
  readNewMessages(channelState);
}
function canBeUsed$2() {
  if (isNode)
    return false;
  var idb = getIdb();
  if (!idb)
    return false;
  return true;
}
function averageResponseTime$2(options) {
  return options.idb.fallbackInterval * 2;
}
var IndexeDbMethod = {
  create: create$2,
  close: close$2,
  onMessage: onMessage$2,
  postMessage: postMessage$2,
  canBeUsed: canBeUsed$2,
  type: type$2,
  averageResponseTime: averageResponseTime$2,
  microSeconds: microSeconds$2
};
var microSeconds$1 = microSeconds$4;
var KEY_PREFIX = "pubkey.broadcastChannel-";
var type$1 = "localstorage";
function getLocalStorage() {
  var localStorage2;
  if (typeof window === "undefined")
    return null;
  try {
    localStorage2 = window.localStorage;
    localStorage2 = window["ie8-eventlistener/storage"] || window.localStorage;
  } catch (e2) {
  }
  return localStorage2;
}
function storageKey(channelName) {
  return KEY_PREFIX + channelName;
}
function postMessage$1(channelState, messageJson) {
  return new Promise(function(res) {
    sleep().then(function() {
      var key = storageKey(channelState.channelName);
      var writeObj = {
        token: randomToken(),
        time: new Date().getTime(),
        data: messageJson,
        uuid: channelState.uuid
      };
      var value = JSON.stringify(writeObj);
      getLocalStorage().setItem(key, value);
      var ev = document.createEvent("Event");
      ev.initEvent("storage", true, true);
      ev.key = key;
      ev.newValue = value;
      window.dispatchEvent(ev);
      res();
    });
  });
}
function addStorageEventListener(channelName, fn2) {
  var key = storageKey(channelName);
  var listener = function listener2(ev) {
    if (ev.key === key) {
      fn2(JSON.parse(ev.newValue));
    }
  };
  window.addEventListener("storage", listener);
  return listener;
}
function removeStorageEventListener(listener) {
  window.removeEventListener("storage", listener);
}
function create$1(channelName, options) {
  options = fillOptionsWithDefaults(options);
  if (!canBeUsed$1()) {
    throw new Error("BroadcastChannel: localstorage cannot be used");
  }
  var uuid = randomToken();
  var eMIs = new ObliviousSet(options.localstorage.removeTimeout);
  var state = {
    channelName,
    uuid,
    eMIs
  };
  state.listener = addStorageEventListener(channelName, function(msgObj) {
    if (!state.messagesCallback)
      return;
    if (msgObj.uuid === uuid)
      return;
    if (!msgObj.token || eMIs.has(msgObj.token))
      return;
    if (msgObj.data.time && msgObj.data.time < state.messagesCallbackTime)
      return;
    eMIs.add(msgObj.token);
    state.messagesCallback(msgObj.data);
  });
  return state;
}
function close$1(channelState) {
  removeStorageEventListener(channelState.listener);
}
function onMessage$1(channelState, fn2, time) {
  channelState.messagesCallbackTime = time;
  channelState.messagesCallback = fn2;
}
function canBeUsed$1() {
  if (isNode)
    return false;
  var ls = getLocalStorage();
  if (!ls)
    return false;
  try {
    var key = "__broadcastchannel_check";
    ls.setItem(key, "works");
    ls.removeItem(key);
  } catch (e2) {
    return false;
  }
  return true;
}
function averageResponseTime$1() {
  var defaultTime = 120;
  var userAgent = navigator.userAgent.toLowerCase();
  if (userAgent.includes("safari") && !userAgent.includes("chrome")) {
    return defaultTime * 2;
  }
  return defaultTime;
}
var LocalstorageMethod = {
  create: create$1,
  close: close$1,
  onMessage: onMessage$1,
  postMessage: postMessage$1,
  canBeUsed: canBeUsed$1,
  type: type$1,
  averageResponseTime: averageResponseTime$1,
  microSeconds: microSeconds$1
};
var microSeconds = microSeconds$4;
var type = "simulate";
var SIMULATE_CHANNELS = /* @__PURE__ */ new Set();
function create(channelName) {
  var state = {
    name: channelName,
    messagesCallback: null
  };
  SIMULATE_CHANNELS.add(state);
  return state;
}
function close(channelState) {
  SIMULATE_CHANNELS["delete"](channelState);
}
function postMessage(channelState, messageJson) {
  return new Promise(function(res) {
    return setTimeout(function() {
      var channelArray = Array.from(SIMULATE_CHANNELS);
      channelArray.filter(function(channel) {
        return channel.name === channelState.name;
      }).filter(function(channel) {
        return channel !== channelState;
      }).filter(function(channel) {
        return !!channel.messagesCallback;
      }).forEach(function(channel) {
        return channel.messagesCallback(messageJson);
      });
      res();
    }, 5);
  });
}
function onMessage(channelState, fn2) {
  channelState.messagesCallback = fn2;
}
function canBeUsed() {
  return true;
}
function averageResponseTime() {
  return 5;
}
var SimulateMethod = {
  create,
  close,
  onMessage,
  postMessage,
  canBeUsed,
  type,
  averageResponseTime,
  microSeconds
};
var METHODS = [
  NativeMethod,
  IndexeDbMethod,
  LocalstorageMethod
];
function chooseMethod(options) {
  var chooseMethods = [].concat(options.methods, METHODS).filter(Boolean);
  if (options.type) {
    if (options.type === "simulate") {
      return SimulateMethod;
    }
    var ret = chooseMethods.find(function(m2) {
      return m2.type === options.type;
    });
    if (!ret)
      throw new Error("method-type " + options.type + " not found");
    else
      return ret;
  }
  if (!options.webWorkerSupport && !isNode) {
    chooseMethods = chooseMethods.filter(function(m2) {
      return m2.type !== "idb";
    });
  }
  var useMethod = chooseMethods.find(function(method) {
    return method.canBeUsed();
  });
  if (!useMethod)
    throw new Error("No useable method found in " + JSON.stringify(METHODS.map(function(m2) {
      return m2.type;
    })));
  else
    return useMethod;
}
var OPEN_BROADCAST_CHANNELS = /* @__PURE__ */ new Set();
var lastId = 0;
var BroadcastChannel$1 = function BroadcastChannel2(name2, options) {
  this.id = lastId++;
  OPEN_BROADCAST_CHANNELS.add(this);
  this.name = name2;
  if (ENFORCED_OPTIONS) {
    options = ENFORCED_OPTIONS;
  }
  this.options = fillOptionsWithDefaults(options);
  this.method = chooseMethod(this.options);
  this._iL = false;
  this._onML = null;
  this._addEL = {
    message: [],
    internal: []
  };
  this._uMP = /* @__PURE__ */ new Set();
  this._befC = [];
  this._prepP = null;
  _prepareChannel(this);
};
BroadcastChannel$1._pubkey = true;
var ENFORCED_OPTIONS;
BroadcastChannel$1.prototype = {
  postMessage: function postMessage2(msg) {
    if (this.closed) {
      throw new Error("BroadcastChannel.postMessage(): Cannot post message after channel has closed " + JSON.stringify(msg));
    }
    return _post(this, "message", msg);
  },
  postInternal: function postInternal(msg) {
    return _post(this, "internal", msg);
  },
  set onmessage(fn2) {
    var time = this.method.microSeconds();
    var listenObj = {
      time,
      fn: fn2
    };
    _removeListenerObject(this, "message", this._onML);
    if (fn2 && typeof fn2 === "function") {
      this._onML = listenObj;
      _addListenerObject(this, "message", listenObj);
    } else {
      this._onML = null;
    }
  },
  addEventListener: function addEventListener(type2, fn2) {
    var time = this.method.microSeconds();
    var listenObj = {
      time,
      fn: fn2
    };
    _addListenerObject(this, type2, listenObj);
  },
  removeEventListener: function removeEventListener(type2, fn2) {
    var obj = this._addEL[type2].find(function(obj2) {
      return obj2.fn === fn2;
    });
    _removeListenerObject(this, type2, obj);
  },
  close: function close2() {
    var _this = this;
    if (this.closed) {
      return;
    }
    OPEN_BROADCAST_CHANNELS["delete"](this);
    this.closed = true;
    var awaitPrepare = this._prepP ? this._prepP : PROMISE_RESOLVED_VOID;
    this._onML = null;
    this._addEL.message = [];
    return awaitPrepare.then(function() {
      return Promise.all(Array.from(_this._uMP));
    }).then(function() {
      return Promise.all(_this._befC.map(function(fn2) {
        return fn2();
      }));
    }).then(function() {
      return _this.method.close(_this._state);
    });
  },
  get type() {
    return this.method.type;
  },
  get isClosed() {
    return this.closed;
  }
};
function _post(broadcastChannel, type2, msg) {
  var time = broadcastChannel.method.microSeconds();
  var msgObj = {
    time,
    type: type2,
    data: msg
  };
  var awaitPrepare = broadcastChannel._prepP ? broadcastChannel._prepP : PROMISE_RESOLVED_VOID;
  return awaitPrepare.then(function() {
    var sendPromise = broadcastChannel.method.postMessage(broadcastChannel._state, msgObj);
    broadcastChannel._uMP.add(sendPromise);
    sendPromise["catch"]().then(function() {
      return broadcastChannel._uMP["delete"](sendPromise);
    });
    return sendPromise;
  });
}
function _prepareChannel(channel) {
  var maybePromise = channel.method.create(channel.name, channel.options);
  if (isPromise(maybePromise)) {
    channel._prepP = maybePromise;
    maybePromise.then(function(s2) {
      channel._state = s2;
    });
  } else {
    channel._state = maybePromise;
  }
}
function _hasMessageListeners(channel) {
  if (channel._addEL.message.length > 0)
    return true;
  if (channel._addEL.internal.length > 0)
    return true;
  return false;
}
function _addListenerObject(channel, type2, obj) {
  channel._addEL[type2].push(obj);
  _startListening(channel);
}
function _removeListenerObject(channel, type2, obj) {
  channel._addEL[type2] = channel._addEL[type2].filter(function(o2) {
    return o2 !== obj;
  });
  _stopListening(channel);
}
function _startListening(channel) {
  if (!channel._iL && _hasMessageListeners(channel)) {
    var listenerFn = function listenerFn2(msgObj) {
      channel._addEL[msgObj.type].forEach(function(listenerObject) {
        var hundredMsInMicro = 100 * 1e3;
        var minMessageTime = listenerObject.time - hundredMsInMicro;
        if (msgObj.time >= minMessageTime) {
          listenerObject.fn(msgObj.data);
        }
      });
    };
    var time = channel.method.microSeconds();
    if (channel._prepP) {
      channel._prepP.then(function() {
        channel._iL = true;
        channel.method.onMessage(channel._state, listenerFn, time);
      });
    } else {
      channel._iL = true;
      channel.method.onMessage(channel._state, listenerFn, time);
    }
  }
}
function _stopListening(channel) {
  if (channel._iL && !_hasMessageListeners(channel)) {
    channel._iL = false;
    var time = channel.method.microSeconds();
    channel.method.onMessage(channel._state, null, time);
  }
}
const NHOST_REFRESH_TOKEN_KEY = "nhostRefreshToken";
const NHOST_JWT_EXPIRES_AT_KEY = "nhostRefreshTokenExpiresAt";
const MIN_PASSWORD_LENGTH = 3;
const TOKEN_REFRESH_MARGIN = 900;
const MIN_TOKEN_REFRESH_INTERVAL = 60;
const NETWORK_ERROR_CODE = 0;
const VALIDATION_ERROR_CODE = 10;
const INVALID_EMAIL_ERROR = {
  status: VALIDATION_ERROR_CODE,
  error: "invalid-email",
  message: "Email is incorrectly formatted"
};
const INVALID_MFA_TYPE_ERROR = {
  status: VALIDATION_ERROR_CODE,
  error: "invalid-mfa-type",
  message: "MFA type is invalid"
};
const INVALID_PASSWORD_ERROR = {
  status: VALIDATION_ERROR_CODE,
  error: "invalid-password",
  message: "Password is incorrectly formatted"
};
const INVALID_PHONE_NUMBER_ERROR = {
  status: VALIDATION_ERROR_CODE,
  error: "invalid-phone-number",
  message: "Phone number is incorrectly formatted"
};
const NO_MFA_TICKET_ERROR = {
  status: VALIDATION_ERROR_CODE,
  error: "no-mfa-ticket",
  message: "No MFA ticket has been provided"
};
var axios$8 = { exports: {} };
var bind$8 = function bind(fn2, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i2 = 0; i2 < args.length; i2++) {
      args[i2] = arguments[i2];
    }
    return fn2.apply(thisArg, args);
  };
};
var bind$7 = bind$8;
var toString$2 = Object.prototype.toString;
function isArray$2(val) {
  return Array.isArray(val);
}
function isUndefined$2(val) {
  return typeof val === "undefined";
}
function isBuffer$2(val) {
  return val !== null && !isUndefined$2(val) && val.constructor !== null && !isUndefined$2(val.constructor) && typeof val.constructor.isBuffer === "function" && val.constructor.isBuffer(val);
}
function isArrayBuffer$2(val) {
  return toString$2.call(val) === "[object ArrayBuffer]";
}
function isFormData$2(val) {
  return toString$2.call(val) === "[object FormData]";
}
function isArrayBufferView$2(val) {
  var result;
  if (typeof ArrayBuffer !== "undefined" && ArrayBuffer.isView) {
    result = ArrayBuffer.isView(val);
  } else {
    result = val && val.buffer && isArrayBuffer$2(val.buffer);
  }
  return result;
}
function isString$2(val) {
  return typeof val === "string";
}
function isNumber$2(val) {
  return typeof val === "number";
}
function isObject$2(val) {
  return val !== null && typeof val === "object";
}
function isPlainObject$2(val) {
  if (toString$2.call(val) !== "[object Object]") {
    return false;
  }
  var prototype = Object.getPrototypeOf(val);
  return prototype === null || prototype === Object.prototype;
}
function isDate$2(val) {
  return toString$2.call(val) === "[object Date]";
}
function isFile$2(val) {
  return toString$2.call(val) === "[object File]";
}
function isBlob$2(val) {
  return toString$2.call(val) === "[object Blob]";
}
function isFunction$2(val) {
  return toString$2.call(val) === "[object Function]";
}
function isStream$2(val) {
  return isObject$2(val) && isFunction$2(val.pipe);
}
function isURLSearchParams$2(val) {
  return toString$2.call(val) === "[object URLSearchParams]";
}
function trim$2(str) {
  return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, "");
}
function isStandardBrowserEnv$2() {
  if (typeof navigator !== "undefined" && (navigator.product === "ReactNative" || navigator.product === "NativeScript" || navigator.product === "NS")) {
    return false;
  }
  return typeof window !== "undefined" && typeof document !== "undefined";
}
function forEach$2(obj, fn2) {
  if (obj === null || typeof obj === "undefined") {
    return;
  }
  if (typeof obj !== "object") {
    obj = [obj];
  }
  if (isArray$2(obj)) {
    for (var i2 = 0, l2 = obj.length; i2 < l2; i2++) {
      fn2.call(null, obj[i2], i2, obj);
    }
  } else {
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn2.call(null, obj[key], key, obj);
      }
    }
  }
}
function merge$2() {
  var result = {};
  function assignValue(val, key) {
    if (isPlainObject$2(result[key]) && isPlainObject$2(val)) {
      result[key] = merge$2(result[key], val);
    } else if (isPlainObject$2(val)) {
      result[key] = merge$2({}, val);
    } else if (isArray$2(val)) {
      result[key] = val.slice();
    } else {
      result[key] = val;
    }
  }
  for (var i2 = 0, l2 = arguments.length; i2 < l2; i2++) {
    forEach$2(arguments[i2], assignValue);
  }
  return result;
}
function extend$2(a2, b2, thisArg) {
  forEach$2(b2, function assignValue(val, key) {
    if (thisArg && typeof val === "function") {
      a2[key] = bind$7(val, thisArg);
    } else {
      a2[key] = val;
    }
  });
  return a2;
}
function stripBOM$2(content) {
  if (content.charCodeAt(0) === 65279) {
    content = content.slice(1);
  }
  return content;
}
var utils$G = {
  isArray: isArray$2,
  isArrayBuffer: isArrayBuffer$2,
  isBuffer: isBuffer$2,
  isFormData: isFormData$2,
  isArrayBufferView: isArrayBufferView$2,
  isString: isString$2,
  isNumber: isNumber$2,
  isObject: isObject$2,
  isPlainObject: isPlainObject$2,
  isUndefined: isUndefined$2,
  isDate: isDate$2,
  isFile: isFile$2,
  isBlob: isBlob$2,
  isFunction: isFunction$2,
  isStream: isStream$2,
  isURLSearchParams: isURLSearchParams$2,
  isStandardBrowserEnv: isStandardBrowserEnv$2,
  forEach: forEach$2,
  merge: merge$2,
  extend: extend$2,
  trim: trim$2,
  stripBOM: stripBOM$2
};
var utils$F = utils$G;
function encode$2(val) {
  return encodeURIComponent(val).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
var buildURL$8 = function buildURL(url, params, paramsSerializer) {
  if (!params) {
    return url;
  }
  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils$F.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];
    utils$F.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === "undefined") {
        return;
      }
      if (utils$F.isArray(val)) {
        key = key + "[]";
      } else {
        val = [val];
      }
      utils$F.forEach(val, function parseValue(v2) {
        if (utils$F.isDate(v2)) {
          v2 = v2.toISOString();
        } else if (utils$F.isObject(v2)) {
          v2 = JSON.stringify(v2);
        }
        parts.push(encode$2(key) + "=" + encode$2(v2));
      });
    });
    serializedParams = parts.join("&");
  }
  if (serializedParams) {
    var hashmarkIndex = url.indexOf("#");
    if (hashmarkIndex !== -1) {
      url = url.slice(0, hashmarkIndex);
    }
    url += (url.indexOf("?") === -1 ? "?" : "&") + serializedParams;
  }
  return url;
};
var utils$E = utils$G;
function InterceptorManager$5() {
  this.handlers = [];
}
InterceptorManager$5.prototype.use = function use(fulfilled, rejected, options) {
  this.handlers.push({
    fulfilled,
    rejected,
    synchronous: options ? options.synchronous : false,
    runWhen: options ? options.runWhen : null
  });
  return this.handlers.length - 1;
};
InterceptorManager$5.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};
InterceptorManager$5.prototype.forEach = function forEach(fn2) {
  utils$E.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn2(h);
    }
  });
};
var InterceptorManager_1$2 = InterceptorManager$5;
var utils$D = utils$G;
var normalizeHeaderName$5 = function normalizeHeaderName(headers, normalizedName) {
  utils$D.forEach(headers, function processHeader(value, name2) {
    if (name2 !== normalizedName && name2.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name2];
    }
  });
};
var enhanceError$8 = function enhanceError(error2, config, code, request4, response) {
  error2.config = config;
  if (code) {
    error2.code = code;
  }
  error2.request = request4;
  error2.response = response;
  error2.isAxiosError = true;
  error2.toJSON = function toJSON() {
    return {
      message: this.message,
      name: this.name,
      description: this.description,
      number: this.number,
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      config: this.config,
      code: this.code,
      status: this.response && this.response.status ? this.response.status : null
    };
  };
  return error2;
};
var enhanceError$7 = enhanceError$8;
var createError$8 = function createError(message, config, code, request4, response) {
  var error2 = new Error(message);
  return enhanceError$7(error2, config, code, request4, response);
};
var createError$7 = createError$8;
var settle$5 = function settle(resolve, reject, response) {
  var validateStatus4 = response.config.validateStatus;
  if (!response.status || !validateStatus4 || validateStatus4(response.status)) {
    resolve(response);
  } else {
    reject(createError$7("Request failed with status code " + response.status, response.config, null, response.request, response));
  }
};
var utils$C = utils$G;
var cookies$5 = utils$C.isStandardBrowserEnv() ? function standardBrowserEnv() {
  return {
    write: function write(name2, value, expires, path2, domain, secure) {
      var cookie = [];
      cookie.push(name2 + "=" + encodeURIComponent(value));
      if (utils$C.isNumber(expires)) {
        cookie.push("expires=" + new Date(expires).toGMTString());
      }
      if (utils$C.isString(path2)) {
        cookie.push("path=" + path2);
      }
      if (utils$C.isString(domain)) {
        cookie.push("domain=" + domain);
      }
      if (secure === true) {
        cookie.push("secure");
      }
      document.cookie = cookie.join("; ");
    },
    read: function read(name2) {
      var match = document.cookie.match(new RegExp("(^|;\\s*)(" + name2 + ")=([^;]*)"));
      return match ? decodeURIComponent(match[3]) : null;
    },
    remove: function remove(name2) {
      this.write(name2, "", Date.now() - 864e5);
    }
  };
}() : function nonStandardBrowserEnv() {
  return {
    write: function write() {
    },
    read: function read() {
      return null;
    },
    remove: function remove() {
    }
  };
}();
var isAbsoluteURL$5 = function isAbsoluteURL(url) {
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
};
var combineURLs$5 = function combineURLs(baseURL, relativeURL) {
  return relativeURL ? baseURL.replace(/\/+$/, "") + "/" + relativeURL.replace(/^\/+/, "") : baseURL;
};
var isAbsoluteURL$4 = isAbsoluteURL$5;
var combineURLs$4 = combineURLs$5;
var buildFullPath$5 = function buildFullPath(baseURL, requestedURL) {
  if (baseURL && !isAbsoluteURL$4(requestedURL)) {
    return combineURLs$4(baseURL, requestedURL);
  }
  return requestedURL;
};
var utils$B = utils$G;
var ignoreDuplicateOf$2 = [
  "age",
  "authorization",
  "content-length",
  "content-type",
  "etag",
  "expires",
  "from",
  "host",
  "if-modified-since",
  "if-unmodified-since",
  "last-modified",
  "location",
  "max-forwards",
  "proxy-authorization",
  "referer",
  "retry-after",
  "user-agent"
];
var parseHeaders$5 = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i2;
  if (!headers) {
    return parsed;
  }
  utils$B.forEach(headers.split("\n"), function parser(line) {
    i2 = line.indexOf(":");
    key = utils$B.trim(line.substr(0, i2)).toLowerCase();
    val = utils$B.trim(line.substr(i2 + 1));
    if (key) {
      if (parsed[key] && ignoreDuplicateOf$2.indexOf(key) >= 0) {
        return;
      }
      if (key === "set-cookie") {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ", " + val : val;
      }
    }
  });
  return parsed;
};
var utils$A = utils$G;
var isURLSameOrigin$5 = utils$A.isStandardBrowserEnv() ? function standardBrowserEnv2() {
  var msie = /(msie|trident)/i.test(navigator.userAgent);
  var urlParsingNode = document.createElement("a");
  var originURL;
  function resolveURL(url) {
    var href = url;
    if (msie) {
      urlParsingNode.setAttribute("href", href);
      href = urlParsingNode.href;
    }
    urlParsingNode.setAttribute("href", href);
    return {
      href: urlParsingNode.href,
      protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, "") : "",
      host: urlParsingNode.host,
      search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, "") : "",
      hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, "") : "",
      hostname: urlParsingNode.hostname,
      port: urlParsingNode.port,
      pathname: urlParsingNode.pathname.charAt(0) === "/" ? urlParsingNode.pathname : "/" + urlParsingNode.pathname
    };
  }
  originURL = resolveURL(window.location.href);
  return function isURLSameOrigin2(requestURL) {
    var parsed = utils$A.isString(requestURL) ? resolveURL(requestURL) : requestURL;
    return parsed.protocol === originURL.protocol && parsed.host === originURL.host;
  };
}() : function nonStandardBrowserEnv2() {
  return function isURLSameOrigin2() {
    return true;
  };
}();
function Cancel$9(message) {
  this.message = message;
}
Cancel$9.prototype.toString = function toString() {
  return "Cancel" + (this.message ? ": " + this.message : "");
};
Cancel$9.prototype.__CANCEL__ = true;
var Cancel_1$2 = Cancel$9;
var utils$z = utils$G;
var settle$4 = settle$5;
var cookies$4 = cookies$5;
var buildURL$7 = buildURL$8;
var buildFullPath$4 = buildFullPath$5;
var parseHeaders$4 = parseHeaders$5;
var isURLSameOrigin$4 = isURLSameOrigin$5;
var createError$6 = createError$8;
var defaults$d = defaults_1$2;
var Cancel$8 = Cancel_1$2;
var xhr$2 = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;
    var responseType = config.responseType;
    var onCanceled;
    function done2() {
      if (config.cancelToken) {
        config.cancelToken.unsubscribe(onCanceled);
      }
      if (config.signal) {
        config.signal.removeEventListener("abort", onCanceled);
      }
    }
    if (utils$z.isFormData(requestData)) {
      delete requestHeaders["Content-Type"];
    }
    var request4 = new XMLHttpRequest();
    if (config.auth) {
      var username = config.auth.username || "";
      var password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : "";
      requestHeaders.Authorization = "Basic " + btoa(username + ":" + password);
    }
    var fullPath = buildFullPath$4(config.baseURL, config.url);
    request4.open(config.method.toUpperCase(), buildURL$7(fullPath, config.params, config.paramsSerializer), true);
    request4.timeout = config.timeout;
    function onloadend() {
      if (!request4) {
        return;
      }
      var responseHeaders = "getAllResponseHeaders" in request4 ? parseHeaders$4(request4.getAllResponseHeaders()) : null;
      var responseData = !responseType || responseType === "text" || responseType === "json" ? request4.responseText : request4.response;
      var response = {
        data: responseData,
        status: request4.status,
        statusText: request4.statusText,
        headers: responseHeaders,
        config,
        request: request4
      };
      settle$4(function _resolve(value) {
        resolve(value);
        done2();
      }, function _reject(err) {
        reject(err);
        done2();
      }, response);
      request4 = null;
    }
    if ("onloadend" in request4) {
      request4.onloadend = onloadend;
    } else {
      request4.onreadystatechange = function handleLoad() {
        if (!request4 || request4.readyState !== 4) {
          return;
        }
        if (request4.status === 0 && !(request4.responseURL && request4.responseURL.indexOf("file:") === 0)) {
          return;
        }
        setTimeout(onloadend);
      };
    }
    request4.onabort = function handleAbort() {
      if (!request4) {
        return;
      }
      reject(createError$6("Request aborted", config, "ECONNABORTED", request4));
      request4 = null;
    };
    request4.onerror = function handleError() {
      reject(createError$6("Network Error", config, null, request4));
      request4 = null;
    };
    request4.ontimeout = function handleTimeout() {
      var timeoutErrorMessage = config.timeout ? "timeout of " + config.timeout + "ms exceeded" : "timeout exceeded";
      var transitional4 = config.transitional || defaults$d.transitional;
      if (config.timeoutErrorMessage) {
        timeoutErrorMessage = config.timeoutErrorMessage;
      }
      reject(createError$6(timeoutErrorMessage, config, transitional4.clarifyTimeoutError ? "ETIMEDOUT" : "ECONNABORTED", request4));
      request4 = null;
    };
    if (utils$z.isStandardBrowserEnv()) {
      var xsrfValue = (config.withCredentials || isURLSameOrigin$4(fullPath)) && config.xsrfCookieName ? cookies$4.read(config.xsrfCookieName) : void 0;
      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }
    if ("setRequestHeader" in request4) {
      utils$z.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === "undefined" && key.toLowerCase() === "content-type") {
          delete requestHeaders[key];
        } else {
          request4.setRequestHeader(key, val);
        }
      });
    }
    if (!utils$z.isUndefined(config.withCredentials)) {
      request4.withCredentials = !!config.withCredentials;
    }
    if (responseType && responseType !== "json") {
      request4.responseType = config.responseType;
    }
    if (typeof config.onDownloadProgress === "function") {
      request4.addEventListener("progress", config.onDownloadProgress);
    }
    if (typeof config.onUploadProgress === "function" && request4.upload) {
      request4.upload.addEventListener("progress", config.onUploadProgress);
    }
    if (config.cancelToken || config.signal) {
      onCanceled = function(cancel2) {
        if (!request4) {
          return;
        }
        reject(!cancel2 || cancel2 && cancel2.type ? new Cancel$8("canceled") : cancel2);
        request4.abort();
        request4 = null;
      };
      config.cancelToken && config.cancelToken.subscribe(onCanceled);
      if (config.signal) {
        config.signal.aborted ? onCanceled() : config.signal.addEventListener("abort", onCanceled);
      }
    }
    if (!requestData) {
      requestData = null;
    }
    request4.send(requestData);
  });
};
var utils$y = utils$G;
var normalizeHeaderName$4 = normalizeHeaderName$5;
var enhanceError$6 = enhanceError$8;
var DEFAULT_CONTENT_TYPE$2 = {
  "Content-Type": "application/x-www-form-urlencoded"
};
function setContentTypeIfUnset$2(headers, value) {
  if (!utils$y.isUndefined(headers) && utils$y.isUndefined(headers["Content-Type"])) {
    headers["Content-Type"] = value;
  }
}
function getDefaultAdapter$2() {
  var adapter;
  if (typeof XMLHttpRequest !== "undefined") {
    adapter = xhr$2;
  } else if (typeof process !== "undefined" && Object.prototype.toString.call(process) === "[object process]") {
    adapter = xhr$2;
  }
  return adapter;
}
function stringifySafely$2(rawValue, parser, encoder) {
  if (utils$y.isString(rawValue)) {
    try {
      (parser || JSON.parse)(rawValue);
      return utils$y.trim(rawValue);
    } catch (e2) {
      if (e2.name !== "SyntaxError") {
        throw e2;
      }
    }
  }
  return (encoder || JSON.stringify)(rawValue);
}
var defaults$c = {
  transitional: {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false
  },
  adapter: getDefaultAdapter$2(),
  transformRequest: [function transformRequest(data2, headers) {
    normalizeHeaderName$4(headers, "Accept");
    normalizeHeaderName$4(headers, "Content-Type");
    if (utils$y.isFormData(data2) || utils$y.isArrayBuffer(data2) || utils$y.isBuffer(data2) || utils$y.isStream(data2) || utils$y.isFile(data2) || utils$y.isBlob(data2)) {
      return data2;
    }
    if (utils$y.isArrayBufferView(data2)) {
      return data2.buffer;
    }
    if (utils$y.isURLSearchParams(data2)) {
      setContentTypeIfUnset$2(headers, "application/x-www-form-urlencoded;charset=utf-8");
      return data2.toString();
    }
    if (utils$y.isObject(data2) || headers && headers["Content-Type"] === "application/json") {
      setContentTypeIfUnset$2(headers, "application/json");
      return stringifySafely$2(data2);
    }
    return data2;
  }],
  transformResponse: [function transformResponse(data2) {
    var transitional4 = this.transitional || defaults$c.transitional;
    var silentJSONParsing = transitional4 && transitional4.silentJSONParsing;
    var forcedJSONParsing = transitional4 && transitional4.forcedJSONParsing;
    var strictJSONParsing = !silentJSONParsing && this.responseType === "json";
    if (strictJSONParsing || forcedJSONParsing && utils$y.isString(data2) && data2.length) {
      try {
        return JSON.parse(data2);
      } catch (e2) {
        if (strictJSONParsing) {
          if (e2.name === "SyntaxError") {
            throw enhanceError$6(e2, this, "E_JSON_PARSE");
          }
          throw e2;
        }
      }
    }
    return data2;
  }],
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  },
  headers: {
    common: {
      "Accept": "application/json, text/plain, */*"
    }
  }
};
utils$y.forEach(["delete", "get", "head"], function forEachMethodNoData(method) {
  defaults$c.headers[method] = {};
});
utils$y.forEach(["post", "put", "patch"], function forEachMethodWithData(method) {
  defaults$c.headers[method] = utils$y.merge(DEFAULT_CONTENT_TYPE$2);
});
var defaults_1$2 = defaults$c;
var utils$x = utils$G;
var defaults$b = defaults_1$2;
var transformData$5 = function transformData(data2, headers, fns) {
  var context = this || defaults$b;
  utils$x.forEach(fns, function transform(fn2) {
    data2 = fn2.call(context, data2, headers);
  });
  return data2;
};
var isCancel$5 = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};
var utils$w = utils$G;
var transformData$4 = transformData$5;
var isCancel$4 = isCancel$5;
var defaults$a = defaults_1$2;
var Cancel$7 = Cancel_1$2;
function throwIfCancellationRequested$2(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
  if (config.signal && config.signal.aborted) {
    throw new Cancel$7("canceled");
  }
}
var dispatchRequest$5 = function dispatchRequest(config) {
  throwIfCancellationRequested$2(config);
  config.headers = config.headers || {};
  config.data = transformData$4.call(config, config.data, config.headers, config.transformRequest);
  config.headers = utils$w.merge(config.headers.common || {}, config.headers[config.method] || {}, config.headers);
  utils$w.forEach(["delete", "get", "head", "post", "put", "patch", "common"], function cleanHeaderConfig(method) {
    delete config.headers[method];
  });
  var adapter = config.adapter || defaults$a.adapter;
  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested$2(config);
    response.data = transformData$4.call(config, response.data, response.headers, config.transformResponse);
    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel$4(reason)) {
      throwIfCancellationRequested$2(config);
      if (reason && reason.response) {
        reason.response.data = transformData$4.call(config, reason.response.data, reason.response.headers, config.transformResponse);
      }
    }
    return Promise.reject(reason);
  });
};
var utils$v = utils$G;
var mergeConfig$8 = function mergeConfig(config1, config2) {
  config2 = config2 || {};
  var config = {};
  function getMergedValue(target, source4) {
    if (utils$v.isPlainObject(target) && utils$v.isPlainObject(source4)) {
      return utils$v.merge(target, source4);
    } else if (utils$v.isPlainObject(source4)) {
      return utils$v.merge({}, source4);
    } else if (utils$v.isArray(source4)) {
      return source4.slice();
    }
    return source4;
  }
  function mergeDeepProperties(prop) {
    if (!utils$v.isUndefined(config2[prop])) {
      return getMergedValue(config1[prop], config2[prop]);
    } else if (!utils$v.isUndefined(config1[prop])) {
      return getMergedValue(void 0, config1[prop]);
    }
  }
  function valueFromConfig2(prop) {
    if (!utils$v.isUndefined(config2[prop])) {
      return getMergedValue(void 0, config2[prop]);
    }
  }
  function defaultToConfig2(prop) {
    if (!utils$v.isUndefined(config2[prop])) {
      return getMergedValue(void 0, config2[prop]);
    } else if (!utils$v.isUndefined(config1[prop])) {
      return getMergedValue(void 0, config1[prop]);
    }
  }
  function mergeDirectKeys(prop) {
    if (prop in config2) {
      return getMergedValue(config1[prop], config2[prop]);
    } else if (prop in config1) {
      return getMergedValue(void 0, config1[prop]);
    }
  }
  var mergeMap = {
    "url": valueFromConfig2,
    "method": valueFromConfig2,
    "data": valueFromConfig2,
    "baseURL": defaultToConfig2,
    "transformRequest": defaultToConfig2,
    "transformResponse": defaultToConfig2,
    "paramsSerializer": defaultToConfig2,
    "timeout": defaultToConfig2,
    "timeoutMessage": defaultToConfig2,
    "withCredentials": defaultToConfig2,
    "adapter": defaultToConfig2,
    "responseType": defaultToConfig2,
    "xsrfCookieName": defaultToConfig2,
    "xsrfHeaderName": defaultToConfig2,
    "onUploadProgress": defaultToConfig2,
    "onDownloadProgress": defaultToConfig2,
    "decompress": defaultToConfig2,
    "maxContentLength": defaultToConfig2,
    "maxBodyLength": defaultToConfig2,
    "transport": defaultToConfig2,
    "httpAgent": defaultToConfig2,
    "httpsAgent": defaultToConfig2,
    "cancelToken": defaultToConfig2,
    "socketPath": defaultToConfig2,
    "responseEncoding": defaultToConfig2,
    "validateStatus": mergeDirectKeys
  };
  utils$v.forEach(Object.keys(config1).concat(Object.keys(config2)), function computeConfigValue(prop) {
    var merge2 = mergeMap[prop] || mergeDeepProperties;
    var configValue = merge2(prop);
    utils$v.isUndefined(configValue) && merge2 !== mergeDirectKeys || (config[prop] = configValue);
  });
  return config;
};
var data$1 = {
  "version": "0.25.0"
};
var VERSION$1 = data$1.version;
var validators$5 = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach(function(type2, i2) {
  validators$5[type2] = function validator2(thing) {
    return typeof thing === type2 || "a" + (i2 < 1 ? "n " : " ") + type2;
  };
});
var deprecatedWarnings$2 = {};
validators$5.transitional = function transitional(validator2, version2, message) {
  function formatMessage(opt, desc) {
    return "[Axios v" + VERSION$1 + "] Transitional option '" + opt + "'" + desc + (message ? ". " + message : "");
  }
  return function(value, opt, opts) {
    if (validator2 === false) {
      throw new Error(formatMessage(opt, " has been removed" + (version2 ? " in " + version2 : "")));
    }
    if (version2 && !deprecatedWarnings$2[opt]) {
      deprecatedWarnings$2[opt] = true;
      console.warn(formatMessage(opt, " has been deprecated since v" + version2 + " and will be removed in the near future"));
    }
    return validator2 ? validator2(value, opt, opts) : true;
  };
};
function assertOptions$2(options, schema, allowUnknown) {
  if (typeof options !== "object") {
    throw new TypeError("options must be an object");
  }
  var keys = Object.keys(options);
  var i2 = keys.length;
  while (i2-- > 0) {
    var opt = keys[i2];
    var validator2 = schema[opt];
    if (validator2) {
      var value = options[opt];
      var result = value === void 0 || validator2(value, opt, options);
      if (result !== true) {
        throw new TypeError("option " + opt + " must be " + result);
      }
      continue;
    }
    if (allowUnknown !== true) {
      throw Error("Unknown option " + opt);
    }
  }
}
var validator$5 = {
  assertOptions: assertOptions$2,
  validators: validators$5
};
var utils$u = utils$G;
var buildURL$6 = buildURL$8;
var InterceptorManager$4 = InterceptorManager_1$2;
var dispatchRequest$4 = dispatchRequest$5;
var mergeConfig$7 = mergeConfig$8;
var validator$4 = validator$5;
var validators$4 = validator$4.validators;
function Axios$5(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager$4(),
    response: new InterceptorManager$4()
  };
}
Axios$5.prototype.request = function request(configOrUrl, config) {
  if (typeof configOrUrl === "string") {
    config = config || {};
    config.url = configOrUrl;
  } else {
    config = configOrUrl || {};
  }
  if (!config.url) {
    throw new Error("Provided config url is not valid");
  }
  config = mergeConfig$7(this.defaults, config);
  if (config.method) {
    config.method = config.method.toLowerCase();
  } else if (this.defaults.method) {
    config.method = this.defaults.method.toLowerCase();
  } else {
    config.method = "get";
  }
  var transitional4 = config.transitional;
  if (transitional4 !== void 0) {
    validator$4.assertOptions(transitional4, {
      silentJSONParsing: validators$4.transitional(validators$4.boolean),
      forcedJSONParsing: validators$4.transitional(validators$4.boolean),
      clarifyTimeoutError: validators$4.transitional(validators$4.boolean)
    }, false);
  }
  var requestInterceptorChain = [];
  var synchronousRequestInterceptors = true;
  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    if (typeof interceptor.runWhen === "function" && interceptor.runWhen(config) === false) {
      return;
    }
    synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
    requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
  });
  var responseInterceptorChain = [];
  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
  });
  var promise;
  if (!synchronousRequestInterceptors) {
    var chain = [dispatchRequest$4, void 0];
    Array.prototype.unshift.apply(chain, requestInterceptorChain);
    chain = chain.concat(responseInterceptorChain);
    promise = Promise.resolve(config);
    while (chain.length) {
      promise = promise.then(chain.shift(), chain.shift());
    }
    return promise;
  }
  var newConfig = config;
  while (requestInterceptorChain.length) {
    var onFulfilled = requestInterceptorChain.shift();
    var onRejected = requestInterceptorChain.shift();
    try {
      newConfig = onFulfilled(newConfig);
    } catch (error2) {
      onRejected(error2);
      break;
    }
  }
  try {
    promise = dispatchRequest$4(newConfig);
  } catch (error2) {
    return Promise.reject(error2);
  }
  while (responseInterceptorChain.length) {
    promise = promise.then(responseInterceptorChain.shift(), responseInterceptorChain.shift());
  }
  return promise;
};
Axios$5.prototype.getUri = function getUri(config) {
  if (!config.url) {
    throw new Error("Provided config url is not valid");
  }
  config = mergeConfig$7(this.defaults, config);
  return buildURL$6(config.url, config.params, config.paramsSerializer).replace(/^\?/, "");
};
utils$u.forEach(["delete", "get", "head", "options"], function forEachMethodNoData2(method) {
  Axios$5.prototype[method] = function(url, config) {
    return this.request(mergeConfig$7(config || {}, {
      method,
      url,
      data: (config || {}).data
    }));
  };
});
utils$u.forEach(["post", "put", "patch"], function forEachMethodWithData2(method) {
  Axios$5.prototype[method] = function(url, data2, config) {
    return this.request(mergeConfig$7(config || {}, {
      method,
      url,
      data: data2
    }));
  };
});
var Axios_1$2 = Axios$5;
var Cancel$6 = Cancel_1$2;
function CancelToken$2(executor) {
  if (typeof executor !== "function") {
    throw new TypeError("executor must be a function.");
  }
  var resolvePromise;
  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });
  var token = this;
  this.promise.then(function(cancel2) {
    if (!token._listeners)
      return;
    var i2;
    var l2 = token._listeners.length;
    for (i2 = 0; i2 < l2; i2++) {
      token._listeners[i2](cancel2);
    }
    token._listeners = null;
  });
  this.promise.then = function(onfulfilled) {
    var _resolve;
    var promise = new Promise(function(resolve) {
      token.subscribe(resolve);
      _resolve = resolve;
    }).then(onfulfilled);
    promise.cancel = function reject() {
      token.unsubscribe(_resolve);
    };
    return promise;
  };
  executor(function cancel2(message) {
    if (token.reason) {
      return;
    }
    token.reason = new Cancel$6(message);
    resolvePromise(token.reason);
  });
}
CancelToken$2.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};
CancelToken$2.prototype.subscribe = function subscribe(listener) {
  if (this.reason) {
    listener(this.reason);
    return;
  }
  if (this._listeners) {
    this._listeners.push(listener);
  } else {
    this._listeners = [listener];
  }
};
CancelToken$2.prototype.unsubscribe = function unsubscribe(listener) {
  if (!this._listeners) {
    return;
  }
  var index2 = this._listeners.indexOf(listener);
  if (index2 !== -1) {
    this._listeners.splice(index2, 1);
  }
};
CancelToken$2.source = function source() {
  var cancel2;
  var token = new CancelToken$2(function executor(c2) {
    cancel2 = c2;
  });
  return {
    token,
    cancel: cancel2
  };
};
var CancelToken_1$2 = CancelToken$2;
var spread$2 = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};
var utils$t = utils$G;
var isAxiosError$2 = function isAxiosError(payload) {
  return utils$t.isObject(payload) && payload.isAxiosError === true;
};
var utils$s = utils$G;
var bind$6 = bind$8;
var Axios$4 = Axios_1$2;
var mergeConfig$6 = mergeConfig$8;
var defaults$9 = defaults_1$2;
function createInstance$2(defaultConfig) {
  var context = new Axios$4(defaultConfig);
  var instance = bind$6(Axios$4.prototype.request, context);
  utils$s.extend(instance, Axios$4.prototype, context);
  utils$s.extend(instance, context);
  instance.create = function create3(instanceConfig) {
    return createInstance$2(mergeConfig$6(defaultConfig, instanceConfig));
  };
  return instance;
}
var axios$7 = createInstance$2(defaults$9);
axios$7.Axios = Axios$4;
axios$7.Cancel = Cancel_1$2;
axios$7.CancelToken = CancelToken_1$2;
axios$7.isCancel = isCancel$5;
axios$7.VERSION = data$1.version;
axios$7.all = function all(promises) {
  return Promise.all(promises);
};
axios$7.spread = spread$2;
axios$7.isAxiosError = isAxiosError$2;
axios$8.exports = axios$7;
axios$8.exports.default = axios$7;
var axios$6 = axios$8.exports;
const nhostApiClient = (backendUrl) => {
  const client = axios$6.create({ baseURL: backendUrl });
  client.interceptors.response.use((response) => response, (error2) => {
    var _a2, _b, _c, _d, _e, _f, _g, _h, _i, _j;
    return Promise.reject({
      error: {
        message: (_e = (_d = (_c = (_b = (_a2 = error2.response) == null ? void 0 : _a2.data) == null ? void 0 : _b.message) != null ? _c : error2.message) != null ? _d : error2.request.responseText) != null ? _e : JSON.stringify(error2),
        status: (_i = (_h = (_f = error2.response) == null ? void 0 : _f.status) != null ? _h : (_g = error2.response) == null ? void 0 : _g.data.statusCode) != null ? _i : NETWORK_ERROR_CODE,
        error: ((_j = error2.response) == null ? void 0 : _j.data.error) || error2.request.statusText || "network"
      }
    });
  });
  return client;
};
const encodeQueryParameters = (baseUrl, parameters) => {
  const encodedParameters = parameters && Object.entries(parameters).map(([key, value]) => {
    const stringValue = Array.isArray(value) ? value.join(",") : typeof value === "object" ? JSON.stringify(value) : value;
    return `${key}=${encodeURIComponent(stringValue)}`;
  }).join("&");
  if (encodedParameters)
    return `${baseUrl}?${encodedParameters}`;
  else
    return baseUrl;
};
const rewriteRedirectTo = (clientUrl, options) => {
  var _a2;
  return (options == null ? void 0 : options.redirectTo) ? __spreadProps(__spreadValues({}, options), {
    redirectTo: ((_a2 = options == null ? void 0 : options.redirectTo) == null ? void 0 : _a2.startsWith("/")) ? clientUrl + options.redirectTo : options == null ? void 0 : options.redirectTo
  }) : options;
};
const isValidEmail = (email) => !!email && typeof email === "string" && !!String(email).toLowerCase().match(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
const isValidPassword = (password) => !!password && typeof password === "string" && password.length >= MIN_PASSWORD_LENGTH;
const isValidPhoneNumber = (phoneNumber) => !!phoneNumber && typeof phoneNumber === "string";
const INITIAL_MACHINE_CONTEXT = {
  user: null,
  mfa: null,
  accessToken: {
    value: null,
    expiresAt: new Date()
  },
  refreshTimer: {
    elapsed: 0,
    attempts: 0
  },
  refreshToken: {
    value: null
  },
  errors: {}
};
const createChangeEmailMachine = ({ backendUrl, clientUrl, interpreter }) => {
  const api = nhostApiClient(backendUrl);
  return createMachine({
    schema: {
      context: {},
      events: {}
    },
    tsTypes: {},
    preserveActionOrder: true,
    id: "changeEmail",
    initial: "idle",
    context: { error: null },
    states: {
      idle: {
        on: {
          REQUEST: [
            {
              cond: "invalidEmail",
              actions: "saveInvalidEmailError",
              target: ".error"
            },
            {
              target: "requesting"
            }
          ]
        },
        initial: "initial",
        states: {
          initial: {},
          success: {},
          error: {}
        }
      },
      requesting: {
        invoke: {
          src: "requestChange",
          id: "requestChange",
          onDone: { target: "idle.success", actions: "reportSuccess" },
          onError: { actions: ["saveRequestError", "reportError"], target: "idle.error" }
        }
      }
    }
  }, {
    actions: {
      saveInvalidEmailError: assign$1({ error: (_2) => INVALID_EMAIL_ERROR }),
      saveRequestError: assign$1({
        error: (_2, { data: { error: error2 } }) => error2
      }),
      reportError: send((ctx) => ({ type: "ERROR", error: ctx.error })),
      reportSuccess: send("SUCCESS")
    },
    guards: {
      invalidEmail: (_2, { email }) => !isValidEmail(email)
    },
    services: {
      requestChange: async (_2, { email, options }) => {
        const res = await api.post("/user/email/change", {
          newEmail: email,
          options: rewriteRedirectTo(clientUrl, options)
        }, {
          headers: {
            authorization: `Bearer ${interpreter == null ? void 0 : interpreter.state.context.accessToken.value}`
          }
        });
        return res.data;
      }
    }
  });
};
const createChangePasswordMachine = ({ backendUrl, interpreter }) => {
  const api = nhostApiClient(backendUrl);
  return createMachine({
    schema: {
      context: {},
      events: {}
    },
    tsTypes: {},
    preserveActionOrder: true,
    id: "changePassword",
    initial: "idle",
    context: { error: null },
    states: {
      idle: {
        on: {
          REQUEST: [
            {
              cond: "invalidPassword",
              actions: "saveInvalidPasswordError",
              target: ".error"
            },
            {
              target: "requesting"
            }
          ]
        },
        initial: "initial",
        states: {
          initial: {},
          success: {},
          error: {}
        }
      },
      requesting: {
        invoke: {
          src: "requestChange",
          id: "requestChange",
          onDone: { target: "idle.success", actions: "reportSuccess" },
          onError: { actions: ["saveRequestError", "reportError"], target: "idle.error" }
        }
      }
    }
  }, {
    actions: {
      saveInvalidPasswordError: assign$1({ error: (_2) => INVALID_PASSWORD_ERROR }),
      saveRequestError: assign$1({
        error: (_2, { data: { error: error2 } }) => {
          console.log(error2);
          return error2;
        }
      }),
      reportError: send((ctx) => ({ type: "ERROR", error: ctx.error })),
      reportSuccess: send("SUCCESS")
    },
    guards: {
      invalidPassword: (_2, { password }) => !isValidPassword(password)
    },
    services: {
      requestChange: (_2, { password }) => api.post("/user/password", { newPassword: password }, {
        headers: {
          authorization: `Bearer ${interpreter == null ? void 0 : interpreter.state.context.accessToken.value}`
        }
      })
    }
  });
};
const createEnableMfaMachine = ({ backendUrl, interpreter }) => {
  const api = nhostApiClient(backendUrl);
  return createMachine({
    schema: {
      context: {},
      events: {}
    },
    tsTypes: {},
    preserveActionOrder: true,
    id: "enableMfa",
    initial: "idle",
    context: { error: null, imageUrl: null, secret: null },
    states: {
      idle: {
        initial: "initial",
        on: {
          GENERATE: "generating"
        },
        states: {
          initial: {},
          error: {}
        }
      },
      generating: {
        invoke: {
          src: "generate",
          id: "generate",
          onDone: { target: "generated", actions: ["reportGeneratedSuccess", "saveGeneration"] },
          onError: { actions: ["saveError", "reportGeneratedError"], target: "idle.error" }
        }
      },
      generated: {
        initial: "idle",
        states: {
          idle: {
            initial: "idle",
            on: {
              ACTIVATE: [
                {
                  cond: "invalidMfaType",
                  actions: "saveInvalidMfaTypeError",
                  target: ".error"
                },
                {
                  target: "activating"
                }
              ]
            },
            states: { idle: {}, error: {} }
          },
          activating: {
            invoke: {
              src: "activate",
              id: "activate",
              onDone: { target: "activated", actions: "reportSuccess" },
              onError: { actions: ["saveError", "reportError"], target: "idle.error" }
            }
          },
          activated: { type: "final" }
        }
      }
    }
  }, {
    actions: {
      saveInvalidMfaTypeError: assign$1({ error: (_2) => INVALID_MFA_TYPE_ERROR }),
      saveError: assign$1({
        error: (_2, { data: { error: error2 } }) => error2
      }),
      saveGeneration: assign$1({
        imageUrl: (_2, { data: { imageUrl } }) => imageUrl,
        secret: (_2, { data: { totpSecret } }) => totpSecret
      }),
      reportError: send((ctx) => ({ type: "ERROR", error: ctx.error })),
      reportSuccess: send("SUCCESS"),
      reportGeneratedSuccess: send("GENERATED"),
      reportGeneratedError: send((ctx) => ({ type: "GENERATED_ERROR", error: ctx.error }))
    },
    guards: {
      invalidMfaType: (_2, { activeMfaType }) => !activeMfaType || activeMfaType !== "totp"
    },
    services: {
      generate: async (_2) => {
        const { data: data2 } = await api.get("/mfa/totp/generate", {
          headers: {
            authorization: `Bearer ${interpreter == null ? void 0 : interpreter.state.context.accessToken.value}`
          }
        });
        return data2;
      },
      activate: (_2, { code, activeMfaType }) => api.post("/user/mfa", {
        code,
        activeMfaType
      }, {
        headers: {
          authorization: `Bearer ${interpreter == null ? void 0 : interpreter.state.context.accessToken.value}`
        }
      })
    }
  });
};
const createResetPasswordMachine = ({ backendUrl, clientUrl }) => {
  const api = nhostApiClient(backendUrl);
  return createMachine({
    schema: {
      context: {},
      events: {}
    },
    tsTypes: {},
    preserveActionOrder: true,
    id: "changePassword",
    initial: "idle",
    context: { error: null },
    states: {
      idle: {
        on: {
          REQUEST: "requesting"
        },
        initial: "initial",
        states: {
          initial: {},
          success: {},
          error: {}
        }
      },
      requesting: {
        invoke: {
          src: "requestChange",
          id: "requestChange",
          onDone: { target: "idle.success", actions: "reportSuccess" },
          onError: { actions: ["saveRequestError", "reportError"], target: "idle.error" }
        }
      }
    }
  }, {
    actions: {
      saveRequestError: assign$1({
        error: (_2, { data: { error: error2 } }) => {
          console.log(error2);
          return error2;
        }
      }),
      reportError: send((ctx) => ({ type: "ERROR", error: ctx.error })),
      reportSuccess: send("SUCCESS")
    },
    services: {
      requestChange: (_2, { email, options }) => api.post("/user/password/reset", {
        email,
        options: rewriteRedirectTo(clientUrl, options)
      })
    }
  });
};
const createSendVerificationEmailMachine = ({
  backendUrl,
  clientUrl,
  interpreter
}) => {
  const api = nhostApiClient(backendUrl);
  return createMachine({
    schema: {
      context: {},
      events: {}
    },
    tsTypes: {},
    preserveActionOrder: true,
    id: "sendVerificationEmail",
    initial: "idle",
    context: { error: null },
    states: {
      idle: {
        on: {
          REQUEST: [
            {
              cond: "invalidEmail",
              actions: "saveInvalidEmailError",
              target: ".error"
            },
            {
              target: "requesting"
            }
          ]
        },
        initial: "initial",
        states: {
          initial: {},
          success: {},
          error: {}
        }
      },
      requesting: {
        invoke: {
          src: "request",
          id: "request",
          onDone: { target: "idle.success", actions: "reportSuccess" },
          onError: { actions: ["saveRequestError", "reportError"], target: "idle.error" }
        }
      }
    }
  }, {
    actions: {
      saveInvalidEmailError: assign$1({ error: (_2) => INVALID_EMAIL_ERROR }),
      saveRequestError: assign$1({
        error: (_2, { data: { error: error2 } }) => error2
      }),
      reportError: send((ctx) => ({ type: "ERROR", error: ctx.error })),
      reportSuccess: send("SUCCESS")
    },
    guards: {
      invalidEmail: (_2, { email }) => !isValidEmail(email)
    },
    services: {
      request: async (_2, { email, options }) => {
        const res = await api.post("/user/email/send-verification-email", {
          email,
          options: rewriteRedirectTo(clientUrl, options)
        });
        return res.data;
      }
    }
  });
};
const createAuthMachine = ({
  backendUrl,
  clientUrl,
  clientStorageGetter,
  clientStorageSetter,
  refreshIntervalTime,
  autoRefreshToken = true,
  autoSignIn = true
}) => {
  const api = nhostApiClient(backendUrl);
  const postRequest = async (url, data2, config) => {
    const result = await api.post(url, data2, config);
    return result.data;
  };
  return createMachine({
    schema: {
      context: {},
      events: {}
    },
    tsTypes: {},
    context: INITIAL_MACHINE_CONTEXT,
    preserveActionOrder: true,
    id: "nhost",
    type: "parallel",
    states: {
      authentication: {
        initial: "checkAutoSignIn",
        on: {
          SESSION_UPDATE: [
            {
              cond: "hasSession",
              actions: ["saveSession", "persist", "resetTimer", "reportTokenChanged"],
              target: ".signedIn"
            }
          ]
        },
        states: {
          checkAutoSignIn: {
            always: [{ cond: "isAutoSignInDisabled", target: "importingRefreshToken" }],
            invoke: {
              id: "autoSignIn",
              src: "autoSignIn",
              onDone: {
                target: "signedIn",
                actions: ["saveSession", "persist", "reportTokenChanged"]
              },
              onError: "importingRefreshToken"
            }
          },
          importingRefreshToken: {
            invoke: {
              id: "importRefreshToken",
              src: "importRefreshToken",
              onDone: { actions: "saveRefreshToken", target: "starting" }
            }
          },
          starting: {
            always: [
              {
                cond: "isSignedIn",
                target: "signedIn"
              },
              {
                cond: "hasRefreshTokenWithoutSession",
                target: ["authenticating.token", "#nhost.token.running"]
              },
              "signedOut"
            ]
          },
          signedOut: {
            tags: ["ready"],
            initial: "noErrors",
            entry: "reportSignedOut",
            states: {
              noErrors: {},
              success: {},
              needsEmailVerification: {},
              needsSmsOtp: {},
              needsMfa: {},
              failed: {
                exit: "resetAuthenticationError",
                initial: "server",
                states: {
                  server: {},
                  validation: {
                    states: {
                      password: {},
                      email: {},
                      phoneNumber: {}
                    }
                  }
                }
              },
              signingOut: {
                entry: "destroyToken",
                exit: "clearContext",
                invoke: {
                  src: "signout",
                  id: "signingOut",
                  onDone: {
                    target: "success"
                  },
                  onError: {
                    target: "failed.server"
                  }
                }
              }
            },
            on: {
              SIGNIN_PASSWORD: [
                {
                  cond: "invalidEmail",
                  actions: ["saveInvalidEmail"],
                  target: ".failed.validation.email"
                },
                {
                  cond: "invalidPassword",
                  actions: ["saveInvalidPassword"],
                  target: ".failed.validation.password"
                },
                "#nhost.authentication.authenticating.password"
              ],
              SIGNIN_PASSWORDLESS_EMAIL: [
                {
                  cond: "invalidEmail",
                  actions: "saveInvalidEmail",
                  target: ".failed.validation.email"
                },
                "#nhost.authentication.authenticating.passwordlessEmail"
              ],
              SIGNIN_PASSWORDLESS_SMS: [
                {
                  cond: "invalidPhoneNumber",
                  actions: "saveInvalidPhoneNumber",
                  target: ".failed.validation.phoneNumber"
                },
                "#nhost.authentication.authenticating.passwordlessSms"
              ],
              SIGNIN_PASSWORDLESS_SMS_OTP: [
                {
                  cond: "invalidPhoneNumber",
                  actions: "saveInvalidPhoneNumber",
                  target: ".failed.validation.phoneNumber"
                },
                "#nhost.authentication.authenticating.passwordlessSmsOtp"
              ],
              SIGNUP_EMAIL_PASSWORD: [
                {
                  cond: "invalidEmail",
                  actions: "saveInvalidSignUpEmail",
                  target: ".failed.validation.email"
                },
                {
                  cond: "invalidPassword",
                  actions: "saveInvalidSignUpPassword",
                  target: ".failed.validation.password"
                },
                "#nhost.authentication.registering"
              ],
              SIGNIN_ANONYMOUS: "#nhost.authentication.authenticating.anonymous",
              SIGNIN_MFA_TOTP: [
                {
                  cond: "noMfaTicket",
                  actions: ["saveNoMfaTicketError"],
                  target: ".failed"
                },
                "#nhost.authentication.authenticating.mfa.totp"
              ]
            }
          },
          authenticating: {
            states: {
              passwordlessEmail: {
                invoke: {
                  src: "signInPasswordlessEmail",
                  id: "authenticatePasswordlessEmail",
                  onDone: "#nhost.authentication.signedOut.needsEmailVerification",
                  onError: {
                    actions: "saveAuthenticationError",
                    target: "#nhost.authentication.signedOut.failed.server"
                  }
                }
              },
              passwordlessSms: {
                invoke: {
                  src: "signInPasswordlessSms",
                  id: "authenticatePasswordlessSms",
                  onDone: "#nhost.authentication.signedOut.needsSmsOtp",
                  onError: {
                    actions: "saveAuthenticationError",
                    target: "#nhost.authentication.signedOut.failed.server"
                  }
                }
              },
              passwordlessSmsOtp: {
                invoke: {
                  src: "signInPasswordlessSmsOtp",
                  id: "authenticatePasswordlessSmsOtp",
                  onDone: {
                    actions: ["saveSession", "persist", "reportTokenChanged"],
                    target: "#nhost.authentication.signedIn"
                  },
                  onError: {
                    actions: "saveAuthenticationError",
                    target: "#nhost.authentication.signedOut.failed.server"
                  }
                }
              },
              password: {
                invoke: {
                  src: "signInPassword",
                  id: "authenticateUserWithPassword",
                  onDone: [
                    {
                      cond: "hasMfaTicket",
                      actions: ["saveMfaTicket"],
                      target: "#nhost.authentication.signedOut.needsMfa"
                    },
                    {
                      actions: ["saveSession", "persist", "reportTokenChanged"],
                      target: "#nhost.authentication.signedIn"
                    }
                  ],
                  onError: [
                    {
                      cond: "unverified",
                      target: "#nhost.authentication.signedOut.needsEmailVerification"
                    },
                    {
                      actions: "saveAuthenticationError",
                      target: "#nhost.authentication.signedOut.failed.server"
                    }
                  ]
                }
              },
              token: {},
              anonymous: {
                invoke: {
                  src: "signInAnonymous",
                  id: "authenticateAnonymously",
                  onDone: {
                    actions: ["saveSession", "persist", "reportTokenChanged"],
                    target: "#nhost.authentication.signedIn"
                  },
                  onError: {
                    actions: "saveAuthenticationError",
                    target: "#nhost.authentication.signedOut.failed.server"
                  }
                }
              },
              mfa: {
                states: {
                  totp: {
                    invoke: {
                      src: "signInMfaTotp",
                      id: "signInMfaTotp",
                      onDone: {
                        actions: ["saveSession", "persist", "reportTokenChanged"],
                        target: "#nhost.authentication.signedIn"
                      },
                      onError: {
                        actions: ["saveAuthenticationError"],
                        target: "#nhost.authentication.signedOut.failed.server"
                      }
                    }
                  }
                }
              }
            }
          },
          registering: {
            entry: "resetSignUpError",
            invoke: {
              src: "registerUser",
              id: "registerUser",
              onDone: [
                {
                  cond: "hasSession",
                  target: "#nhost.authentication.signedIn",
                  actions: ["saveSession", "persist", "reportTokenChanged"]
                },
                {
                  target: "#nhost.authentication.signedOut.needsEmailVerification"
                }
              ],
              onError: [
                {
                  cond: "unverified",
                  target: "#nhost.authentication.signedOut.needsEmailVerification"
                },
                {
                  actions: "saveRegisrationError",
                  target: "#nhost.authentication.signedOut.failed.server"
                }
              ]
            }
          },
          signedIn: {
            tags: ["ready"],
            type: "parallel",
            entry: "reportSignedIn",
            on: {
              SIGNOUT: "#nhost.authentication.signedOut.signingOut",
              DEANONYMIZE: {
                target: ".deanonymizing"
              }
            },
            states: {
              refreshTimer: {
                id: "timer",
                initial: "idle",
                states: {
                  disabled: { type: "final" },
                  stopped: {
                    always: {
                      cond: "noToken",
                      target: "idle"
                    }
                  },
                  idle: {
                    always: [
                      { cond: "isAutoRefreshDisabled", target: "disabled" },
                      {
                        cond: "hasRefreshToken",
                        target: "running"
                      }
                    ]
                  },
                  running: {
                    initial: "pending",
                    entry: "resetTimer",
                    states: {
                      pending: {
                        after: {
                          "1000": {
                            actions: "tickRefreshTimer",
                            internal: false,
                            target: "pending"
                          }
                        },
                        always: {
                          cond: "refreshTimerShouldRefresh",
                          target: "refreshing"
                        }
                      },
                      refreshing: {
                        invoke: {
                          src: "refreshToken",
                          id: "refreshToken",
                          onDone: {
                            actions: ["saveSession", "persist", "resetTimer"],
                            target: "pending"
                          },
                          onError: []
                        }
                      }
                    }
                  }
                }
              },
              deanonymizing: {
                initial: "error",
                states: {
                  error: {},
                  success: {}
                }
              }
            }
          }
        }
      },
      token: {
        initial: "idle",
        states: {
          idle: {
            on: {
              TRY_TOKEN: "running"
            },
            initial: "noErrors",
            states: { noErrors: {}, error: {} }
          },
          running: {
            invoke: {
              src: "refreshToken",
              id: "authenticateWithToken",
              onDone: {
                actions: ["saveSession", "persist", "reportTokenChanged"],
                target: ["#nhost.authentication.signedIn", "idle.noErrors"]
              },
              onError: [
                { cond: "isSignedIn", target: "idle.error" },
                {
                  target: ["#nhost.authentication.signedOut", "idle.error"]
                }
              ]
            }
          }
        }
      }
    }
  }, {
    actions: {
      reportSignedIn: send("SIGNED_IN"),
      reportSignedOut: send("SIGNED_OUT"),
      reportTokenChanged: send("TOKEN_CHANGED"),
      clearContext: assign$1(() => INITIAL_MACHINE_CONTEXT),
      saveSession: assign$1({
        user: (_2, e2) => {
          var _a2, _b;
          return (_b = (_a2 = e2.data) == null ? void 0 : _a2.session) == null ? void 0 : _b.user;
        },
        accessToken: (_2, e2) => {
          var _a2, _b, _c, _d;
          return {
            value: (_b = (_a2 = e2.data) == null ? void 0 : _a2.session) == null ? void 0 : _b.accessToken,
            expiresAt: new Date(Date.now() + ((_d = (_c = e2.data) == null ? void 0 : _c.session) == null ? void 0 : _d.accessTokenExpiresIn) * 1e3)
          };
        },
        refreshToken: (_2, e2) => {
          var _a2, _b;
          return { value: (_b = (_a2 = e2.data) == null ? void 0 : _a2.session) == null ? void 0 : _b.refreshToken };
        }
      }),
      saveMfaTicket: assign$1({
        mfa: (_2, e2) => {
          var _a2, _b;
          return (_b = (_a2 = e2.data) == null ? void 0 : _a2.mfa) != null ? _b : null;
        }
      }),
      resetTimer: assign$1({
        refreshTimer: (ctx, e2) => {
          return {
            elapsed: 0,
            attempts: 0
          };
        }
      }),
      tickRefreshTimer: assign$1({
        refreshTimer: (ctx, e2) => {
          return {
            elapsed: ctx.refreshTimer.elapsed + 1,
            attempts: ctx.refreshTimer.attempts
          };
        }
      }),
      saveAuthenticationError: assign$1({
        errors: ({ errors }, { data: { error: error2 } }) => __spreadProps(__spreadValues({}, errors), { authentication: error2 })
      }),
      resetAuthenticationError: assign$1({
        errors: (_a2) => {
          var { errors: _b } = _a2, _c = _b, { authentication } = _c, errors = __objRest(_c, ["authentication"]);
          return errors;
        }
      }),
      saveInvalidEmail: assign$1({
        errors: ({ errors }) => __spreadProps(__spreadValues({}, errors), { authentication: INVALID_EMAIL_ERROR })
      }),
      saveInvalidPassword: assign$1({
        errors: ({ errors }) => __spreadProps(__spreadValues({}, errors), { authentication: INVALID_PASSWORD_ERROR })
      }),
      saveInvalidPhoneNumber: assign$1({
        errors: ({ errors }) => __spreadProps(__spreadValues({}, errors), { authentication: INVALID_PHONE_NUMBER_ERROR })
      }),
      saveRegisrationError: assign$1({
        errors: ({ errors }, { data: { error: error2 } }) => __spreadProps(__spreadValues({}, errors), { registration: error2 })
      }),
      resetSignUpError: assign$1({
        errors: (_d) => {
          var { errors: _e } = _d, _f = _e, { registration } = _f, errors = __objRest(_f, ["registration"]);
          return errors;
        }
      }),
      saveInvalidSignUpPassword: assign$1({
        errors: ({ errors }) => __spreadProps(__spreadValues({}, errors), { registration: INVALID_EMAIL_ERROR })
      }),
      saveInvalidSignUpEmail: assign$1({
        errors: ({ errors }) => __spreadProps(__spreadValues({}, errors), { registration: INVALID_PASSWORD_ERROR })
      }),
      saveNoMfaTicketError: assign$1({
        errors: ({ errors }) => __spreadProps(__spreadValues({}, errors), { registration: NO_MFA_TICKET_ERROR })
      }),
      saveRefreshToken: assign$1({
        accessToken: (ctx, e2) => __spreadProps(__spreadValues({}, ctx.accessToken), { expiresAt: e2.data.expiresAt }),
        refreshToken: (ctx, e2) => __spreadProps(__spreadValues({}, ctx.refreshToken), { value: e2.data.refreshToken })
      }),
      persist: (_2, { data: data2 }) => {
        clientStorageSetter(NHOST_REFRESH_TOKEN_KEY, data2.session.refreshToken);
        if (data2.session.accessTokenExpiresIn) {
          const nextRefresh = new Date(Date.now() + data2.session.accessTokenExpiresIn * 1e3).toISOString();
          clientStorageSetter(NHOST_JWT_EXPIRES_AT_KEY, nextRefresh);
        } else {
          clientStorageSetter(NHOST_JWT_EXPIRES_AT_KEY, null);
        }
      },
      destroyToken: () => {
        clientStorageSetter(NHOST_REFRESH_TOKEN_KEY, null);
        clientStorageSetter(NHOST_JWT_EXPIRES_AT_KEY, null);
      }
    },
    guards: {
      isSignedIn: (ctx) => !!ctx.user && !!ctx.refreshToken.value && !!ctx.accessToken.value,
      hasRefreshTokenWithoutSession: (ctx) => !!ctx.refreshToken.value && !ctx.user && !ctx.accessToken.value,
      noToken: (ctx) => !ctx.refreshToken.value,
      noMfaTicket: (ctx, { ticket }) => {
        var _a2;
        return !ticket && !((_a2 = ctx.mfa) == null ? void 0 : _a2.ticket);
      },
      hasRefreshToken: (ctx) => !!ctx.refreshToken.value,
      isAutoRefreshDisabled: () => !autoRefreshToken,
      isAutoSignInDisabled: () => !autoSignIn,
      refreshTimerShouldRefresh: (ctx) => ctx.refreshTimer.elapsed > Math.max((Date.now() - ctx.accessToken.expiresAt.getTime()) / 1e3 - TOKEN_REFRESH_MARGIN, refreshIntervalTime),
      unverified: (_2, { data: { error: error2 } }) => error2.status === 401 && error2.message === "Email is not verified",
      hasSession: (_2, e2) => {
        var _a2;
        return !!((_a2 = e2.data) == null ? void 0 : _a2.session);
      },
      hasMfaTicket: (_2, e2) => {
        var _a2;
        return !!((_a2 = e2.data) == null ? void 0 : _a2.mfa);
      },
      invalidEmail: (_2, { email }) => !isValidEmail(email),
      invalidPassword: (_2, { password }) => !isValidPassword(password),
      invalidPhoneNumber: (_2, { phoneNumber }) => !isValidPhoneNumber(phoneNumber)
    },
    services: {
      signInPassword: (_2, { email, password }) => postRequest("/signin/email-password", {
        email,
        password
      }),
      signInPasswordlessSms: (_2, { phoneNumber, options }) => postRequest("/signin/passwordless/sms", {
        phoneNumber,
        options: rewriteRedirectTo(clientUrl, options)
      }),
      signInPasswordlessSmsOtp: (_2, { phoneNumber, otp }) => postRequest("/signin/passwordless/sms/otp", {
        phoneNumber,
        otp
      }),
      signInPasswordlessEmail: (_2, { email, options }) => postRequest("/signin/passwordless/email", {
        email,
        options: rewriteRedirectTo(clientUrl, options)
      }),
      signInAnonymous: (_2) => postRequest("/signin/anonymous"),
      signInMfaTotp: (context, { ticket, otp }) => {
        var _a2;
        return postRequest("/signin/mfa/totp", {
          ticket: ticket || ((_a2 = context.mfa) == null ? void 0 : _a2.ticket),
          otp
        });
      },
      refreshToken: async (ctx, event) => {
        const refreshToken = event.type === "TRY_TOKEN" ? event.token : ctx.refreshToken.value;
        const session = await postRequest("/token", {
          refreshToken
        });
        return { session };
      },
      signout: (ctx, e2) => postRequest("/signout", {
        refreshToken: ctx.refreshToken.value,
        all: !!e2.all
      }),
      registerUser: (_2, { email, password, options }) => postRequest("/signup/email-password", {
        email,
        password,
        options: rewriteRedirectTo(clientUrl, options)
      }),
      autoSignIn: async () => {
        if (typeof window === "undefined" || !window.location)
          throw Error("window is undefined or location does not exist");
        const { hash } = window.location;
        if (!hash)
          throw Error("No hash in window.location");
        const params = new URLSearchParams(hash.slice(1));
        const refreshToken = params.get("refreshToken");
        if (!refreshToken)
          throw Error("No refresh token in the location hash");
        const session = await postRequest("/token", {
          refreshToken
        });
        const channel = new BroadcastChannel$1("nhost");
        channel.postMessage(refreshToken);
        return { session };
      },
      importRefreshToken: async () => {
        const stringExpiresAt = await clientStorageGetter(NHOST_JWT_EXPIRES_AT_KEY);
        const expiresAt = stringExpiresAt ? new Date(stringExpiresAt) : null;
        const refreshToken = await clientStorageGetter(NHOST_REFRESH_TOKEN_KEY);
        return { refreshToken, expiresAt };
      }
    }
  });
};
/*! js-cookie v3.0.1 | MIT */
function assign(target) {
  for (var i2 = 1; i2 < arguments.length; i2++) {
    var source4 = arguments[i2];
    for (var key in source4) {
      target[key] = source4[key];
    }
  }
  return target;
}
var defaultConverter = {
  read: function(value) {
    if (value[0] === '"') {
      value = value.slice(1, -1);
    }
    return value.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
  },
  write: function(value) {
    return encodeURIComponent(value).replace(/%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g, decodeURIComponent);
  }
};
function init(converter, defaultAttributes) {
  function set(key, value, attributes) {
    if (typeof document === "undefined") {
      return;
    }
    attributes = assign({}, defaultAttributes, attributes);
    if (typeof attributes.expires === "number") {
      attributes.expires = new Date(Date.now() + attributes.expires * 864e5);
    }
    if (attributes.expires) {
      attributes.expires = attributes.expires.toUTCString();
    }
    key = encodeURIComponent(key).replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent).replace(/[()]/g, escape);
    var stringifiedAttributes = "";
    for (var attributeName in attributes) {
      if (!attributes[attributeName]) {
        continue;
      }
      stringifiedAttributes += "; " + attributeName;
      if (attributes[attributeName] === true) {
        continue;
      }
      stringifiedAttributes += "=" + attributes[attributeName].split(";")[0];
    }
    return document.cookie = key + "=" + converter.write(value, key) + stringifiedAttributes;
  }
  function get(key) {
    if (typeof document === "undefined" || arguments.length && !key) {
      return;
    }
    var cookies2 = document.cookie ? document.cookie.split("; ") : [];
    var jar = {};
    for (var i2 = 0; i2 < cookies2.length; i2++) {
      var parts = cookies2[i2].split("=");
      var value = parts.slice(1).join("=");
      try {
        var foundKey = decodeURIComponent(parts[0]);
        jar[foundKey] = converter.read(value, foundKey);
        if (key === foundKey) {
          break;
        }
      } catch (e2) {
      }
    }
    return key ? jar[key] : jar;
  }
  return Object.create({
    set,
    get,
    remove: function(key, attributes) {
      set(key, "", assign({}, attributes, {
        expires: -1
      }));
    },
    withAttributes: function(attributes) {
      return init(this.converter, assign({}, this.attributes, attributes));
    },
    withConverter: function(converter2) {
      return init(assign({}, this.converter, converter2), this.attributes);
    }
  }, {
    attributes: { value: Object.freeze(defaultAttributes) },
    converter: { value: Object.freeze(converter) }
  });
}
init(defaultConverter, { path: "/" });
const isBrowser$1 = typeof window !== "undefined";
const inMemoryLocalStorage = /* @__PURE__ */ new Map();
const defaultClientStorageGetter = (key) => {
  var _a2;
  if (isBrowser$1 && localStorage)
    return localStorage.getItem(key);
  else
    return (_a2 = inMemoryLocalStorage.get(key)) != null ? _a2 : null;
};
const defaultClientStorageSetter = (key, value) => {
  if (isBrowser$1 && localStorage) {
    if (value) {
      localStorage.setItem(key, value);
    } else {
      localStorage.removeItem(key);
    }
  } else {
    if (value) {
      inMemoryLocalStorage.set(key, value);
    } else if (inMemoryLocalStorage.has(key)) {
      inMemoryLocalStorage.delete(key);
    }
  }
};
class AuthClient {
  constructor({
    backendUrl,
    clientUrl = typeof window !== "undefined" && ((_a2) => (_a2 = window.location) == null ? void 0 : _a2.origin)() || "",
    clientStorageGetter = defaultClientStorageGetter,
    clientStorageSetter = defaultClientStorageSetter,
    refreshIntervalTime = MIN_TOKEN_REFRESH_INTERVAL,
    autoSignIn = true,
    autoRefreshToken = true,
    start: start2 = true
  }) {
    __privateAdd(this, _interpreter, void 0);
    __privateAdd(this, _channel, void 0);
    __privateAdd(this, _subscriptions, void 0);
    __privateSet(this, _subscriptions, /* @__PURE__ */ new Set());
    this.backendUrl = backendUrl;
    this.clientUrl = clientUrl;
    this.machine = createAuthMachine({
      backendUrl,
      clientUrl,
      refreshIntervalTime,
      clientStorageGetter,
      clientStorageSetter,
      autoSignIn,
      autoRefreshToken
    });
    if (start2) {
      this.interpreter = interpret(this.machine);
      this.interpreter.start();
    }
    if (typeof window !== "undefined" && autoSignIn) {
      __privateSet(this, _channel, new BroadcastChannel$1("nhost"));
      __privateGet(this, _channel).addEventListener("message", (token) => {
        var _a3;
        const existingToken = (_a3 = this.interpreter) == null ? void 0 : _a3.state.context.refreshToken;
        if (this.interpreter && token !== existingToken) {
          this.interpreter.send({ type: "TRY_TOKEN", token });
        }
      });
    }
  }
  get interpreter() {
    return __privateGet(this, _interpreter);
  }
  set interpreter(interpreter) {
    __privateSet(this, _interpreter, interpreter);
    if (interpreter) {
      __privateGet(this, _subscriptions).forEach((fn2) => fn2(this));
    }
  }
  onStart(fn2) {
    __privateGet(this, _subscriptions).add(fn2);
  }
}
_interpreter = new WeakMap();
_channel = new WeakMap();
_subscriptions = new WeakMap();
const isBrowser = () => typeof window !== "undefined";
const getSession = (context) => {
  if (!context || !context.accessToken.value || !context.refreshToken.value)
    return null;
  return {
    accessToken: context.accessToken.value,
    accessTokenExpiresIn: (context.accessToken.expiresAt.getTime() - Date.now()) / 1e3,
    refreshToken: context.refreshToken.value,
    user: context.user
  };
};
const checkStorageAccessors = (clientStorage, accessors) => {
  accessors.forEach((key) => {
    if (typeof clientStorage[key] !== "function") {
      console.error(`clientStorage.${key} is not a function`);
    }
  });
};
const localStorageGetter = (clientStorageType, clientStorage) => {
  if (clientStorage) {
    if (clientStorageType === "react-native" || clientStorageType === "custom") {
      checkStorageAccessors(clientStorage, ["getItem"]);
      return (key) => {
        var _a2;
        return (_a2 = clientStorage.getItem) == null ? void 0 : _a2.call(clientStorage, key);
      };
    } else if (clientStorageType === "capacitor") {
      checkStorageAccessors(clientStorage, ["get"]);
      return (key) => {
        var _a2;
        return (_a2 = clientStorage.get) == null ? void 0 : _a2.call(clientStorage, { key });
      };
    } else if (clientStorageType === "expo-secure-storage") {
      checkStorageAccessors(clientStorage, ["getItemAsync"]);
      return (key) => {
        var _a2;
        return (_a2 = clientStorage.getItemAsync) == null ? void 0 : _a2.call(clientStorage, key);
      };
    }
  }
  return defaultClientStorageGetter;
};
const localStorageSetter = (clientStorageType, clientStorage) => {
  if (clientStorage) {
    if (clientStorageType === "react-native" || clientStorageType === "custom") {
      checkStorageAccessors(clientStorage, ["setItem", "removeItem"]);
      return (key, value) => {
        var _a2, _b;
        if (value)
          (_a2 = clientStorage.setItem) == null ? void 0 : _a2.call(clientStorage, key, value);
        else
          (_b = clientStorage.removeItem) == null ? void 0 : _b.call(clientStorage, key);
      };
    } else if (clientStorageType === "capacitor") {
      checkStorageAccessors(clientStorage, ["set", "remove"]);
      return (key, value) => {
        var _a2, _b;
        if (value)
          (_a2 = clientStorage.set) == null ? void 0 : _a2.call(clientStorage, { key, value });
        else
          (_b = clientStorage.remove) == null ? void 0 : _b.call(clientStorage, { key });
      };
    } else if (clientStorageType === "expo-secure-storage") {
      checkStorageAccessors(clientStorage, ["setItemAsync", "deleteItemAsync"]);
      return async (key, value) => {
        var _a2, _b;
        if (value)
          await ((_a2 = clientStorage.setItemAsync) == null ? void 0 : _a2.call(clientStorage, key, value));
        else
          (_b = clientStorage.deleteItemAsync) == null ? void 0 : _b.call(clientStorage, key);
      };
    }
  }
  return defaultClientStorageSetter;
};
const USER_ALREADY_SIGNED_IN = {
  message: "User is already signed in",
  status: 100
};
const USER_UNAUTHENTICATED = {
  message: "User is not authenticated",
  status: 101
};
const USER_NOT_ANONYMOUS = {
  message: "User is not anonymous",
  status: 101
};
const EMAIL_NEEDS_VERIFICATION = {
  message: "Email needs verification",
  status: 102
};
class HasuraAuthClient {
  constructor({
    url,
    autoRefreshToken = true,
    autoLogin = true,
    clientStorage,
    clientStorageType = "web",
    clientStorageGetter,
    clientStorageSetter,
    refreshIntervalTime,
    start: start2 = true,
    Client = AuthClient
  }) {
    __privateAdd(this, _client, void 0);
    this.onTokenChangedSubscriptions = /* @__PURE__ */ new Set();
    this.onAuthStateChangedSubscriptions = /* @__PURE__ */ new Set();
    __privateSet(this, _client, new Client({
      backendUrl: url,
      autoRefreshToken,
      autoSignIn: autoLogin,
      start: start2,
      clientStorageGetter: clientStorageGetter || localStorageGetter(clientStorageType, clientStorage),
      clientStorageSetter: clientStorageSetter || localStorageSetter(clientStorageType, clientStorage),
      refreshIntervalTime
    }));
  }
  async signUp(params) {
    const interpreter = await this.waitUntilReady();
    const { email, password, options } = params;
    if (this.isAuthenticated()) {
      return {
        session: null,
        error: USER_ALREADY_SIGNED_IN
      };
    }
    return new Promise((resolve) => {
      interpreter.send({ type: "SIGNUP_EMAIL_PASSWORD", email, password, options });
      interpreter.onTransition((state) => {
        if (state.matches({ authentication: { signedOut: "needsEmailVerification" } }))
          return resolve({ session: null, error: null });
        else if (state.matches({ authentication: { signedOut: "failed" } })) {
          return resolve({ session: null, error: state.context.errors.registration || null });
        } else if (state.matches({ authentication: "signedIn" }))
          return resolve({ session: getSession(state.context), error: null });
      });
    });
  }
  async signIn(params) {
    const interpreter = await this.waitUntilReady();
    if (this.isAuthenticated()) {
      return {
        session: null,
        mfa: null,
        error: USER_ALREADY_SIGNED_IN
      };
    }
    if ("provider" in params) {
      const { provider, options } = params;
      const providerUrl = encodeQueryParameters(`${__privateGet(this, _client).backendUrl}/signin/provider/${provider}`, rewriteRedirectTo(__privateGet(this, _client).clientUrl, options));
      if (isBrowser()) {
        window.location.href = providerUrl;
      }
      return { providerUrl, provider, session: null, mfa: null, error: null };
    }
    if ("email" in params && "password" in params) {
      return new Promise((resolve) => {
        interpreter.send(__spreadValues({ type: "SIGNIN_PASSWORD" }, params));
        interpreter.onTransition((state) => {
          if (state.matches({ authentication: "signedIn" }))
            resolve({
              session: getSession(state.context),
              mfa: null,
              error: null
            });
          else if (state.matches({ authentication: { signedOut: "needsEmailVerification" } }))
            resolve({
              session: null,
              mfa: null,
              error: EMAIL_NEEDS_VERIFICATION
            });
          else if (state.matches({ authentication: { signedOut: "needsMfa" } }))
            resolve({
              session: null,
              mfa: state.context.mfa,
              error: null
            });
          else if (state.matches({ authentication: { signedOut: "failed" } }))
            resolve({
              session: null,
              mfa: null,
              error: state.context.errors.authentication || null
            });
        });
      });
    }
    if ("email" in params && !("otp" in params)) {
      return new Promise((resolve) => {
        interpreter.onTransition((state) => {
          if (state.matches({ authentication: { signedOut: "needsEmailVerification" } }))
            resolve({
              session: null,
              mfa: null,
              error: null
            });
          else if (state.matches({ authentication: { signedOut: "failed" } }))
            resolve({
              session: null,
              mfa: null,
              error: state.context.errors.authentication || null
            });
        });
        interpreter.send(__spreadValues({ type: "SIGNIN_PASSWORDLESS_EMAIL" }, params));
      });
    }
    if ("phoneNumber" in params && !("otp" in params)) {
      return new Promise((resolve) => {
        interpreter.onTransition((state) => {
          if (state.matches({ authentication: { signedOut: "needsSmsOtp" } }))
            resolve({
              session: null,
              mfa: null,
              error: null
            });
          else if (state.matches({ authentication: { signedOut: "failed" } }))
            resolve({
              session: null,
              mfa: null,
              error: state.context.errors.authentication || null
            });
        });
        interpreter.send(__spreadValues({ type: "SIGNIN_PASSWORDLESS_SMS" }, params));
      });
    }
    if ("otp" in params) {
      return new Promise((resolve) => {
        interpreter.onTransition((state) => {
          if (state.matches({ authentication: "signedIn" }))
            resolve({
              session: getSession(state.context),
              mfa: null,
              error: null
            });
          else if (state.matches({ authentication: { signedOut: "failed" } }))
            resolve({
              session: null,
              mfa: null,
              error: state.context.errors.authentication || null
            });
        });
        interpreter.send(__spreadValues({ type: "SIGNIN_PASSWORDLESS_SMS_OTP" }, params));
      });
    }
    return {
      session: null,
      mfa: null,
      error: { message: "Incorrect parameters", status: 500 }
    };
  }
  async signOut(params) {
    const interpreter = await this.waitUntilReady();
    if (!this.isAuthenticated())
      return { error: USER_UNAUTHENTICATED };
    return new Promise((resolve) => {
      interpreter.send({ type: "SIGNOUT", all: params == null ? void 0 : params.all });
      interpreter.onTransition((state) => {
        if (state.matches({ authentication: { signedOut: "success" } }))
          resolve({ error: null });
        else if (state.matches({ authentication: { signedOut: "failed" } }))
          resolve({ error: state.context.errors.signout || null });
      });
    });
  }
  async resetPassword({ email, options }) {
    return new Promise((resolve) => {
      const service = interpret(createResetPasswordMachine(__privateGet(this, _client)));
      service.onTransition(({ event }) => {
        if (event.type === "ERROR")
          return resolve({ error: event.error });
        else if (event.type === "SUCCESS")
          return resolve({ error: null });
      });
      service.start();
      service.send({ type: "REQUEST", email, options });
    });
  }
  async changePassword(params) {
    return new Promise((resolve) => {
      const service = interpret(createChangePasswordMachine(__privateGet(this, _client)));
      service.onTransition(({ event }) => {
        if (event.type === "ERROR")
          return resolve({ error: event.error });
        else if (event.type === "SUCCESS")
          return resolve({ error: null });
      });
      service.start();
      service.send({ type: "REQUEST", password: params.newPassword });
    });
  }
  async sendVerificationEmail(params) {
    return new Promise((resolve) => {
      const service = interpret(createSendVerificationEmailMachine(__privateGet(this, _client)));
      service.onTransition(({ event }) => {
        if (event.type === "ERROR")
          return resolve({ error: event.error });
        else if (event.type === "SUCCESS")
          return resolve({ error: null });
      });
      service.start();
      service.send({ type: "REQUEST", email: params.email, options: params.options });
    });
  }
  async changeEmail({ newEmail, options }) {
    return new Promise((resolve) => {
      const service = interpret(createChangeEmailMachine(__privateGet(this, _client)));
      service.onTransition(({ event }) => {
        if (event.type === "ERROR")
          return resolve({ error: event.error });
        else if (event.type === "SUCCESS")
          return resolve({ error: null });
      });
      service.start();
      service.send({ type: "REQUEST", email: newEmail, options });
    });
  }
  async deanonymize(params) {
    const interpreter = await this.waitUntilReady();
    return new Promise((resolve) => {
      var _a2;
      if (!this.isAuthenticated() || !((_a2 = interpreter.state.context.user) == null ? void 0 : _a2.isAnonymous))
        return { error: USER_NOT_ANONYMOUS };
      interpreter.onTransition((state) => {
        if (state.matches({ authentication: { signedIn: { deanonymizing: "success" } } }))
          resolve({ error: null });
        else if (state.matches({ authentication: { signedIn: { deanonymizing: "error" } } }))
          resolve({ error: state.context.errors.authentication || null });
      });
      interpreter.start();
      const _b = params, { signInMethod, connection } = _b, options = __objRest(_b, ["signInMethod", "connection"]);
      interpreter.send({
        type: "DEANONYMIZE",
        signInMethod,
        connection,
        options
      });
    });
  }
  onTokenChanged(fn2) {
    var _a2;
    if (__privateGet(this, _client).interpreter)
      this.onTokenChangedSubscriptions.add((_a2 = __privateGet(this, _client).interpreter) == null ? void 0 : _a2.onTransition(({ event, context }) => {
        if (event.type === "TOKEN_CHANGED")
          fn2(getSession(context));
      }));
    else {
      console.log("onTokenChanged: no interpreter is set yet", fn2);
    }
    return () => {
      this.onTokenChangedSubscriptions.forEach((subscription) => subscription.stop());
    };
  }
  onAuthStateChanged(fn2) {
    var _a2;
    if (__privateGet(this, _client).interpreter)
      this.onAuthStateChangedSubscriptions.add((_a2 = __privateGet(this, _client).interpreter) == null ? void 0 : _a2.onTransition(({ event, context }) => {
        if (event.type === "SIGNED_IN")
          fn2("SIGNED_IN", getSession(context));
        else if (event.type === "SIGNED_OUT")
          fn2("SIGNED_OUT", getSession(context));
      }));
    else {
      console.log("onAuthStateChanged: no interpreter is set yet", fn2);
    }
    return () => {
      this.onAuthStateChangedSubscriptions.forEach((subscription) => subscription.stop());
    };
  }
  isAuthenticated() {
    var _a2;
    return !!((_a2 = __privateGet(this, _client).interpreter) == null ? void 0 : _a2.state.matches({ authentication: "signedIn" }));
  }
  async isAuthenticatedAsync() {
    const interpreter = await this.waitUntilReady();
    return interpreter.state.matches({ authentication: "signedIn" });
  }
  getAuthenticationStatus() {
    if (!this.isReady())
      return { isAuthenticated: false, isLoading: true };
    return { isAuthenticated: this.isAuthenticated(), isLoading: false };
  }
  getJWTToken() {
    return this.getAccessToken();
  }
  getAccessToken() {
    var _a2, _b;
    return (_b = (_a2 = __privateGet(this, _client).interpreter) == null ? void 0 : _a2.state.context.accessToken.value) != null ? _b : void 0;
  }
  async refreshSession(refreshToken) {
    try {
      const interpreter = await this.waitUntilReady();
      if (interpreter.state.matches({ token: "idle" }))
        return;
      return new Promise((resolve) => {
        const token = refreshToken || interpreter.state.context.refreshToken.value;
        if (!token)
          return resolve();
        interpreter == null ? void 0 : interpreter.onTransition((state) => {
          if (state.matches({ token: { idle: "error" } }))
            resolve();
          else if (state.event.type === "TOKEN_CHANGED")
            resolve();
        });
        interpreter.send({
          type: "TRY_TOKEN",
          token
        });
      });
    } catch {
      return;
    }
  }
  getSession() {
    var _a2, _b;
    return getSession((_b = (_a2 = __privateGet(this, _client).interpreter) == null ? void 0 : _a2.state) == null ? void 0 : _b.context);
  }
  getUser() {
    var _a2, _b, _c;
    return ((_c = (_b = (_a2 = __privateGet(this, _client).interpreter) == null ? void 0 : _a2.state) == null ? void 0 : _b.context) == null ? void 0 : _c.user) || null;
  }
  waitUntilReady() {
    const TIMEOUT_IN_SECONS = 15;
    const interpreter = __privateGet(this, _client).interpreter;
    if (!interpreter) {
      throw Error("Auth interpreter not set");
    }
    if (interpreter.state.hasTag("ready"))
      return Promise.resolve(interpreter);
    return new Promise((resolve, reject) => {
      let timer = setTimeout(() => reject(`The state machine is not yet ready after ${TIMEOUT_IN_SECONS} seconds.`), TIMEOUT_IN_SECONS * 1e3);
      interpreter.onTransition((state) => {
        if (state.hasTag("ready")) {
          clearTimeout(timer);
          return resolve(interpreter);
        }
      });
    });
  }
  isReady() {
    var _a2, _b;
    return !!((_b = (_a2 = __privateGet(this, _client).interpreter) == null ? void 0 : _a2.state) == null ? void 0 : _b.hasTag("ready"));
  }
  get client() {
    return __privateGet(this, _client);
  }
}
_client = new WeakMap();
var axios$5 = { exports: {} };
var bind$5 = function bind2(fn2, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i2 = 0; i2 < args.length; i2++) {
      args[i2] = arguments[i2];
    }
    return fn2.apply(thisArg, args);
  };
};
var bind$4 = bind$5;
var toString$1 = Object.prototype.toString;
function isArray$1(val) {
  return toString$1.call(val) === "[object Array]";
}
function isUndefined$1(val) {
  return typeof val === "undefined";
}
function isBuffer$1(val) {
  return val !== null && !isUndefined$1(val) && val.constructor !== null && !isUndefined$1(val.constructor) && typeof val.constructor.isBuffer === "function" && val.constructor.isBuffer(val);
}
function isArrayBuffer$1(val) {
  return toString$1.call(val) === "[object ArrayBuffer]";
}
function isFormData$1(val) {
  return typeof FormData !== "undefined" && val instanceof FormData;
}
function isArrayBufferView$1(val) {
  var result;
  if (typeof ArrayBuffer !== "undefined" && ArrayBuffer.isView) {
    result = ArrayBuffer.isView(val);
  } else {
    result = val && val.buffer && val.buffer instanceof ArrayBuffer;
  }
  return result;
}
function isString$1(val) {
  return typeof val === "string";
}
function isNumber$1(val) {
  return typeof val === "number";
}
function isObject$1(val) {
  return val !== null && typeof val === "object";
}
function isPlainObject$1(val) {
  if (toString$1.call(val) !== "[object Object]") {
    return false;
  }
  var prototype = Object.getPrototypeOf(val);
  return prototype === null || prototype === Object.prototype;
}
function isDate$1(val) {
  return toString$1.call(val) === "[object Date]";
}
function isFile$1(val) {
  return toString$1.call(val) === "[object File]";
}
function isBlob$1(val) {
  return toString$1.call(val) === "[object Blob]";
}
function isFunction$1(val) {
  return toString$1.call(val) === "[object Function]";
}
function isStream$1(val) {
  return isObject$1(val) && isFunction$1(val.pipe);
}
function isURLSearchParams$1(val) {
  return typeof URLSearchParams !== "undefined" && val instanceof URLSearchParams;
}
function trim$1(str) {
  return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, "");
}
function isStandardBrowserEnv$1() {
  if (typeof navigator !== "undefined" && (navigator.product === "ReactNative" || navigator.product === "NativeScript" || navigator.product === "NS")) {
    return false;
  }
  return typeof window !== "undefined" && typeof document !== "undefined";
}
function forEach$1(obj, fn2) {
  if (obj === null || typeof obj === "undefined") {
    return;
  }
  if (typeof obj !== "object") {
    obj = [obj];
  }
  if (isArray$1(obj)) {
    for (var i2 = 0, l2 = obj.length; i2 < l2; i2++) {
      fn2.call(null, obj[i2], i2, obj);
    }
  } else {
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn2.call(null, obj[key], key, obj);
      }
    }
  }
}
function merge$1() {
  var result = {};
  function assignValue(val, key) {
    if (isPlainObject$1(result[key]) && isPlainObject$1(val)) {
      result[key] = merge$1(result[key], val);
    } else if (isPlainObject$1(val)) {
      result[key] = merge$1({}, val);
    } else if (isArray$1(val)) {
      result[key] = val.slice();
    } else {
      result[key] = val;
    }
  }
  for (var i2 = 0, l2 = arguments.length; i2 < l2; i2++) {
    forEach$1(arguments[i2], assignValue);
  }
  return result;
}
function extend$1(a2, b2, thisArg) {
  forEach$1(b2, function assignValue(val, key) {
    if (thisArg && typeof val === "function") {
      a2[key] = bind$4(val, thisArg);
    } else {
      a2[key] = val;
    }
  });
  return a2;
}
function stripBOM$1(content) {
  if (content.charCodeAt(0) === 65279) {
    content = content.slice(1);
  }
  return content;
}
var utils$r = {
  isArray: isArray$1,
  isArrayBuffer: isArrayBuffer$1,
  isBuffer: isBuffer$1,
  isFormData: isFormData$1,
  isArrayBufferView: isArrayBufferView$1,
  isString: isString$1,
  isNumber: isNumber$1,
  isObject: isObject$1,
  isPlainObject: isPlainObject$1,
  isUndefined: isUndefined$1,
  isDate: isDate$1,
  isFile: isFile$1,
  isBlob: isBlob$1,
  isFunction: isFunction$1,
  isStream: isStream$1,
  isURLSearchParams: isURLSearchParams$1,
  isStandardBrowserEnv: isStandardBrowserEnv$1,
  forEach: forEach$1,
  merge: merge$1,
  extend: extend$1,
  trim: trim$1,
  stripBOM: stripBOM$1
};
var utils$q = utils$r;
function encode$1(val) {
  return encodeURIComponent(val).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
var buildURL$5 = function buildURL2(url, params, paramsSerializer) {
  if (!params) {
    return url;
  }
  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils$q.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];
    utils$q.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === "undefined") {
        return;
      }
      if (utils$q.isArray(val)) {
        key = key + "[]";
      } else {
        val = [val];
      }
      utils$q.forEach(val, function parseValue(v2) {
        if (utils$q.isDate(v2)) {
          v2 = v2.toISOString();
        } else if (utils$q.isObject(v2)) {
          v2 = JSON.stringify(v2);
        }
        parts.push(encode$1(key) + "=" + encode$1(v2));
      });
    });
    serializedParams = parts.join("&");
  }
  if (serializedParams) {
    var hashmarkIndex = url.indexOf("#");
    if (hashmarkIndex !== -1) {
      url = url.slice(0, hashmarkIndex);
    }
    url += (url.indexOf("?") === -1 ? "?" : "&") + serializedParams;
  }
  return url;
};
var utils$p = utils$r;
function InterceptorManager$3() {
  this.handlers = [];
}
InterceptorManager$3.prototype.use = function use2(fulfilled, rejected, options) {
  this.handlers.push({
    fulfilled,
    rejected,
    synchronous: options ? options.synchronous : false,
    runWhen: options ? options.runWhen : null
  });
  return this.handlers.length - 1;
};
InterceptorManager$3.prototype.eject = function eject2(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};
InterceptorManager$3.prototype.forEach = function forEach2(fn2) {
  utils$p.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn2(h);
    }
  });
};
var InterceptorManager_1$1 = InterceptorManager$3;
var utils$o = utils$r;
var normalizeHeaderName$3 = function normalizeHeaderName2(headers, normalizedName) {
  utils$o.forEach(headers, function processHeader(value, name2) {
    if (name2 !== normalizedName && name2.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name2];
    }
  });
};
var enhanceError$5 = function enhanceError2(error2, config, code, request4, response) {
  error2.config = config;
  if (code) {
    error2.code = code;
  }
  error2.request = request4;
  error2.response = response;
  error2.isAxiosError = true;
  error2.toJSON = function toJSON() {
    return {
      message: this.message,
      name: this.name,
      description: this.description,
      number: this.number,
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      config: this.config,
      code: this.code
    };
  };
  return error2;
};
var enhanceError$4 = enhanceError$5;
var createError$5 = function createError2(message, config, code, request4, response) {
  var error2 = new Error(message);
  return enhanceError$4(error2, config, code, request4, response);
};
var createError$4 = createError$5;
var settle$3 = function settle2(resolve, reject, response) {
  var validateStatus4 = response.config.validateStatus;
  if (!response.status || !validateStatus4 || validateStatus4(response.status)) {
    resolve(response);
  } else {
    reject(createError$4("Request failed with status code " + response.status, response.config, null, response.request, response));
  }
};
var utils$n = utils$r;
var cookies$3 = utils$n.isStandardBrowserEnv() ? function standardBrowserEnv3() {
  return {
    write: function write(name2, value, expires, path2, domain, secure) {
      var cookie = [];
      cookie.push(name2 + "=" + encodeURIComponent(value));
      if (utils$n.isNumber(expires)) {
        cookie.push("expires=" + new Date(expires).toGMTString());
      }
      if (utils$n.isString(path2)) {
        cookie.push("path=" + path2);
      }
      if (utils$n.isString(domain)) {
        cookie.push("domain=" + domain);
      }
      if (secure === true) {
        cookie.push("secure");
      }
      document.cookie = cookie.join("; ");
    },
    read: function read(name2) {
      var match = document.cookie.match(new RegExp("(^|;\\s*)(" + name2 + ")=([^;]*)"));
      return match ? decodeURIComponent(match[3]) : null;
    },
    remove: function remove(name2) {
      this.write(name2, "", Date.now() - 864e5);
    }
  };
}() : function nonStandardBrowserEnv3() {
  return {
    write: function write() {
    },
    read: function read() {
      return null;
    },
    remove: function remove() {
    }
  };
}();
var isAbsoluteURL$3 = function isAbsoluteURL2(url) {
  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};
var combineURLs$3 = function combineURLs2(baseURL, relativeURL) {
  return relativeURL ? baseURL.replace(/\/+$/, "") + "/" + relativeURL.replace(/^\/+/, "") : baseURL;
};
var isAbsoluteURL$2 = isAbsoluteURL$3;
var combineURLs$2 = combineURLs$3;
var buildFullPath$3 = function buildFullPath2(baseURL, requestedURL) {
  if (baseURL && !isAbsoluteURL$2(requestedURL)) {
    return combineURLs$2(baseURL, requestedURL);
  }
  return requestedURL;
};
var utils$m = utils$r;
var ignoreDuplicateOf$1 = [
  "age",
  "authorization",
  "content-length",
  "content-type",
  "etag",
  "expires",
  "from",
  "host",
  "if-modified-since",
  "if-unmodified-since",
  "last-modified",
  "location",
  "max-forwards",
  "proxy-authorization",
  "referer",
  "retry-after",
  "user-agent"
];
var parseHeaders$3 = function parseHeaders2(headers) {
  var parsed = {};
  var key;
  var val;
  var i2;
  if (!headers) {
    return parsed;
  }
  utils$m.forEach(headers.split("\n"), function parser(line) {
    i2 = line.indexOf(":");
    key = utils$m.trim(line.substr(0, i2)).toLowerCase();
    val = utils$m.trim(line.substr(i2 + 1));
    if (key) {
      if (parsed[key] && ignoreDuplicateOf$1.indexOf(key) >= 0) {
        return;
      }
      if (key === "set-cookie") {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ", " + val : val;
      }
    }
  });
  return parsed;
};
var utils$l = utils$r;
var isURLSameOrigin$3 = utils$l.isStandardBrowserEnv() ? function standardBrowserEnv4() {
  var msie = /(msie|trident)/i.test(navigator.userAgent);
  var urlParsingNode = document.createElement("a");
  var originURL;
  function resolveURL(url) {
    var href = url;
    if (msie) {
      urlParsingNode.setAttribute("href", href);
      href = urlParsingNode.href;
    }
    urlParsingNode.setAttribute("href", href);
    return {
      href: urlParsingNode.href,
      protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, "") : "",
      host: urlParsingNode.host,
      search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, "") : "",
      hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, "") : "",
      hostname: urlParsingNode.hostname,
      port: urlParsingNode.port,
      pathname: urlParsingNode.pathname.charAt(0) === "/" ? urlParsingNode.pathname : "/" + urlParsingNode.pathname
    };
  }
  originURL = resolveURL(window.location.href);
  return function isURLSameOrigin2(requestURL) {
    var parsed = utils$l.isString(requestURL) ? resolveURL(requestURL) : requestURL;
    return parsed.protocol === originURL.protocol && parsed.host === originURL.host;
  };
}() : function nonStandardBrowserEnv4() {
  return function isURLSameOrigin2() {
    return true;
  };
}();
var utils$k = utils$r;
var settle$2 = settle$3;
var cookies$2 = cookies$3;
var buildURL$4 = buildURL$5;
var buildFullPath$2 = buildFullPath$3;
var parseHeaders$2 = parseHeaders$3;
var isURLSameOrigin$2 = isURLSameOrigin$3;
var createError$3 = createError$5;
var xhr$1 = function xhrAdapter2(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;
    var responseType = config.responseType;
    if (utils$k.isFormData(requestData)) {
      delete requestHeaders["Content-Type"];
    }
    var request4 = new XMLHttpRequest();
    if (config.auth) {
      var username = config.auth.username || "";
      var password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : "";
      requestHeaders.Authorization = "Basic " + btoa(username + ":" + password);
    }
    var fullPath = buildFullPath$2(config.baseURL, config.url);
    request4.open(config.method.toUpperCase(), buildURL$4(fullPath, config.params, config.paramsSerializer), true);
    request4.timeout = config.timeout;
    function onloadend() {
      if (!request4) {
        return;
      }
      var responseHeaders = "getAllResponseHeaders" in request4 ? parseHeaders$2(request4.getAllResponseHeaders()) : null;
      var responseData = !responseType || responseType === "text" || responseType === "json" ? request4.responseText : request4.response;
      var response = {
        data: responseData,
        status: request4.status,
        statusText: request4.statusText,
        headers: responseHeaders,
        config,
        request: request4
      };
      settle$2(resolve, reject, response);
      request4 = null;
    }
    if ("onloadend" in request4) {
      request4.onloadend = onloadend;
    } else {
      request4.onreadystatechange = function handleLoad() {
        if (!request4 || request4.readyState !== 4) {
          return;
        }
        if (request4.status === 0 && !(request4.responseURL && request4.responseURL.indexOf("file:") === 0)) {
          return;
        }
        setTimeout(onloadend);
      };
    }
    request4.onabort = function handleAbort() {
      if (!request4) {
        return;
      }
      reject(createError$3("Request aborted", config, "ECONNABORTED", request4));
      request4 = null;
    };
    request4.onerror = function handleError() {
      reject(createError$3("Network Error", config, null, request4));
      request4 = null;
    };
    request4.ontimeout = function handleTimeout() {
      var timeoutErrorMessage = "timeout of " + config.timeout + "ms exceeded";
      if (config.timeoutErrorMessage) {
        timeoutErrorMessage = config.timeoutErrorMessage;
      }
      reject(createError$3(timeoutErrorMessage, config, config.transitional && config.transitional.clarifyTimeoutError ? "ETIMEDOUT" : "ECONNABORTED", request4));
      request4 = null;
    };
    if (utils$k.isStandardBrowserEnv()) {
      var xsrfValue = (config.withCredentials || isURLSameOrigin$2(fullPath)) && config.xsrfCookieName ? cookies$2.read(config.xsrfCookieName) : void 0;
      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }
    if ("setRequestHeader" in request4) {
      utils$k.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === "undefined" && key.toLowerCase() === "content-type") {
          delete requestHeaders[key];
        } else {
          request4.setRequestHeader(key, val);
        }
      });
    }
    if (!utils$k.isUndefined(config.withCredentials)) {
      request4.withCredentials = !!config.withCredentials;
    }
    if (responseType && responseType !== "json") {
      request4.responseType = config.responseType;
    }
    if (typeof config.onDownloadProgress === "function") {
      request4.addEventListener("progress", config.onDownloadProgress);
    }
    if (typeof config.onUploadProgress === "function" && request4.upload) {
      request4.upload.addEventListener("progress", config.onUploadProgress);
    }
    if (config.cancelToken) {
      config.cancelToken.promise.then(function onCanceled(cancel2) {
        if (!request4) {
          return;
        }
        request4.abort();
        reject(cancel2);
        request4 = null;
      });
    }
    if (!requestData) {
      requestData = null;
    }
    request4.send(requestData);
  });
};
var utils$j = utils$r;
var normalizeHeaderName$2 = normalizeHeaderName$3;
var enhanceError$3 = enhanceError$5;
var DEFAULT_CONTENT_TYPE$1 = {
  "Content-Type": "application/x-www-form-urlencoded"
};
function setContentTypeIfUnset$1(headers, value) {
  if (!utils$j.isUndefined(headers) && utils$j.isUndefined(headers["Content-Type"])) {
    headers["Content-Type"] = value;
  }
}
function getDefaultAdapter$1() {
  var adapter;
  if (typeof XMLHttpRequest !== "undefined") {
    adapter = xhr$1;
  } else if (typeof process !== "undefined" && Object.prototype.toString.call(process) === "[object process]") {
    adapter = xhr$1;
  }
  return adapter;
}
function stringifySafely$1(rawValue, parser, encoder) {
  if (utils$j.isString(rawValue)) {
    try {
      (parser || JSON.parse)(rawValue);
      return utils$j.trim(rawValue);
    } catch (e2) {
      if (e2.name !== "SyntaxError") {
        throw e2;
      }
    }
  }
  return (encoder || JSON.stringify)(rawValue);
}
var defaults$8 = {
  transitional: {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false
  },
  adapter: getDefaultAdapter$1(),
  transformRequest: [function transformRequest2(data2, headers) {
    normalizeHeaderName$2(headers, "Accept");
    normalizeHeaderName$2(headers, "Content-Type");
    if (utils$j.isFormData(data2) || utils$j.isArrayBuffer(data2) || utils$j.isBuffer(data2) || utils$j.isStream(data2) || utils$j.isFile(data2) || utils$j.isBlob(data2)) {
      return data2;
    }
    if (utils$j.isArrayBufferView(data2)) {
      return data2.buffer;
    }
    if (utils$j.isURLSearchParams(data2)) {
      setContentTypeIfUnset$1(headers, "application/x-www-form-urlencoded;charset=utf-8");
      return data2.toString();
    }
    if (utils$j.isObject(data2) || headers && headers["Content-Type"] === "application/json") {
      setContentTypeIfUnset$1(headers, "application/json");
      return stringifySafely$1(data2);
    }
    return data2;
  }],
  transformResponse: [function transformResponse2(data2) {
    var transitional4 = this.transitional;
    var silentJSONParsing = transitional4 && transitional4.silentJSONParsing;
    var forcedJSONParsing = transitional4 && transitional4.forcedJSONParsing;
    var strictJSONParsing = !silentJSONParsing && this.responseType === "json";
    if (strictJSONParsing || forcedJSONParsing && utils$j.isString(data2) && data2.length) {
      try {
        return JSON.parse(data2);
      } catch (e2) {
        if (strictJSONParsing) {
          if (e2.name === "SyntaxError") {
            throw enhanceError$3(e2, this, "E_JSON_PARSE");
          }
          throw e2;
        }
      }
    }
    return data2;
  }],
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  validateStatus: function validateStatus2(status) {
    return status >= 200 && status < 300;
  }
};
defaults$8.headers = {
  common: {
    "Accept": "application/json, text/plain, */*"
  }
};
utils$j.forEach(["delete", "get", "head"], function forEachMethodNoData3(method) {
  defaults$8.headers[method] = {};
});
utils$j.forEach(["post", "put", "patch"], function forEachMethodWithData3(method) {
  defaults$8.headers[method] = utils$j.merge(DEFAULT_CONTENT_TYPE$1);
});
var defaults_1$1 = defaults$8;
var utils$i = utils$r;
var defaults$7 = defaults_1$1;
var transformData$3 = function transformData2(data2, headers, fns) {
  var context = this || defaults$7;
  utils$i.forEach(fns, function transform(fn2) {
    data2 = fn2.call(context, data2, headers);
  });
  return data2;
};
var isCancel$3 = function isCancel2(value) {
  return !!(value && value.__CANCEL__);
};
var utils$h = utils$r;
var transformData$2 = transformData$3;
var isCancel$2 = isCancel$3;
var defaults$6 = defaults_1$1;
function throwIfCancellationRequested$1(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
}
var dispatchRequest$3 = function dispatchRequest2(config) {
  throwIfCancellationRequested$1(config);
  config.headers = config.headers || {};
  config.data = transformData$2.call(config, config.data, config.headers, config.transformRequest);
  config.headers = utils$h.merge(config.headers.common || {}, config.headers[config.method] || {}, config.headers);
  utils$h.forEach(["delete", "get", "head", "post", "put", "patch", "common"], function cleanHeaderConfig(method) {
    delete config.headers[method];
  });
  var adapter = config.adapter || defaults$6.adapter;
  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested$1(config);
    response.data = transformData$2.call(config, response.data, response.headers, config.transformResponse);
    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel$2(reason)) {
      throwIfCancellationRequested$1(config);
      if (reason && reason.response) {
        reason.response.data = transformData$2.call(config, reason.response.data, reason.response.headers, config.transformResponse);
      }
    }
    return Promise.reject(reason);
  });
};
var utils$g = utils$r;
var mergeConfig$5 = function mergeConfig2(config1, config2) {
  config2 = config2 || {};
  var config = {};
  var valueFromConfig2Keys = ["url", "method", "data"];
  var mergeDeepPropertiesKeys = ["headers", "auth", "proxy", "params"];
  var defaultToConfig2Keys = [
    "baseURL",
    "transformRequest",
    "transformResponse",
    "paramsSerializer",
    "timeout",
    "timeoutMessage",
    "withCredentials",
    "adapter",
    "responseType",
    "xsrfCookieName",
    "xsrfHeaderName",
    "onUploadProgress",
    "onDownloadProgress",
    "decompress",
    "maxContentLength",
    "maxBodyLength",
    "maxRedirects",
    "transport",
    "httpAgent",
    "httpsAgent",
    "cancelToken",
    "socketPath",
    "responseEncoding"
  ];
  var directMergeKeys = ["validateStatus"];
  function getMergedValue(target, source4) {
    if (utils$g.isPlainObject(target) && utils$g.isPlainObject(source4)) {
      return utils$g.merge(target, source4);
    } else if (utils$g.isPlainObject(source4)) {
      return utils$g.merge({}, source4);
    } else if (utils$g.isArray(source4)) {
      return source4.slice();
    }
    return source4;
  }
  function mergeDeepProperties(prop) {
    if (!utils$g.isUndefined(config2[prop])) {
      config[prop] = getMergedValue(config1[prop], config2[prop]);
    } else if (!utils$g.isUndefined(config1[prop])) {
      config[prop] = getMergedValue(void 0, config1[prop]);
    }
  }
  utils$g.forEach(valueFromConfig2Keys, function valueFromConfig2(prop) {
    if (!utils$g.isUndefined(config2[prop])) {
      config[prop] = getMergedValue(void 0, config2[prop]);
    }
  });
  utils$g.forEach(mergeDeepPropertiesKeys, mergeDeepProperties);
  utils$g.forEach(defaultToConfig2Keys, function defaultToConfig2(prop) {
    if (!utils$g.isUndefined(config2[prop])) {
      config[prop] = getMergedValue(void 0, config2[prop]);
    } else if (!utils$g.isUndefined(config1[prop])) {
      config[prop] = getMergedValue(void 0, config1[prop]);
    }
  });
  utils$g.forEach(directMergeKeys, function merge2(prop) {
    if (prop in config2) {
      config[prop] = getMergedValue(config1[prop], config2[prop]);
    } else if (prop in config1) {
      config[prop] = getMergedValue(void 0, config1[prop]);
    }
  });
  var axiosKeys = valueFromConfig2Keys.concat(mergeDeepPropertiesKeys).concat(defaultToConfig2Keys).concat(directMergeKeys);
  var otherKeys = Object.keys(config1).concat(Object.keys(config2)).filter(function filterAxiosKeys(key) {
    return axiosKeys.indexOf(key) === -1;
  });
  utils$g.forEach(otherKeys, mergeDeepProperties);
  return config;
};
const name = "axios";
const version = "0.21.4";
const description = "Promise based HTTP client for the browser and node.js";
const main = "index.js";
const scripts = {
  test: "grunt test",
  start: "node ./sandbox/server.js",
  build: "NODE_ENV=production grunt build",
  preversion: "npm test",
  version: "npm run build && grunt version && git add -A dist && git add CHANGELOG.md bower.json package.json",
  postversion: "git push && git push --tags",
  examples: "node ./examples/server.js",
  coveralls: "cat coverage/lcov.info | ./node_modules/coveralls/bin/coveralls.js",
  fix: "eslint --fix lib/**/*.js"
};
const repository = {
  type: "git",
  url: "https://github.com/axios/axios.git"
};
const keywords = [
  "xhr",
  "http",
  "ajax",
  "promise",
  "node"
];
const author = "Matt Zabriskie";
const license = "MIT";
const bugs = {
  url: "https://github.com/axios/axios/issues"
};
const homepage = "https://axios-http.com";
const devDependencies = {
  coveralls: "^3.0.0",
  "es6-promise": "^4.2.4",
  grunt: "^1.3.0",
  "grunt-banner": "^0.6.0",
  "grunt-cli": "^1.2.0",
  "grunt-contrib-clean": "^1.1.0",
  "grunt-contrib-watch": "^1.0.0",
  "grunt-eslint": "^23.0.0",
  "grunt-karma": "^4.0.0",
  "grunt-mocha-test": "^0.13.3",
  "grunt-ts": "^6.0.0-beta.19",
  "grunt-webpack": "^4.0.2",
  "istanbul-instrumenter-loader": "^1.0.0",
  "jasmine-core": "^2.4.1",
  karma: "^6.3.2",
  "karma-chrome-launcher": "^3.1.0",
  "karma-firefox-launcher": "^2.1.0",
  "karma-jasmine": "^1.1.1",
  "karma-jasmine-ajax": "^0.1.13",
  "karma-safari-launcher": "^1.0.0",
  "karma-sauce-launcher": "^4.3.6",
  "karma-sinon": "^1.0.5",
  "karma-sourcemap-loader": "^0.3.8",
  "karma-webpack": "^4.0.2",
  "load-grunt-tasks": "^3.5.2",
  minimist: "^1.2.0",
  mocha: "^8.2.1",
  sinon: "^4.5.0",
  "terser-webpack-plugin": "^4.2.3",
  typescript: "^4.0.5",
  "url-search-params": "^0.10.0",
  webpack: "^4.44.2",
  "webpack-dev-server": "^3.11.0"
};
const browser = {
  "./lib/adapters/http.js": "./lib/adapters/xhr.js"
};
const jsdelivr = "dist/axios.min.js";
const unpkg = "dist/axios.min.js";
const typings = "./index.d.ts";
const dependencies = {
  "follow-redirects": "^1.14.0"
};
const bundlesize = [
  {
    path: "./dist/axios.min.js",
    threshold: "5kB"
  }
];
var require$$0 = {
  name,
  version,
  description,
  main,
  scripts,
  repository,
  keywords,
  author,
  license,
  bugs,
  homepage,
  devDependencies,
  browser,
  jsdelivr,
  unpkg,
  typings,
  dependencies,
  bundlesize
};
var pkg = require$$0;
var validators$3 = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach(function(type2, i2) {
  validators$3[type2] = function validator2(thing) {
    return typeof thing === type2 || "a" + (i2 < 1 ? "n " : " ") + type2;
  };
});
var deprecatedWarnings$1 = {};
var currentVerArr = pkg.version.split(".");
function isOlderVersion(version2, thanVersion) {
  var pkgVersionArr = thanVersion ? thanVersion.split(".") : currentVerArr;
  var destVer = version2.split(".");
  for (var i2 = 0; i2 < 3; i2++) {
    if (pkgVersionArr[i2] > destVer[i2]) {
      return true;
    } else if (pkgVersionArr[i2] < destVer[i2]) {
      return false;
    }
  }
  return false;
}
validators$3.transitional = function transitional2(validator2, version2, message) {
  var isDeprecated = version2 && isOlderVersion(version2);
  function formatMessage(opt, desc) {
    return "[Axios v" + pkg.version + "] Transitional option '" + opt + "'" + desc + (message ? ". " + message : "");
  }
  return function(value, opt, opts) {
    if (validator2 === false) {
      throw new Error(formatMessage(opt, " has been removed in " + version2));
    }
    if (isDeprecated && !deprecatedWarnings$1[opt]) {
      deprecatedWarnings$1[opt] = true;
      console.warn(formatMessage(opt, " has been deprecated since v" + version2 + " and will be removed in the near future"));
    }
    return validator2 ? validator2(value, opt, opts) : true;
  };
};
function assertOptions$1(options, schema, allowUnknown) {
  if (typeof options !== "object") {
    throw new TypeError("options must be an object");
  }
  var keys = Object.keys(options);
  var i2 = keys.length;
  while (i2-- > 0) {
    var opt = keys[i2];
    var validator2 = schema[opt];
    if (validator2) {
      var value = options[opt];
      var result = value === void 0 || validator2(value, opt, options);
      if (result !== true) {
        throw new TypeError("option " + opt + " must be " + result);
      }
      continue;
    }
    if (allowUnknown !== true) {
      throw Error("Unknown option " + opt);
    }
  }
}
var validator$3 = {
  isOlderVersion,
  assertOptions: assertOptions$1,
  validators: validators$3
};
var utils$f = utils$r;
var buildURL$3 = buildURL$5;
var InterceptorManager$2 = InterceptorManager_1$1;
var dispatchRequest$2 = dispatchRequest$3;
var mergeConfig$4 = mergeConfig$5;
var validator$2 = validator$3;
var validators$2 = validator$2.validators;
function Axios$3(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager$2(),
    response: new InterceptorManager$2()
  };
}
Axios$3.prototype.request = function request2(config) {
  if (typeof config === "string") {
    config = arguments[1] || {};
    config.url = arguments[0];
  } else {
    config = config || {};
  }
  config = mergeConfig$4(this.defaults, config);
  if (config.method) {
    config.method = config.method.toLowerCase();
  } else if (this.defaults.method) {
    config.method = this.defaults.method.toLowerCase();
  } else {
    config.method = "get";
  }
  var transitional4 = config.transitional;
  if (transitional4 !== void 0) {
    validator$2.assertOptions(transitional4, {
      silentJSONParsing: validators$2.transitional(validators$2.boolean, "1.0.0"),
      forcedJSONParsing: validators$2.transitional(validators$2.boolean, "1.0.0"),
      clarifyTimeoutError: validators$2.transitional(validators$2.boolean, "1.0.0")
    }, false);
  }
  var requestInterceptorChain = [];
  var synchronousRequestInterceptors = true;
  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    if (typeof interceptor.runWhen === "function" && interceptor.runWhen(config) === false) {
      return;
    }
    synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
    requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
  });
  var responseInterceptorChain = [];
  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
  });
  var promise;
  if (!synchronousRequestInterceptors) {
    var chain = [dispatchRequest$2, void 0];
    Array.prototype.unshift.apply(chain, requestInterceptorChain);
    chain = chain.concat(responseInterceptorChain);
    promise = Promise.resolve(config);
    while (chain.length) {
      promise = promise.then(chain.shift(), chain.shift());
    }
    return promise;
  }
  var newConfig = config;
  while (requestInterceptorChain.length) {
    var onFulfilled = requestInterceptorChain.shift();
    var onRejected = requestInterceptorChain.shift();
    try {
      newConfig = onFulfilled(newConfig);
    } catch (error2) {
      onRejected(error2);
      break;
    }
  }
  try {
    promise = dispatchRequest$2(newConfig);
  } catch (error2) {
    return Promise.reject(error2);
  }
  while (responseInterceptorChain.length) {
    promise = promise.then(responseInterceptorChain.shift(), responseInterceptorChain.shift());
  }
  return promise;
};
Axios$3.prototype.getUri = function getUri2(config) {
  config = mergeConfig$4(this.defaults, config);
  return buildURL$3(config.url, config.params, config.paramsSerializer).replace(/^\?/, "");
};
utils$f.forEach(["delete", "get", "head", "options"], function forEachMethodNoData4(method) {
  Axios$3.prototype[method] = function(url, config) {
    return this.request(mergeConfig$4(config || {}, {
      method,
      url,
      data: (config || {}).data
    }));
  };
});
utils$f.forEach(["post", "put", "patch"], function forEachMethodWithData4(method) {
  Axios$3.prototype[method] = function(url, data2, config) {
    return this.request(mergeConfig$4(config || {}, {
      method,
      url,
      data: data2
    }));
  };
});
var Axios_1$1 = Axios$3;
function Cancel$5(message) {
  this.message = message;
}
Cancel$5.prototype.toString = function toString2() {
  return "Cancel" + (this.message ? ": " + this.message : "");
};
Cancel$5.prototype.__CANCEL__ = true;
var Cancel_1$1 = Cancel$5;
var Cancel$4 = Cancel_1$1;
function CancelToken$1(executor) {
  if (typeof executor !== "function") {
    throw new TypeError("executor must be a function.");
  }
  var resolvePromise;
  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });
  var token = this;
  executor(function cancel2(message) {
    if (token.reason) {
      return;
    }
    token.reason = new Cancel$4(message);
    resolvePromise(token.reason);
  });
}
CancelToken$1.prototype.throwIfRequested = function throwIfRequested2() {
  if (this.reason) {
    throw this.reason;
  }
};
CancelToken$1.source = function source2() {
  var cancel2;
  var token = new CancelToken$1(function executor(c2) {
    cancel2 = c2;
  });
  return {
    token,
    cancel: cancel2
  };
};
var CancelToken_1$1 = CancelToken$1;
var spread$1 = function spread2(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};
var isAxiosError$1 = function isAxiosError2(payload) {
  return typeof payload === "object" && payload.isAxiosError === true;
};
var utils$e = utils$r;
var bind$3 = bind$5;
var Axios$2 = Axios_1$1;
var mergeConfig$3 = mergeConfig$5;
var defaults$5 = defaults_1$1;
function createInstance$1(defaultConfig) {
  var context = new Axios$2(defaultConfig);
  var instance = bind$3(Axios$2.prototype.request, context);
  utils$e.extend(instance, Axios$2.prototype, context);
  utils$e.extend(instance, context);
  return instance;
}
var axios$4 = createInstance$1(defaults$5);
axios$4.Axios = Axios$2;
axios$4.create = function create2(instanceConfig) {
  return createInstance$1(mergeConfig$3(axios$4.defaults, instanceConfig));
};
axios$4.Cancel = Cancel_1$1;
axios$4.CancelToken = CancelToken_1$1;
axios$4.isCancel = isCancel$3;
axios$4.all = function all2(promises) {
  return Promise.all(promises);
};
axios$4.spread = spread$1;
axios$4.isAxiosError = isAxiosError$1;
axios$5.exports = axios$4;
axios$5.exports.default = axios$4;
var axios$3 = axios$5.exports;
class HasuraStorageApi {
  constructor({ url }) {
    this.url = url;
    this.httpClient = axios$3.create({
      baseURL: this.url
    });
  }
  async upload(params) {
    try {
      const res = await this.httpClient.post("/files", params.file, {
        headers: __spreadValues(__spreadValues({}, this.generateUploadHeaders(params)), this.generateAuthHeaders())
      });
      return { fileMetadata: res.data, error: null };
    } catch (error2) {
      return { fileMetadata: null, error: error2 };
    }
  }
  async getPresignedUrl(params) {
    try {
      const { fileId } = params;
      const res = await this.httpClient.get(`/files/${fileId}/presignedurl`, {
        headers: __spreadValues({}, this.generateAuthHeaders())
      });
      return { presignedUrl: res.data, error: null };
    } catch (error2) {
      return { presignedUrl: null, error: error2 };
    }
  }
  async delete(params) {
    try {
      const { fileId } = params;
      await this.httpClient.delete(`/files/${fileId}`, {
        headers: __spreadValues({}, this.generateAuthHeaders())
      });
      return { error: null };
    } catch (error2) {
      return { error: error2 };
    }
  }
  setAccessToken(accessToken) {
    this.accessToken = accessToken;
    return this;
  }
  setAdminSecret(adminSecret) {
    this.adminSecret = adminSecret;
    return this;
  }
  generateUploadHeaders(params) {
    const { bucketId, name: name2, id } = params;
    const uploadheaders = {};
    if (bucketId) {
      uploadheaders["x-nhost-bucket-id"] = bucketId;
    }
    if (id) {
      uploadheaders["x-nhost-file-id"] = id;
    }
    if (name2) {
      uploadheaders["x-nhost-file-name"] = name2;
    }
    return uploadheaders;
  }
  generateAuthHeaders() {
    if (!this.adminSecret && !this.accessToken) {
      return null;
    }
    if (this.adminSecret) {
      return {
        "x-hasura-admin-secret": this.adminSecret
      };
    }
    return {
      Authorization: `Bearer ${this.accessToken}`
    };
  }
}
class HasuraStorageClient {
  constructor({ url }) {
    this.url = url;
    this.api = new HasuraStorageApi({ url });
  }
  async upload(params) {
    const file = new FormData();
    file.append("file", params.file);
    const { fileMetadata, error: error2 } = await this.api.upload(__spreadProps(__spreadValues({}, params), {
      file
    }));
    if (error2) {
      return { fileMetadata: null, error: error2 };
    }
    if (!fileMetadata) {
      return { fileMetadata: null, error: new Error("Invalid file returned") };
    }
    return { fileMetadata, error: null };
  }
  getUrl(params) {
    return this.getPublicUrl(params);
  }
  getPublicUrl(params) {
    const { fileId } = params;
    return `${this.url}/files/${fileId}`;
  }
  async getPresignedUrl(params) {
    const { presignedUrl, error: error2 } = await this.api.getPresignedUrl(params);
    if (error2) {
      return { presignedUrl: null, error: error2 };
    }
    if (!presignedUrl) {
      return { presignedUrl: null, error: new Error("Invalid file id") };
    }
    return { presignedUrl, error: null };
  }
  async delete(params) {
    const { error: error2 } = await this.api.delete(params);
    if (error2) {
      return { error: error2 };
    }
    return { error: null };
  }
  setAccessToken(accessToken) {
    this.api.setAccessToken(accessToken);
    return this;
  }
  setAdminSecret(adminSecret) {
    this.api.setAdminSecret(adminSecret);
    return this;
  }
}
var axios$2 = { exports: {} };
var bind$2 = function bind3(fn2, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i2 = 0; i2 < args.length; i2++) {
      args[i2] = arguments[i2];
    }
    return fn2.apply(thisArg, args);
  };
};
var bind$1 = bind$2;
var toString3 = Object.prototype.toString;
function isArray(val) {
  return toString3.call(val) === "[object Array]";
}
function isUndefined(val) {
  return typeof val === "undefined";
}
function isBuffer(val) {
  return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor) && typeof val.constructor.isBuffer === "function" && val.constructor.isBuffer(val);
}
function isArrayBuffer(val) {
  return toString3.call(val) === "[object ArrayBuffer]";
}
function isFormData(val) {
  return typeof FormData !== "undefined" && val instanceof FormData;
}
function isArrayBufferView(val) {
  var result;
  if (typeof ArrayBuffer !== "undefined" && ArrayBuffer.isView) {
    result = ArrayBuffer.isView(val);
  } else {
    result = val && val.buffer && val.buffer instanceof ArrayBuffer;
  }
  return result;
}
function isString(val) {
  return typeof val === "string";
}
function isNumber(val) {
  return typeof val === "number";
}
function isObject(val) {
  return val !== null && typeof val === "object";
}
function isPlainObject(val) {
  if (toString3.call(val) !== "[object Object]") {
    return false;
  }
  var prototype = Object.getPrototypeOf(val);
  return prototype === null || prototype === Object.prototype;
}
function isDate(val) {
  return toString3.call(val) === "[object Date]";
}
function isFile(val) {
  return toString3.call(val) === "[object File]";
}
function isBlob(val) {
  return toString3.call(val) === "[object Blob]";
}
function isFunction(val) {
  return toString3.call(val) === "[object Function]";
}
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}
function isURLSearchParams(val) {
  return typeof URLSearchParams !== "undefined" && val instanceof URLSearchParams;
}
function trim(str) {
  return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, "");
}
function isStandardBrowserEnv() {
  if (typeof navigator !== "undefined" && (navigator.product === "ReactNative" || navigator.product === "NativeScript" || navigator.product === "NS")) {
    return false;
  }
  return typeof window !== "undefined" && typeof document !== "undefined";
}
function forEach3(obj, fn2) {
  if (obj === null || typeof obj === "undefined") {
    return;
  }
  if (typeof obj !== "object") {
    obj = [obj];
  }
  if (isArray(obj)) {
    for (var i2 = 0, l2 = obj.length; i2 < l2; i2++) {
      fn2.call(null, obj[i2], i2, obj);
    }
  } else {
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn2.call(null, obj[key], key, obj);
      }
    }
  }
}
function merge() {
  var result = {};
  function assignValue(val, key) {
    if (isPlainObject(result[key]) && isPlainObject(val)) {
      result[key] = merge(result[key], val);
    } else if (isPlainObject(val)) {
      result[key] = merge({}, val);
    } else if (isArray(val)) {
      result[key] = val.slice();
    } else {
      result[key] = val;
    }
  }
  for (var i2 = 0, l2 = arguments.length; i2 < l2; i2++) {
    forEach3(arguments[i2], assignValue);
  }
  return result;
}
function extend(a2, b2, thisArg) {
  forEach3(b2, function assignValue(val, key) {
    if (thisArg && typeof val === "function") {
      a2[key] = bind$1(val, thisArg);
    } else {
      a2[key] = val;
    }
  });
  return a2;
}
function stripBOM(content) {
  if (content.charCodeAt(0) === 65279) {
    content = content.slice(1);
  }
  return content;
}
var utils$d = {
  isArray,
  isArrayBuffer,
  isBuffer,
  isFormData,
  isArrayBufferView,
  isString,
  isNumber,
  isObject,
  isPlainObject,
  isUndefined,
  isDate,
  isFile,
  isBlob,
  isFunction,
  isStream,
  isURLSearchParams,
  isStandardBrowserEnv,
  forEach: forEach3,
  merge,
  extend,
  trim,
  stripBOM
};
var utils$c = utils$d;
function encode(val) {
  return encodeURIComponent(val).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
var buildURL$2 = function buildURL3(url, params, paramsSerializer) {
  if (!params) {
    return url;
  }
  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils$c.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];
    utils$c.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === "undefined") {
        return;
      }
      if (utils$c.isArray(val)) {
        key = key + "[]";
      } else {
        val = [val];
      }
      utils$c.forEach(val, function parseValue(v2) {
        if (utils$c.isDate(v2)) {
          v2 = v2.toISOString();
        } else if (utils$c.isObject(v2)) {
          v2 = JSON.stringify(v2);
        }
        parts.push(encode(key) + "=" + encode(v2));
      });
    });
    serializedParams = parts.join("&");
  }
  if (serializedParams) {
    var hashmarkIndex = url.indexOf("#");
    if (hashmarkIndex !== -1) {
      url = url.slice(0, hashmarkIndex);
    }
    url += (url.indexOf("?") === -1 ? "?" : "&") + serializedParams;
  }
  return url;
};
var utils$b = utils$d;
function InterceptorManager$1() {
  this.handlers = [];
}
InterceptorManager$1.prototype.use = function use3(fulfilled, rejected, options) {
  this.handlers.push({
    fulfilled,
    rejected,
    synchronous: options ? options.synchronous : false,
    runWhen: options ? options.runWhen : null
  });
  return this.handlers.length - 1;
};
InterceptorManager$1.prototype.eject = function eject3(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};
InterceptorManager$1.prototype.forEach = function forEach4(fn2) {
  utils$b.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn2(h);
    }
  });
};
var InterceptorManager_1 = InterceptorManager$1;
var utils$a = utils$d;
var normalizeHeaderName$1 = function normalizeHeaderName3(headers, normalizedName) {
  utils$a.forEach(headers, function processHeader(value, name2) {
    if (name2 !== normalizedName && name2.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name2];
    }
  });
};
var enhanceError$2 = function enhanceError3(error2, config, code, request4, response) {
  error2.config = config;
  if (code) {
    error2.code = code;
  }
  error2.request = request4;
  error2.response = response;
  error2.isAxiosError = true;
  error2.toJSON = function toJSON() {
    return {
      message: this.message,
      name: this.name,
      description: this.description,
      number: this.number,
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      config: this.config,
      code: this.code,
      status: this.response && this.response.status ? this.response.status : null
    };
  };
  return error2;
};
var enhanceError$1 = enhanceError$2;
var createError$2 = function createError3(message, config, code, request4, response) {
  var error2 = new Error(message);
  return enhanceError$1(error2, config, code, request4, response);
};
var createError$1 = createError$2;
var settle$1 = function settle3(resolve, reject, response) {
  var validateStatus4 = response.config.validateStatus;
  if (!response.status || !validateStatus4 || validateStatus4(response.status)) {
    resolve(response);
  } else {
    reject(createError$1("Request failed with status code " + response.status, response.config, null, response.request, response));
  }
};
var utils$9 = utils$d;
var cookies$1 = utils$9.isStandardBrowserEnv() ? function standardBrowserEnv5() {
  return {
    write: function write(name2, value, expires, path2, domain, secure) {
      var cookie = [];
      cookie.push(name2 + "=" + encodeURIComponent(value));
      if (utils$9.isNumber(expires)) {
        cookie.push("expires=" + new Date(expires).toGMTString());
      }
      if (utils$9.isString(path2)) {
        cookie.push("path=" + path2);
      }
      if (utils$9.isString(domain)) {
        cookie.push("domain=" + domain);
      }
      if (secure === true) {
        cookie.push("secure");
      }
      document.cookie = cookie.join("; ");
    },
    read: function read(name2) {
      var match = document.cookie.match(new RegExp("(^|;\\s*)(" + name2 + ")=([^;]*)"));
      return match ? decodeURIComponent(match[3]) : null;
    },
    remove: function remove(name2) {
      this.write(name2, "", Date.now() - 864e5);
    }
  };
}() : function nonStandardBrowserEnv5() {
  return {
    write: function write() {
    },
    read: function read() {
      return null;
    },
    remove: function remove() {
    }
  };
}();
var isAbsoluteURL$1 = function isAbsoluteURL3(url) {
  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};
var combineURLs$1 = function combineURLs3(baseURL, relativeURL) {
  return relativeURL ? baseURL.replace(/\/+$/, "") + "/" + relativeURL.replace(/^\/+/, "") : baseURL;
};
var isAbsoluteURL4 = isAbsoluteURL$1;
var combineURLs4 = combineURLs$1;
var buildFullPath$1 = function buildFullPath3(baseURL, requestedURL) {
  if (baseURL && !isAbsoluteURL4(requestedURL)) {
    return combineURLs4(baseURL, requestedURL);
  }
  return requestedURL;
};
var utils$8 = utils$d;
var ignoreDuplicateOf = [
  "age",
  "authorization",
  "content-length",
  "content-type",
  "etag",
  "expires",
  "from",
  "host",
  "if-modified-since",
  "if-unmodified-since",
  "last-modified",
  "location",
  "max-forwards",
  "proxy-authorization",
  "referer",
  "retry-after",
  "user-agent"
];
var parseHeaders$1 = function parseHeaders3(headers) {
  var parsed = {};
  var key;
  var val;
  var i2;
  if (!headers) {
    return parsed;
  }
  utils$8.forEach(headers.split("\n"), function parser(line) {
    i2 = line.indexOf(":");
    key = utils$8.trim(line.substr(0, i2)).toLowerCase();
    val = utils$8.trim(line.substr(i2 + 1));
    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === "set-cookie") {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ", " + val : val;
      }
    }
  });
  return parsed;
};
var utils$7 = utils$d;
var isURLSameOrigin$1 = utils$7.isStandardBrowserEnv() ? function standardBrowserEnv6() {
  var msie = /(msie|trident)/i.test(navigator.userAgent);
  var urlParsingNode = document.createElement("a");
  var originURL;
  function resolveURL(url) {
    var href = url;
    if (msie) {
      urlParsingNode.setAttribute("href", href);
      href = urlParsingNode.href;
    }
    urlParsingNode.setAttribute("href", href);
    return {
      href: urlParsingNode.href,
      protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, "") : "",
      host: urlParsingNode.host,
      search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, "") : "",
      hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, "") : "",
      hostname: urlParsingNode.hostname,
      port: urlParsingNode.port,
      pathname: urlParsingNode.pathname.charAt(0) === "/" ? urlParsingNode.pathname : "/" + urlParsingNode.pathname
    };
  }
  originURL = resolveURL(window.location.href);
  return function isURLSameOrigin2(requestURL) {
    var parsed = utils$7.isString(requestURL) ? resolveURL(requestURL) : requestURL;
    return parsed.protocol === originURL.protocol && parsed.host === originURL.host;
  };
}() : function nonStandardBrowserEnv6() {
  return function isURLSameOrigin2() {
    return true;
  };
}();
function Cancel$3(message) {
  this.message = message;
}
Cancel$3.prototype.toString = function toString4() {
  return "Cancel" + (this.message ? ": " + this.message : "");
};
Cancel$3.prototype.__CANCEL__ = true;
var Cancel_1 = Cancel$3;
var utils$6 = utils$d;
var settle4 = settle$1;
var cookies = cookies$1;
var buildURL$1 = buildURL$2;
var buildFullPath4 = buildFullPath$1;
var parseHeaders4 = parseHeaders$1;
var isURLSameOrigin = isURLSameOrigin$1;
var createError4 = createError$2;
var defaults$4 = defaults_1;
var Cancel$2 = Cancel_1;
var xhr = function xhrAdapter3(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;
    var responseType = config.responseType;
    var onCanceled;
    function done2() {
      if (config.cancelToken) {
        config.cancelToken.unsubscribe(onCanceled);
      }
      if (config.signal) {
        config.signal.removeEventListener("abort", onCanceled);
      }
    }
    if (utils$6.isFormData(requestData)) {
      delete requestHeaders["Content-Type"];
    }
    var request4 = new XMLHttpRequest();
    if (config.auth) {
      var username = config.auth.username || "";
      var password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : "";
      requestHeaders.Authorization = "Basic " + btoa(username + ":" + password);
    }
    var fullPath = buildFullPath4(config.baseURL, config.url);
    request4.open(config.method.toUpperCase(), buildURL$1(fullPath, config.params, config.paramsSerializer), true);
    request4.timeout = config.timeout;
    function onloadend() {
      if (!request4) {
        return;
      }
      var responseHeaders = "getAllResponseHeaders" in request4 ? parseHeaders4(request4.getAllResponseHeaders()) : null;
      var responseData = !responseType || responseType === "text" || responseType === "json" ? request4.responseText : request4.response;
      var response = {
        data: responseData,
        status: request4.status,
        statusText: request4.statusText,
        headers: responseHeaders,
        config,
        request: request4
      };
      settle4(function _resolve(value) {
        resolve(value);
        done2();
      }, function _reject(err) {
        reject(err);
        done2();
      }, response);
      request4 = null;
    }
    if ("onloadend" in request4) {
      request4.onloadend = onloadend;
    } else {
      request4.onreadystatechange = function handleLoad() {
        if (!request4 || request4.readyState !== 4) {
          return;
        }
        if (request4.status === 0 && !(request4.responseURL && request4.responseURL.indexOf("file:") === 0)) {
          return;
        }
        setTimeout(onloadend);
      };
    }
    request4.onabort = function handleAbort() {
      if (!request4) {
        return;
      }
      reject(createError4("Request aborted", config, "ECONNABORTED", request4));
      request4 = null;
    };
    request4.onerror = function handleError() {
      reject(createError4("Network Error", config, null, request4));
      request4 = null;
    };
    request4.ontimeout = function handleTimeout() {
      var timeoutErrorMessage = config.timeout ? "timeout of " + config.timeout + "ms exceeded" : "timeout exceeded";
      var transitional4 = config.transitional || defaults$4.transitional;
      if (config.timeoutErrorMessage) {
        timeoutErrorMessage = config.timeoutErrorMessage;
      }
      reject(createError4(timeoutErrorMessage, config, transitional4.clarifyTimeoutError ? "ETIMEDOUT" : "ECONNABORTED", request4));
      request4 = null;
    };
    if (utils$6.isStandardBrowserEnv()) {
      var xsrfValue = (config.withCredentials || isURLSameOrigin(fullPath)) && config.xsrfCookieName ? cookies.read(config.xsrfCookieName) : void 0;
      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }
    if ("setRequestHeader" in request4) {
      utils$6.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === "undefined" && key.toLowerCase() === "content-type") {
          delete requestHeaders[key];
        } else {
          request4.setRequestHeader(key, val);
        }
      });
    }
    if (!utils$6.isUndefined(config.withCredentials)) {
      request4.withCredentials = !!config.withCredentials;
    }
    if (responseType && responseType !== "json") {
      request4.responseType = config.responseType;
    }
    if (typeof config.onDownloadProgress === "function") {
      request4.addEventListener("progress", config.onDownloadProgress);
    }
    if (typeof config.onUploadProgress === "function" && request4.upload) {
      request4.upload.addEventListener("progress", config.onUploadProgress);
    }
    if (config.cancelToken || config.signal) {
      onCanceled = function(cancel2) {
        if (!request4) {
          return;
        }
        reject(!cancel2 || cancel2 && cancel2.type ? new Cancel$2("canceled") : cancel2);
        request4.abort();
        request4 = null;
      };
      config.cancelToken && config.cancelToken.subscribe(onCanceled);
      if (config.signal) {
        config.signal.aborted ? onCanceled() : config.signal.addEventListener("abort", onCanceled);
      }
    }
    if (!requestData) {
      requestData = null;
    }
    request4.send(requestData);
  });
};
var utils$5 = utils$d;
var normalizeHeaderName4 = normalizeHeaderName$1;
var enhanceError4 = enhanceError$2;
var DEFAULT_CONTENT_TYPE = {
  "Content-Type": "application/x-www-form-urlencoded"
};
function setContentTypeIfUnset(headers, value) {
  if (!utils$5.isUndefined(headers) && utils$5.isUndefined(headers["Content-Type"])) {
    headers["Content-Type"] = value;
  }
}
function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== "undefined") {
    adapter = xhr;
  } else if (typeof process !== "undefined" && Object.prototype.toString.call(process) === "[object process]") {
    adapter = xhr;
  }
  return adapter;
}
function stringifySafely(rawValue, parser, encoder) {
  if (utils$5.isString(rawValue)) {
    try {
      (parser || JSON.parse)(rawValue);
      return utils$5.trim(rawValue);
    } catch (e2) {
      if (e2.name !== "SyntaxError") {
        throw e2;
      }
    }
  }
  return (encoder || JSON.stringify)(rawValue);
}
var defaults$3 = {
  transitional: {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false
  },
  adapter: getDefaultAdapter(),
  transformRequest: [function transformRequest3(data2, headers) {
    normalizeHeaderName4(headers, "Accept");
    normalizeHeaderName4(headers, "Content-Type");
    if (utils$5.isFormData(data2) || utils$5.isArrayBuffer(data2) || utils$5.isBuffer(data2) || utils$5.isStream(data2) || utils$5.isFile(data2) || utils$5.isBlob(data2)) {
      return data2;
    }
    if (utils$5.isArrayBufferView(data2)) {
      return data2.buffer;
    }
    if (utils$5.isURLSearchParams(data2)) {
      setContentTypeIfUnset(headers, "application/x-www-form-urlencoded;charset=utf-8");
      return data2.toString();
    }
    if (utils$5.isObject(data2) || headers && headers["Content-Type"] === "application/json") {
      setContentTypeIfUnset(headers, "application/json");
      return stringifySafely(data2);
    }
    return data2;
  }],
  transformResponse: [function transformResponse3(data2) {
    var transitional4 = this.transitional || defaults$3.transitional;
    var silentJSONParsing = transitional4 && transitional4.silentJSONParsing;
    var forcedJSONParsing = transitional4 && transitional4.forcedJSONParsing;
    var strictJSONParsing = !silentJSONParsing && this.responseType === "json";
    if (strictJSONParsing || forcedJSONParsing && utils$5.isString(data2) && data2.length) {
      try {
        return JSON.parse(data2);
      } catch (e2) {
        if (strictJSONParsing) {
          if (e2.name === "SyntaxError") {
            throw enhanceError4(e2, this, "E_JSON_PARSE");
          }
          throw e2;
        }
      }
    }
    return data2;
  }],
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  validateStatus: function validateStatus3(status) {
    return status >= 200 && status < 300;
  },
  headers: {
    common: {
      "Accept": "application/json, text/plain, */*"
    }
  }
};
utils$5.forEach(["delete", "get", "head"], function forEachMethodNoData5(method) {
  defaults$3.headers[method] = {};
});
utils$5.forEach(["post", "put", "patch"], function forEachMethodWithData5(method) {
  defaults$3.headers[method] = utils$5.merge(DEFAULT_CONTENT_TYPE);
});
var defaults_1 = defaults$3;
var utils$4 = utils$d;
var defaults$2 = defaults_1;
var transformData$1 = function transformData3(data2, headers, fns) {
  var context = this || defaults$2;
  utils$4.forEach(fns, function transform(fn2) {
    data2 = fn2.call(context, data2, headers);
  });
  return data2;
};
var isCancel$1 = function isCancel3(value) {
  return !!(value && value.__CANCEL__);
};
var utils$3 = utils$d;
var transformData4 = transformData$1;
var isCancel4 = isCancel$1;
var defaults$1 = defaults_1;
var Cancel$1 = Cancel_1;
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
  if (config.signal && config.signal.aborted) {
    throw new Cancel$1("canceled");
  }
}
var dispatchRequest$1 = function dispatchRequest3(config) {
  throwIfCancellationRequested(config);
  config.headers = config.headers || {};
  config.data = transformData4.call(config, config.data, config.headers, config.transformRequest);
  config.headers = utils$3.merge(config.headers.common || {}, config.headers[config.method] || {}, config.headers);
  utils$3.forEach(["delete", "get", "head", "post", "put", "patch", "common"], function cleanHeaderConfig(method) {
    delete config.headers[method];
  });
  var adapter = config.adapter || defaults$1.adapter;
  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);
    response.data = transformData4.call(config, response.data, response.headers, config.transformResponse);
    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel4(reason)) {
      throwIfCancellationRequested(config);
      if (reason && reason.response) {
        reason.response.data = transformData4.call(config, reason.response.data, reason.response.headers, config.transformResponse);
      }
    }
    return Promise.reject(reason);
  });
};
var utils$2 = utils$d;
var mergeConfig$2 = function mergeConfig3(config1, config2) {
  config2 = config2 || {};
  var config = {};
  function getMergedValue(target, source4) {
    if (utils$2.isPlainObject(target) && utils$2.isPlainObject(source4)) {
      return utils$2.merge(target, source4);
    } else if (utils$2.isPlainObject(source4)) {
      return utils$2.merge({}, source4);
    } else if (utils$2.isArray(source4)) {
      return source4.slice();
    }
    return source4;
  }
  function mergeDeepProperties(prop) {
    if (!utils$2.isUndefined(config2[prop])) {
      return getMergedValue(config1[prop], config2[prop]);
    } else if (!utils$2.isUndefined(config1[prop])) {
      return getMergedValue(void 0, config1[prop]);
    }
  }
  function valueFromConfig2(prop) {
    if (!utils$2.isUndefined(config2[prop])) {
      return getMergedValue(void 0, config2[prop]);
    }
  }
  function defaultToConfig2(prop) {
    if (!utils$2.isUndefined(config2[prop])) {
      return getMergedValue(void 0, config2[prop]);
    } else if (!utils$2.isUndefined(config1[prop])) {
      return getMergedValue(void 0, config1[prop]);
    }
  }
  function mergeDirectKeys(prop) {
    if (prop in config2) {
      return getMergedValue(config1[prop], config2[prop]);
    } else if (prop in config1) {
      return getMergedValue(void 0, config1[prop]);
    }
  }
  var mergeMap = {
    "url": valueFromConfig2,
    "method": valueFromConfig2,
    "data": valueFromConfig2,
    "baseURL": defaultToConfig2,
    "transformRequest": defaultToConfig2,
    "transformResponse": defaultToConfig2,
    "paramsSerializer": defaultToConfig2,
    "timeout": defaultToConfig2,
    "timeoutMessage": defaultToConfig2,
    "withCredentials": defaultToConfig2,
    "adapter": defaultToConfig2,
    "responseType": defaultToConfig2,
    "xsrfCookieName": defaultToConfig2,
    "xsrfHeaderName": defaultToConfig2,
    "onUploadProgress": defaultToConfig2,
    "onDownloadProgress": defaultToConfig2,
    "decompress": defaultToConfig2,
    "maxContentLength": defaultToConfig2,
    "maxBodyLength": defaultToConfig2,
    "transport": defaultToConfig2,
    "httpAgent": defaultToConfig2,
    "httpsAgent": defaultToConfig2,
    "cancelToken": defaultToConfig2,
    "socketPath": defaultToConfig2,
    "responseEncoding": defaultToConfig2,
    "validateStatus": mergeDirectKeys
  };
  utils$2.forEach(Object.keys(config1).concat(Object.keys(config2)), function computeConfigValue(prop) {
    var merge2 = mergeMap[prop] || mergeDeepProperties;
    var configValue = merge2(prop);
    utils$2.isUndefined(configValue) && merge2 !== mergeDirectKeys || (config[prop] = configValue);
  });
  return config;
};
var data = {
  "version": "0.23.0"
};
var VERSION = data.version;
var validators$1 = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach(function(type2, i2) {
  validators$1[type2] = function validator2(thing) {
    return typeof thing === type2 || "a" + (i2 < 1 ? "n " : " ") + type2;
  };
});
var deprecatedWarnings = {};
validators$1.transitional = function transitional3(validator2, version2, message) {
  function formatMessage(opt, desc) {
    return "[Axios v" + VERSION + "] Transitional option '" + opt + "'" + desc + (message ? ". " + message : "");
  }
  return function(value, opt, opts) {
    if (validator2 === false) {
      throw new Error(formatMessage(opt, " has been removed" + (version2 ? " in " + version2 : "")));
    }
    if (version2 && !deprecatedWarnings[opt]) {
      deprecatedWarnings[opt] = true;
      console.warn(formatMessage(opt, " has been deprecated since v" + version2 + " and will be removed in the near future"));
    }
    return validator2 ? validator2(value, opt, opts) : true;
  };
};
function assertOptions(options, schema, allowUnknown) {
  if (typeof options !== "object") {
    throw new TypeError("options must be an object");
  }
  var keys = Object.keys(options);
  var i2 = keys.length;
  while (i2-- > 0) {
    var opt = keys[i2];
    var validator2 = schema[opt];
    if (validator2) {
      var value = options[opt];
      var result = value === void 0 || validator2(value, opt, options);
      if (result !== true) {
        throw new TypeError("option " + opt + " must be " + result);
      }
      continue;
    }
    if (allowUnknown !== true) {
      throw Error("Unknown option " + opt);
    }
  }
}
var validator$1 = {
  assertOptions,
  validators: validators$1
};
var utils$1 = utils$d;
var buildURL4 = buildURL$2;
var InterceptorManager = InterceptorManager_1;
var dispatchRequest4 = dispatchRequest$1;
var mergeConfig$1 = mergeConfig$2;
var validator = validator$1;
var validators = validator.validators;
function Axios$1(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}
Axios$1.prototype.request = function request3(config) {
  if (typeof config === "string") {
    config = arguments[1] || {};
    config.url = arguments[0];
  } else {
    config = config || {};
  }
  config = mergeConfig$1(this.defaults, config);
  if (config.method) {
    config.method = config.method.toLowerCase();
  } else if (this.defaults.method) {
    config.method = this.defaults.method.toLowerCase();
  } else {
    config.method = "get";
  }
  var transitional4 = config.transitional;
  if (transitional4 !== void 0) {
    validator.assertOptions(transitional4, {
      silentJSONParsing: validators.transitional(validators.boolean),
      forcedJSONParsing: validators.transitional(validators.boolean),
      clarifyTimeoutError: validators.transitional(validators.boolean)
    }, false);
  }
  var requestInterceptorChain = [];
  var synchronousRequestInterceptors = true;
  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    if (typeof interceptor.runWhen === "function" && interceptor.runWhen(config) === false) {
      return;
    }
    synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
    requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
  });
  var responseInterceptorChain = [];
  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
  });
  var promise;
  if (!synchronousRequestInterceptors) {
    var chain = [dispatchRequest4, void 0];
    Array.prototype.unshift.apply(chain, requestInterceptorChain);
    chain = chain.concat(responseInterceptorChain);
    promise = Promise.resolve(config);
    while (chain.length) {
      promise = promise.then(chain.shift(), chain.shift());
    }
    return promise;
  }
  var newConfig = config;
  while (requestInterceptorChain.length) {
    var onFulfilled = requestInterceptorChain.shift();
    var onRejected = requestInterceptorChain.shift();
    try {
      newConfig = onFulfilled(newConfig);
    } catch (error2) {
      onRejected(error2);
      break;
    }
  }
  try {
    promise = dispatchRequest4(newConfig);
  } catch (error2) {
    return Promise.reject(error2);
  }
  while (responseInterceptorChain.length) {
    promise = promise.then(responseInterceptorChain.shift(), responseInterceptorChain.shift());
  }
  return promise;
};
Axios$1.prototype.getUri = function getUri3(config) {
  config = mergeConfig$1(this.defaults, config);
  return buildURL4(config.url, config.params, config.paramsSerializer).replace(/^\?/, "");
};
utils$1.forEach(["delete", "get", "head", "options"], function forEachMethodNoData6(method) {
  Axios$1.prototype[method] = function(url, config) {
    return this.request(mergeConfig$1(config || {}, {
      method,
      url,
      data: (config || {}).data
    }));
  };
});
utils$1.forEach(["post", "put", "patch"], function forEachMethodWithData6(method) {
  Axios$1.prototype[method] = function(url, data2, config) {
    return this.request(mergeConfig$1(config || {}, {
      method,
      url,
      data: data2
    }));
  };
});
var Axios_1 = Axios$1;
var Cancel = Cancel_1;
function CancelToken(executor) {
  if (typeof executor !== "function") {
    throw new TypeError("executor must be a function.");
  }
  var resolvePromise;
  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });
  var token = this;
  this.promise.then(function(cancel2) {
    if (!token._listeners)
      return;
    var i2;
    var l2 = token._listeners.length;
    for (i2 = 0; i2 < l2; i2++) {
      token._listeners[i2](cancel2);
    }
    token._listeners = null;
  });
  this.promise.then = function(onfulfilled) {
    var _resolve;
    var promise = new Promise(function(resolve) {
      token.subscribe(resolve);
      _resolve = resolve;
    }).then(onfulfilled);
    promise.cancel = function reject() {
      token.unsubscribe(_resolve);
    };
    return promise;
  };
  executor(function cancel2(message) {
    if (token.reason) {
      return;
    }
    token.reason = new Cancel(message);
    resolvePromise(token.reason);
  });
}
CancelToken.prototype.throwIfRequested = function throwIfRequested3() {
  if (this.reason) {
    throw this.reason;
  }
};
CancelToken.prototype.subscribe = function subscribe2(listener) {
  if (this.reason) {
    listener(this.reason);
    return;
  }
  if (this._listeners) {
    this._listeners.push(listener);
  } else {
    this._listeners = [listener];
  }
};
CancelToken.prototype.unsubscribe = function unsubscribe2(listener) {
  if (!this._listeners) {
    return;
  }
  var index2 = this._listeners.indexOf(listener);
  if (index2 !== -1) {
    this._listeners.splice(index2, 1);
  }
};
CancelToken.source = function source3() {
  var cancel2;
  var token = new CancelToken(function executor(c2) {
    cancel2 = c2;
  });
  return {
    token,
    cancel: cancel2
  };
};
var CancelToken_1 = CancelToken;
var spread3 = function spread4(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};
var isAxiosError3 = function isAxiosError4(payload) {
  return typeof payload === "object" && payload.isAxiosError === true;
};
var utils = utils$d;
var bind4 = bind$2;
var Axios = Axios_1;
var mergeConfig4 = mergeConfig$2;
var defaults = defaults_1;
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind4(Axios.prototype.request, context);
  utils.extend(instance, Axios.prototype, context);
  utils.extend(instance, context);
  instance.create = function create3(instanceConfig) {
    return createInstance(mergeConfig4(defaultConfig, instanceConfig));
  };
  return instance;
}
var axios$1 = createInstance(defaults);
axios$1.Axios = Axios;
axios$1.Cancel = Cancel_1;
axios$1.CancelToken = CancelToken_1;
axios$1.isCancel = isCancel$1;
axios$1.VERSION = data.version;
axios$1.all = function all3(promises) {
  return Promise.all(promises);
};
axios$1.spread = spread3;
axios$1.isAxiosError = isAxiosError3;
axios$2.exports = axios$1;
axios$2.exports.default = axios$1;
var axios = axios$2.exports;
class NhostFunctionsClient {
  constructor(params) {
    const { url } = params;
    this.accessToken = null;
    this.instance = axios.create({
      baseURL: url
    });
  }
  async call(url, data2, config) {
    const headers = __spreadValues(__spreadValues({}, this.generateAccessTokenHeaders()), config == null ? void 0 : config.headers);
    let res;
    try {
      res = await this.instance.post(url, data2, __spreadProps(__spreadValues({}, config), { headers }));
    } catch (error2) {
      if (error2 instanceof Error) {
        return { res: null, error: error2 };
      }
    }
    if (!res) {
      return {
        res: null,
        error: new Error("Unable to make post request to funtion")
      };
    }
    return { res, error: null };
  }
  setAccessToken(accessToken) {
    if (!accessToken) {
      this.accessToken = null;
      return;
    }
    this.accessToken = accessToken;
  }
  generateAccessTokenHeaders() {
    if (!this.accessToken) {
      return;
    }
    return {
      Authorization: `Bearer ${this.accessToken}`
    };
  }
}
class NhostGraphqlClient {
  constructor(params) {
    const { url } = params;
    this.url = url;
    this.accessToken = null;
    this.instance = axios.create({
      baseURL: url
    });
  }
  async request(document2, variables, config) {
    const headers = __spreadValues(__spreadValues({}, config == null ? void 0 : config.headers), this.generateAccessTokenHeaders());
    const operationName = "";
    let responseData;
    try {
      const res = await this.instance.post("", {
        operationName: operationName || void 0,
        query: document2,
        variables
      }, __spreadProps(__spreadValues({}, config), { headers }));
      responseData = res.data;
    } catch (error2) {
      if (error2 instanceof Error) {
        return { data: null, error: error2 };
      }
      console.error(error2);
      return {
        data: null,
        error: new Error("Unable to get do GraphQL request")
      };
    }
    if (typeof responseData !== "object" || Array.isArray(responseData) || responseData === null) {
      return {
        data: null,
        error: new Error("incorrect response data from GraphQL server")
      };
    }
    responseData = responseData;
    if (responseData.errors) {
      return {
        data: null,
        error: responseData.errors
      };
    }
    return { data: responseData.data, error: null };
  }
  getUrl() {
    return this.url;
  }
  setAccessToken(accessToken) {
    if (!accessToken) {
      this.accessToken = null;
      return;
    }
    this.accessToken = accessToken;
  }
  generateAccessTokenHeaders() {
    if (!this.accessToken) {
      return;
    }
    return {
      Authorization: `Bearer ${this.accessToken}`
    };
  }
}
class NhostClient$1 {
  constructor({
    backendUrl,
    refreshIntervalTime,
    clientStorageGetter,
    clientStorageSetter,
    clientStorage,
    clientStorageType,
    autoRefreshToken,
    autoLogin,
    start: start2 = true,
    Client
  }) {
    if (!backendUrl)
      throw new Error("Please specify a `backendUrl`. Docs: [todo]!");
    this.auth = new HasuraAuthClient({
      url: `${backendUrl}/v1/auth`,
      refreshIntervalTime,
      clientStorageGetter,
      clientStorageSetter,
      clientStorage,
      clientStorageType,
      autoRefreshToken,
      autoLogin,
      start: start2,
      Client
    });
    this.storage = new HasuraStorageClient({
      url: `${backendUrl}/v1/storage`
    });
    this.functions = new NhostFunctionsClient({
      url: `${backendUrl}/v1/functions`
    });
    this.graphql = new NhostGraphqlClient({
      url: `${backendUrl}/v1/graphql`
    });
    this.storage.setAccessToken(this.auth.getAccessToken());
    this.functions.setAccessToken(this.auth.getAccessToken());
    this.graphql.setAccessToken(this.auth.getAccessToken());
    this.auth.client.onStart(() => {
      this.auth.onAuthStateChanged((_event, session) => {
        this.storage.setAccessToken(session == null ? void 0 : session.accessToken);
        this.functions.setAccessToken(session == null ? void 0 : session.accessToken);
        this.graphql.setAccessToken(session == null ? void 0 : session.accessToken);
      });
      this.auth.onTokenChanged((session) => {
        this.storage.setAccessToken(session == null ? void 0 : session.accessToken);
        this.functions.setAccessToken(session == null ? void 0 : session.accessToken);
        this.graphql.setAccessToken(session == null ? void 0 : session.accessToken);
      });
    });
  }
}
const suppressConsoleMessage = (message, method) => {
  const nativeConsoleMethod = console[method];
  console[method] = (nativeMessage) => {
    if (!RegExp(message, "gi").test(nativeMessage)) {
      nativeConsoleMethod(nativeMessage);
    }
  };
};
var ReactEffectType;
(function(ReactEffectType2) {
  ReactEffectType2[ReactEffectType2["Effect"] = 1] = "Effect";
  ReactEffectType2[ReactEffectType2["LayoutEffect"] = 2] = "LayoutEffect";
})(ReactEffectType || (ReactEffectType = {}));
var index = useLayoutEffect;
function useConstant(fn2) {
  var ref = React.useRef();
  if (!ref.current) {
    ref.current = { v: fn2() };
  }
  return ref.current.v;
}
var __read$3 = globalThis && globalThis.__read || function(o2, n2) {
  var m2 = typeof Symbol === "function" && o2[Symbol.iterator];
  if (!m2)
    return o2;
  var i2 = m2.call(o2), r2, ar = [], e2;
  try {
    while ((n2 === void 0 || n2-- > 0) && !(r2 = i2.next()).done)
      ar.push(r2.value);
  } catch (error2) {
    e2 = { error: error2 };
  } finally {
    try {
      if (r2 && !r2.done && (m2 = i2["return"]))
        m2.call(i2);
    } finally {
      if (e2)
        throw e2.error;
    }
  }
  return ar;
};
var __values = globalThis && globalThis.__values || function(o2) {
  var s2 = typeof Symbol === "function" && Symbol.iterator, m2 = s2 && o2[s2], i2 = 0;
  if (m2)
    return m2.call(o2);
  if (o2 && typeof o2.length === "number")
    return {
      next: function() {
        if (o2 && i2 >= o2.length)
          o2 = void 0;
        return { value: o2 && o2[i2++], done: !o2 };
      }
    };
  throw new TypeError(s2 ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
function partition(items, predicate) {
  var e_1, _a2;
  var _b = __read$3([[], []], 2), truthy = _b[0], falsy = _b[1];
  try {
    for (var items_1 = __values(items), items_1_1 = items_1.next(); !items_1_1.done; items_1_1 = items_1.next()) {
      var item = items_1_1.value;
      if (predicate(item)) {
        truthy.push(item);
      } else {
        falsy.push(item);
      }
    }
  } catch (e_1_1) {
    e_1 = { error: e_1_1 };
  } finally {
    try {
      if (items_1_1 && !items_1_1.done && (_a2 = items_1.return))
        _a2.call(items_1);
    } finally {
      if (e_1)
        throw e_1.error;
    }
  }
  return [truthy, falsy];
}
function getServiceSnapshot(service) {
  return service.status !== 0 ? service.state : service.machine.initialState;
}
var __read$2 = globalThis && globalThis.__read || function(o2, n2) {
  var m2 = typeof Symbol === "function" && o2[Symbol.iterator];
  if (!m2)
    return o2;
  var i2 = m2.call(o2), r2, ar = [], e2;
  try {
    while ((n2 === void 0 || n2-- > 0) && !(r2 = i2.next()).done)
      ar.push(r2.value);
  } catch (error2) {
    e2 = { error: error2 };
  } finally {
    try {
      if (r2 && !r2.done && (m2 = i2["return"]))
        m2.call(i2);
    } finally {
      if (e2)
        throw e2.error;
    }
  }
  return ar;
};
var __spreadArray = globalThis && globalThis.__spreadArray || function(to, from, pack) {
  if (pack || arguments.length === 2)
    for (var i2 = 0, l2 = from.length, ar; i2 < l2; i2++) {
      if (ar || !(i2 in from)) {
        if (!ar)
          ar = Array.prototype.slice.call(from, 0, i2);
        ar[i2] = from[i2];
      }
    }
  return to.concat(ar || Array.prototype.slice.call(from));
};
function executeEffect(action, state) {
  var exec = action.exec;
  var originalExec = exec(state.context, state._event.data, {
    action,
    state,
    _event: state._event
  });
  originalExec();
}
function useReactEffectActions(service) {
  var effectActionsRef = useRef([]);
  var layoutEffectActionsRef = useRef([]);
  index(function() {
    var sub = service.subscribe(function(currentState) {
      var _a2, _b;
      if (currentState.actions.length) {
        var reactEffectActions = currentState.actions.filter(function(action) {
          return typeof action.exec === "function" && "__effect" in action.exec;
        });
        var _c = __read$2(partition(reactEffectActions, function(action) {
          return action.exec.__effect === ReactEffectType.Effect;
        }), 2), effectActions = _c[0], layoutEffectActions = _c[1];
        (_a2 = effectActionsRef.current).push.apply(_a2, __spreadArray([], __read$2(effectActions.map(function(effectAction) {
          return [effectAction, currentState];
        })), false));
        (_b = layoutEffectActionsRef.current).push.apply(_b, __spreadArray([], __read$2(layoutEffectActions.map(function(layoutEffectAction) {
          return [layoutEffectAction, currentState];
        })), false));
      }
    });
    return function() {
      sub.unsubscribe();
    };
  }, []);
  index(function() {
    while (layoutEffectActionsRef.current.length) {
      var _a2 = __read$2(layoutEffectActionsRef.current.shift(), 2), layoutEffectAction = _a2[0], effectState = _a2[1];
      executeEffect(layoutEffectAction, effectState);
    }
  });
  useEffect(function() {
    while (effectActionsRef.current.length) {
      var _a2 = __read$2(effectActionsRef.current.shift(), 2), effectAction = _a2[0], effectState = _a2[1];
      executeEffect(effectAction, effectState);
    }
  });
}
var __assign = globalThis && globalThis.__assign || function() {
  __assign = Object.assign || function(t2) {
    for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
      s2 = arguments[i2];
      for (var p2 in s2)
        if (Object.prototype.hasOwnProperty.call(s2, p2))
          t2[p2] = s2[p2];
    }
    return t2;
  };
  return __assign.apply(this, arguments);
};
var __rest = globalThis && globalThis.__rest || function(s2, e2) {
  var t2 = {};
  for (var p2 in s2)
    if (Object.prototype.hasOwnProperty.call(s2, p2) && e2.indexOf(p2) < 0)
      t2[p2] = s2[p2];
  if (s2 != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i2 = 0, p2 = Object.getOwnPropertySymbols(s2); i2 < p2.length; i2++) {
      if (e2.indexOf(p2[i2]) < 0 && Object.prototype.propertyIsEnumerable.call(s2, p2[i2]))
        t2[p2[i2]] = s2[p2[i2]];
    }
  return t2;
};
var __read$1 = globalThis && globalThis.__read || function(o2, n2) {
  var m2 = typeof Symbol === "function" && o2[Symbol.iterator];
  if (!m2)
    return o2;
  var i2 = m2.call(o2), r2, ar = [], e2;
  try {
    while ((n2 === void 0 || n2-- > 0) && !(r2 = i2.next()).done)
      ar.push(r2.value);
  } catch (error2) {
    e2 = { error: error2 };
  } finally {
    try {
      if (r2 && !r2.done && (m2 = i2["return"]))
        m2.call(i2);
    } finally {
      if (e2)
        throw e2.error;
    }
  }
  return ar;
};
function toObserver(nextHandler, errorHandler, completionHandler) {
  if (typeof nextHandler === "object") {
    return nextHandler;
  }
  var noop = function() {
    return void 0;
  };
  return {
    next: nextHandler,
    error: errorHandler || noop,
    complete: completionHandler || noop
  };
}
function useInterpret(getMachine) {
  var _a2 = [];
  for (var _i = 1; _i < arguments.length; _i++) {
    _a2[_i - 1] = arguments[_i];
  }
  var _b = __read$1(_a2, 2), _c = _b[0], options = _c === void 0 ? {} : _c, observerOrListener = _b[1];
  var machine = useConstant(function() {
    return typeof getMachine === "function" ? getMachine() : getMachine;
  });
  var context = options.context, guards = options.guards, actions = options.actions, services = options.services, delays = options.delays, rehydratedState = options.state, interpreterOptions = __rest(options, ["context", "guards", "actions", "services", "delays", "state"]);
  var activities = options.activities;
  var service = useConstant(function() {
    var machineConfig = {
      context,
      guards,
      actions,
      activities,
      services,
      delays
    };
    var machineWithConfig = machine.withConfig(machineConfig, function() {
      return __assign(__assign({}, machine.context), context);
    });
    return interpret(machineWithConfig, __assign({ deferEvents: true }, interpreterOptions));
  });
  index(function() {
    var sub;
    if (observerOrListener) {
      sub = service.subscribe(toObserver(observerOrListener));
    }
    return function() {
      sub === null || sub === void 0 ? void 0 : sub.unsubscribe();
    };
  }, [observerOrListener]);
  index(function() {
    service.start(rehydratedState ? State.create(rehydratedState) : void 0);
    return function() {
      service.stop();
    };
  }, []);
  index(function() {
    Object.assign(service.machine.options.actions, actions);
    Object.assign(service.machine.options.guards, guards);
    Object.assign(service.machine.options.activities, activities);
    Object.assign(service.machine.options.services, services);
    Object.assign(service.machine.options.delays, delays);
  }, [actions, guards, activities, services, delays]);
  useReactEffectActions(service);
  return service;
}
var __read = globalThis && globalThis.__read || function(o2, n2) {
  var m2 = typeof Symbol === "function" && o2[Symbol.iterator];
  if (!m2)
    return o2;
  var i2 = m2.call(o2), r2, ar = [], e2;
  try {
    while ((n2 === void 0 || n2-- > 0) && !(r2 = i2.next()).done)
      ar.push(r2.value);
  } catch (error2) {
    e2 = { error: error2 };
  } finally {
    try {
      if (r2 && !r2.done && (m2 = i2["return"]))
        m2.call(i2);
    } finally {
      if (e2)
        throw e2.error;
    }
  }
  return ar;
};
globalThis && globalThis.__spreadArray || function(to, from, pack) {
  if (pack || arguments.length === 2)
    for (var i2 = 0, l2 = from.length, ar; i2 < l2; i2++) {
      if (ar || !(i2 in from)) {
        if (!ar)
          ar = Array.prototype.slice.call(from, 0, i2);
        ar[i2] = from[i2];
      }
    }
  return to.concat(ar || Array.prototype.slice.call(from));
};
function useMachine(getMachine) {
  var _a2 = [];
  for (var _i = 1; _i < arguments.length; _i++) {
    _a2[_i - 1] = arguments[_i];
  }
  var _b = __read(_a2, 1), _c = _b[0], options = _c === void 0 ? {} : _c;
  var listener = useCallback(function(nextState) {
    var initialStateChanged = nextState.changed === void 0 && Object.keys(nextState.children).length;
    if (nextState.changed || initialStateChanged) {
      setState(nextState);
    }
  }, []);
  var service = useInterpret(getMachine, options, listener);
  var _d = __read(useState(function() {
    var initialState = service.machine.initialState;
    return options.state ? State.create(options.state) : initialState;
  }), 2), state = _d[0], setState = _d[1];
  return [state, service.send, service];
}
globalThis && globalThis.__read || function(o2, n2) {
  var m2 = typeof Symbol === "function" && o2[Symbol.iterator];
  if (!m2)
    return o2;
  var i2 = m2.call(o2), r2, ar = [], e2;
  try {
    while ((n2 === void 0 || n2-- > 0) && !(r2 = i2.next()).done)
      ar.push(r2.value);
  } catch (error2) {
    e2 = { error: error2 };
  } finally {
    try {
      if (r2 && !r2.done && (m2 = i2["return"]))
        m2.call(i2);
    } finally {
      if (e2)
        throw e2.error;
    }
  }
  return ar;
};
function isActorWithState(actorRef) {
  return "state" in actorRef;
}
var useSubscription = { exports: {} };
var useSubscription_production_min = {};
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;
function toObject(val) {
  if (val === null || val === void 0) {
    throw new TypeError("Object.assign cannot be called with null or undefined");
  }
  return Object(val);
}
function shouldUseNative() {
  try {
    if (!Object.assign) {
      return false;
    }
    var test1 = new String("abc");
    test1[5] = "de";
    if (Object.getOwnPropertyNames(test1)[0] === "5") {
      return false;
    }
    var test2 = {};
    for (var i2 = 0; i2 < 10; i2++) {
      test2["_" + String.fromCharCode(i2)] = i2;
    }
    var order2 = Object.getOwnPropertyNames(test2).map(function(n2) {
      return test2[n2];
    });
    if (order2.join("") !== "0123456789") {
      return false;
    }
    var test3 = {};
    "abcdefghijklmnopqrst".split("").forEach(function(letter) {
      test3[letter] = letter;
    });
    if (Object.keys(Object.assign({}, test3)).join("") !== "abcdefghijklmnopqrst") {
      return false;
    }
    return true;
  } catch (err) {
    return false;
  }
}
var objectAssign = shouldUseNative() ? Object.assign : function(target, source4) {
  var from;
  var to = toObject(target);
  var symbols;
  for (var s2 = 1; s2 < arguments.length; s2++) {
    from = Object(arguments[s2]);
    for (var key in from) {
      if (hasOwnProperty.call(from, key)) {
        to[key] = from[key];
      }
    }
    if (getOwnPropertySymbols) {
      symbols = getOwnPropertySymbols(from);
      for (var i2 = 0; i2 < symbols.length; i2++) {
        if (propIsEnumerable.call(from, symbols[i2])) {
          to[symbols[i2]] = from[symbols[i2]];
        }
      }
    }
  }
  return to;
};
/** @license React vundefined
 * use-subscription.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var e = objectAssign, g$2 = React__default;
useSubscription_production_min.useSubscription = function(a2) {
  var c2 = a2.getCurrentValue, d2 = a2.subscribe, b2 = g$2.useState(function() {
    return { getCurrentValue: c2, subscribe: d2, value: c2() };
  });
  a2 = b2[0];
  var f2 = b2[1];
  b2 = a2.value;
  if (a2.getCurrentValue !== c2 || a2.subscribe !== d2)
    b2 = c2(), f2({ getCurrentValue: c2, subscribe: d2, value: b2 });
  g$2.useDebugValue(b2);
  g$2.useEffect(function() {
    function b3() {
      if (!a3) {
        var b4 = c2();
        f2(function(a4) {
          return a4.getCurrentValue !== c2 || a4.subscribe !== d2 || a4.value === b4 ? a4 : e({}, a4, { value: b4 });
        });
      }
    }
    var a3 = false, h = d2(b3);
    b3();
    return function() {
      a3 = true;
      h();
    };
  }, [c2, d2]);
  return b2;
};
{
  useSubscription.exports = useSubscription_production_min;
}
function isService(actor) {
  return "state" in actor && "machine" in actor;
}
var defaultCompare = function(a2, b2) {
  return a2 === b2;
};
var defaultGetSnapshot = function(a2) {
  return isService(a2) ? getServiceSnapshot(a2) : isActorWithState(a2) ? a2.state : void 0;
};
function useSelector(actor, selector, compare, getSnapshot) {
  if (compare === void 0) {
    compare = defaultCompare;
  }
  if (getSnapshot === void 0) {
    getSnapshot = defaultGetSnapshot;
  }
  var latestSelectorRef = useRef(selector);
  var subscription = useMemo(function() {
    var snapshot = getSnapshot(actor);
    var current = selector(snapshot);
    var notifySubscriber;
    return {
      getSnapshot: function() {
        return snapshot;
      },
      getCurrentValue: function() {
        return current;
      },
      setCurrentValue: function(newCurrent) {
        current = newCurrent;
        notifySubscriber === null || notifySubscriber === void 0 ? void 0 : notifySubscriber();
      },
      subscribe: function(callback) {
        notifySubscriber = callback;
        var sub = actor.subscribe(function(emitted) {
          snapshot = emitted;
          var next = latestSelectorRef.current(emitted);
          if (!compare(current, next)) {
            current = next;
            callback();
          }
        });
        return function() {
          sub.unsubscribe();
        };
      }
    };
  }, [actor]);
  var currentSelected = useSubscription.exports.useSubscription(subscription);
  var currentChanged = false;
  if (latestSelectorRef.current !== selector) {
    var selected = selector(subscription.getSnapshot());
    if (!compare(currentSelected, selected)) {
      currentChanged = true;
      currentSelected = selected;
    }
  }
  index(function() {
    latestSelectorRef.current = selector;
    if (currentChanged) {
      subscription.setCurrentValue(currentSelected);
    }
  });
  return currentSelected;
}
function n$1(n2) {
  for (var r2 = arguments.length, t2 = Array(r2 > 1 ? r2 - 1 : 0), e2 = 1; e2 < r2; e2++)
    t2[e2 - 1] = arguments[e2];
  throw Error("[Immer] minified error nr: " + n2 + (t2.length ? " " + t2.map(function(n3) {
    return "'" + n3 + "'";
  }).join(",") : "") + ". Find the full error at: https://bit.ly/3cXEKWf");
}
function r(n2) {
  return !!n2 && !!n2[Q];
}
function t(n2) {
  return !!n2 && (function(n3) {
    if (!n3 || typeof n3 != "object")
      return false;
    var r2 = Object.getPrototypeOf(n3);
    if (r2 === null)
      return true;
    var t2 = Object.hasOwnProperty.call(r2, "constructor") && r2.constructor;
    return t2 === Object || typeof t2 == "function" && Function.toString.call(t2) === Z;
  }(n2) || Array.isArray(n2) || !!n2[L] || !!n2.constructor[L] || s(n2) || v(n2));
}
function i(n2, r2, t2) {
  t2 === void 0 && (t2 = false), o(n2) === 0 ? (t2 ? Object.keys : nn)(n2).forEach(function(e2) {
    t2 && typeof e2 == "symbol" || r2(e2, n2[e2], n2);
  }) : n2.forEach(function(t3, e2) {
    return r2(e2, t3, n2);
  });
}
function o(n2) {
  var r2 = n2[Q];
  return r2 ? r2.i > 3 ? r2.i - 4 : r2.i : Array.isArray(n2) ? 1 : s(n2) ? 2 : v(n2) ? 3 : 0;
}
function u(n2, r2) {
  return o(n2) === 2 ? n2.has(r2) : Object.prototype.hasOwnProperty.call(n2, r2);
}
function a(n2, r2) {
  return o(n2) === 2 ? n2.get(r2) : n2[r2];
}
function f$1(n2, r2, t2) {
  var e2 = o(n2);
  e2 === 2 ? n2.set(r2, t2) : e2 === 3 ? (n2.delete(r2), n2.add(t2)) : n2[r2] = t2;
}
function c(n2, r2) {
  return n2 === r2 ? n2 !== 0 || 1 / n2 == 1 / r2 : n2 != n2 && r2 != r2;
}
function s(n2) {
  return X && n2 instanceof Map;
}
function v(n2) {
  return q$1 && n2 instanceof Set;
}
function p$1(n2) {
  return n2.o || n2.t;
}
function l(n2) {
  if (Array.isArray(n2))
    return Array.prototype.slice.call(n2);
  var r2 = rn(n2);
  delete r2[Q];
  for (var t2 = nn(r2), e2 = 0; e2 < t2.length; e2++) {
    var i2 = t2[e2], o2 = r2[i2];
    o2.writable === false && (o2.writable = true, o2.configurable = true), (o2.get || o2.set) && (r2[i2] = { configurable: true, writable: true, enumerable: o2.enumerable, value: n2[i2] });
  }
  return Object.create(Object.getPrototypeOf(n2), r2);
}
function d(n2, e2) {
  return e2 === void 0 && (e2 = false), y(n2) || r(n2) || !t(n2) ? n2 : (o(n2) > 1 && (n2.set = n2.add = n2.clear = n2.delete = h$1), Object.freeze(n2), e2 && i(n2, function(n3, r2) {
    return d(r2, true);
  }, true), n2);
}
function h$1() {
  n$1(2);
}
function y(n2) {
  return n2 == null || typeof n2 != "object" || Object.isFrozen(n2);
}
function b(r2) {
  var t2 = tn[r2];
  return t2 || n$1(18, r2), t2;
}
function _() {
  return U;
}
function j(n2, r2) {
  r2 && (b("Patches"), n2.u = [], n2.s = [], n2.v = r2);
}
function O(n2) {
  g$1(n2), n2.p.forEach(S), n2.p = null;
}
function g$1(n2) {
  n2 === U && (U = n2.l);
}
function w(n2) {
  return U = { p: [], l: U, h: n2, m: true, _: 0 };
}
function S(n2) {
  var r2 = n2[Q];
  r2.i === 0 || r2.i === 1 ? r2.j() : r2.O = true;
}
function P(r2, e2) {
  e2._ = e2.p.length;
  var i2 = e2.p[0], o2 = r2 !== void 0 && r2 !== i2;
  return e2.h.g || b("ES5").S(e2, r2, o2), o2 ? (i2[Q].P && (O(e2), n$1(4)), t(r2) && (r2 = M(e2, r2), e2.l || x(e2, r2)), e2.u && b("Patches").M(i2[Q].t, r2, e2.u, e2.s)) : r2 = M(e2, i2, []), O(e2), e2.u && e2.v(e2.u, e2.s), r2 !== H ? r2 : void 0;
}
function M(n2, r2, t2) {
  if (y(r2))
    return r2;
  var e2 = r2[Q];
  if (!e2)
    return i(r2, function(i2, o3) {
      return A(n2, e2, r2, i2, o3, t2);
    }, true), r2;
  if (e2.A !== n2)
    return r2;
  if (!e2.P)
    return x(n2, e2.t, true), e2.t;
  if (!e2.I) {
    e2.I = true, e2.A._--;
    var o2 = e2.i === 4 || e2.i === 5 ? e2.o = l(e2.k) : e2.o;
    i(e2.i === 3 ? new Set(o2) : o2, function(r3, i2) {
      return A(n2, e2, o2, r3, i2, t2);
    }), x(n2, o2, false), t2 && n2.u && b("Patches").R(e2, t2, n2.u, n2.s);
  }
  return e2.o;
}
function A(e2, i2, o2, a2, c2, s2) {
  if (r(c2)) {
    var v2 = M(e2, c2, s2 && i2 && i2.i !== 3 && !u(i2.D, a2) ? s2.concat(a2) : void 0);
    if (f$1(o2, a2, v2), !r(v2))
      return;
    e2.m = false;
  }
  if (t(c2) && !y(c2)) {
    if (!e2.h.F && e2._ < 1)
      return;
    M(e2, c2), i2 && i2.A.l || x(e2, c2);
  }
}
function x(n2, r2, t2) {
  t2 === void 0 && (t2 = false), n2.h.F && n2.m && d(r2, t2);
}
function z(n2, r2) {
  var t2 = n2[Q];
  return (t2 ? p$1(t2) : n2)[r2];
}
function I(n2, r2) {
  if (r2 in n2)
    for (var t2 = Object.getPrototypeOf(n2); t2; ) {
      var e2 = Object.getOwnPropertyDescriptor(t2, r2);
      if (e2)
        return e2;
      t2 = Object.getPrototypeOf(t2);
    }
}
function k(n2) {
  n2.P || (n2.P = true, n2.l && k(n2.l));
}
function E(n2) {
  n2.o || (n2.o = l(n2.t));
}
function R(n2, r2, t2) {
  var e2 = s(r2) ? b("MapSet").N(r2, t2) : v(r2) ? b("MapSet").T(r2, t2) : n2.g ? function(n3, r3) {
    var t3 = Array.isArray(n3), e3 = { i: t3 ? 1 : 0, A: r3 ? r3.A : _(), P: false, I: false, D: {}, l: r3, t: n3, k: null, o: null, j: null, C: false }, i2 = e3, o2 = en;
    t3 && (i2 = [e3], o2 = on);
    var u2 = Proxy.revocable(i2, o2), a2 = u2.revoke, f2 = u2.proxy;
    return e3.k = f2, e3.j = a2, f2;
  }(r2, t2) : b("ES5").J(r2, t2);
  return (t2 ? t2.A : _()).p.push(e2), e2;
}
function D(e2) {
  return r(e2) || n$1(22, e2), function n2(r2) {
    if (!t(r2))
      return r2;
    var e3, u2 = r2[Q], c2 = o(r2);
    if (u2) {
      if (!u2.P && (u2.i < 4 || !b("ES5").K(u2)))
        return u2.t;
      u2.I = true, e3 = F(r2, c2), u2.I = false;
    } else
      e3 = F(r2, c2);
    return i(e3, function(r3, t2) {
      u2 && a(u2.t, r3) === t2 || f$1(e3, r3, n2(t2));
    }), c2 === 3 ? new Set(e3) : e3;
  }(e2);
}
function F(n2, r2) {
  switch (r2) {
    case 2:
      return new Map(n2);
    case 3:
      return Array.from(n2);
  }
  return l(n2);
}
var G, U, W = typeof Symbol != "undefined" && typeof Symbol("x") == "symbol", X = typeof Map != "undefined", q$1 = typeof Set != "undefined", B = typeof Proxy != "undefined" && Proxy.revocable !== void 0 && typeof Reflect != "undefined", H = W ? Symbol.for("immer-nothing") : ((G = {})["immer-nothing"] = true, G), L = W ? Symbol.for("immer-draftable") : "__$immer_draftable", Q = W ? Symbol.for("immer-state") : "__$immer_state", Z = "" + Object.prototype.constructor, nn = typeof Reflect != "undefined" && Reflect.ownKeys ? Reflect.ownKeys : Object.getOwnPropertySymbols !== void 0 ? function(n2) {
  return Object.getOwnPropertyNames(n2).concat(Object.getOwnPropertySymbols(n2));
} : Object.getOwnPropertyNames, rn = Object.getOwnPropertyDescriptors || function(n2) {
  var r2 = {};
  return nn(n2).forEach(function(t2) {
    r2[t2] = Object.getOwnPropertyDescriptor(n2, t2);
  }), r2;
}, tn = {}, en = { get: function(n2, r2) {
  if (r2 === Q)
    return n2;
  var e2 = p$1(n2);
  if (!u(e2, r2))
    return function(n3, r3, t2) {
      var e3, i3 = I(r3, t2);
      return i3 ? "value" in i3 ? i3.value : (e3 = i3.get) === null || e3 === void 0 ? void 0 : e3.call(n3.k) : void 0;
    }(n2, e2, r2);
  var i2 = e2[r2];
  return n2.I || !t(i2) ? i2 : i2 === z(n2.t, r2) ? (E(n2), n2.o[r2] = R(n2.A.h, i2, n2)) : i2;
}, has: function(n2, r2) {
  return r2 in p$1(n2);
}, ownKeys: function(n2) {
  return Reflect.ownKeys(p$1(n2));
}, set: function(n2, r2, t2) {
  var e2 = I(p$1(n2), r2);
  if (e2 == null ? void 0 : e2.set)
    return e2.set.call(n2.k, t2), true;
  if (!n2.P) {
    var i2 = z(p$1(n2), r2), o2 = i2 == null ? void 0 : i2[Q];
    if (o2 && o2.t === t2)
      return n2.o[r2] = t2, n2.D[r2] = false, true;
    if (c(t2, i2) && (t2 !== void 0 || u(n2.t, r2)))
      return true;
    E(n2), k(n2);
  }
  return n2.o[r2] === t2 && typeof t2 != "number" && (t2 !== void 0 || r2 in n2.o) || (n2.o[r2] = t2, n2.D[r2] = true, true);
}, deleteProperty: function(n2, r2) {
  return z(n2.t, r2) !== void 0 || r2 in n2.t ? (n2.D[r2] = false, E(n2), k(n2)) : delete n2.D[r2], n2.o && delete n2.o[r2], true;
}, getOwnPropertyDescriptor: function(n2, r2) {
  var t2 = p$1(n2), e2 = Reflect.getOwnPropertyDescriptor(t2, r2);
  return e2 ? { writable: true, configurable: n2.i !== 1 || r2 !== "length", enumerable: e2.enumerable, value: t2[r2] } : e2;
}, defineProperty: function() {
  n$1(11);
}, getPrototypeOf: function(n2) {
  return Object.getPrototypeOf(n2.t);
}, setPrototypeOf: function() {
  n$1(12);
} }, on = {};
i(en, function(n2, r2) {
  on[n2] = function() {
    return arguments[0] = arguments[0][0], r2.apply(this, arguments);
  };
}), on.deleteProperty = function(r2, t2) {
  return on.set.call(this, r2, t2, void 0);
}, on.set = function(r2, t2, e2) {
  return en.set.call(this, r2[0], t2, e2, r2[0]);
};
var un = function() {
  function e2(r2) {
    var e3 = this;
    this.g = B, this.F = true, this.produce = function(r3, i3, o2) {
      if (typeof r3 == "function" && typeof i3 != "function") {
        var u2 = i3;
        i3 = r3;
        var a2 = e3;
        return function(n2) {
          var r4 = this;
          n2 === void 0 && (n2 = u2);
          for (var t2 = arguments.length, e4 = Array(t2 > 1 ? t2 - 1 : 0), o3 = 1; o3 < t2; o3++)
            e4[o3 - 1] = arguments[o3];
          return a2.produce(n2, function(n3) {
            var t3;
            return (t3 = i3).call.apply(t3, [r4, n3].concat(e4));
          });
        };
      }
      var f2;
      if (typeof i3 != "function" && n$1(6), o2 !== void 0 && typeof o2 != "function" && n$1(7), t(r3)) {
        var c2 = w(e3), s2 = R(e3, r3, void 0), v2 = true;
        try {
          f2 = i3(s2), v2 = false;
        } finally {
          v2 ? O(c2) : g$1(c2);
        }
        return typeof Promise != "undefined" && f2 instanceof Promise ? f2.then(function(n2) {
          return j(c2, o2), P(n2, c2);
        }, function(n2) {
          throw O(c2), n2;
        }) : (j(c2, o2), P(f2, c2));
      }
      if (!r3 || typeof r3 != "object") {
        if ((f2 = i3(r3)) === void 0 && (f2 = r3), f2 === H && (f2 = void 0), e3.F && d(f2, true), o2) {
          var p2 = [], l2 = [];
          b("Patches").M(r3, f2, p2, l2), o2(p2, l2);
        }
        return f2;
      }
      n$1(21, r3);
    }, this.produceWithPatches = function(n2, r3) {
      if (typeof n2 == "function")
        return function(r4) {
          for (var t3 = arguments.length, i4 = Array(t3 > 1 ? t3 - 1 : 0), o3 = 1; o3 < t3; o3++)
            i4[o3 - 1] = arguments[o3];
          return e3.produceWithPatches(r4, function(r5) {
            return n2.apply(void 0, [r5].concat(i4));
          });
        };
      var t2, i3, o2 = e3.produce(n2, r3, function(n3, r4) {
        t2 = n3, i3 = r4;
      });
      return typeof Promise != "undefined" && o2 instanceof Promise ? o2.then(function(n3) {
        return [n3, t2, i3];
      }) : [o2, t2, i3];
    }, typeof (r2 == null ? void 0 : r2.useProxies) == "boolean" && this.setUseProxies(r2.useProxies), typeof (r2 == null ? void 0 : r2.autoFreeze) == "boolean" && this.setAutoFreeze(r2.autoFreeze);
  }
  var i2 = e2.prototype;
  return i2.createDraft = function(e3) {
    t(e3) || n$1(8), r(e3) && (e3 = D(e3));
    var i3 = w(this), o2 = R(this, e3, void 0);
    return o2[Q].C = true, g$1(i3), o2;
  }, i2.finishDraft = function(r2, t2) {
    var e3 = r2 && r2[Q];
    var i3 = e3.A;
    return j(i3, t2), P(void 0, i3);
  }, i2.setAutoFreeze = function(n2) {
    this.F = n2;
  }, i2.setUseProxies = function(r2) {
    r2 && !B && n$1(20), this.g = r2;
  }, i2.applyPatches = function(n2, t2) {
    var e3;
    for (e3 = t2.length - 1; e3 >= 0; e3--) {
      var i3 = t2[e3];
      if (i3.path.length === 0 && i3.op === "replace") {
        n2 = i3.value;
        break;
      }
    }
    e3 > -1 && (t2 = t2.slice(e3 + 1));
    var o2 = b("Patches").$;
    return r(n2) ? o2(n2, t2) : this.produce(n2, function(n3) {
      return o2(n3, t2);
    });
  }, e2;
}(), an = new un(), fn = an.produce;
an.produceWithPatches.bind(an);
an.setAutoFreeze.bind(an);
an.setUseProxies.bind(an);
an.applyPatches.bind(an);
an.createDraft.bind(an);
an.finishDraft.bind(an);
var produce = fn;
var jsxRuntime = { exports: {} };
var reactJsxRuntime_production_min = {};
/** @license React v17.0.2
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var f = React__default, g = 60103;
reactJsxRuntime_production_min.Fragment = 60107;
if (typeof Symbol === "function" && Symbol.for) {
  var h = Symbol.for;
  g = h("react.element");
  reactJsxRuntime_production_min.Fragment = h("react.fragment");
}
var m = f.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, n = Object.prototype.hasOwnProperty, p = { key: true, ref: true, __self: true, __source: true };
function q(c2, a2, k2) {
  var b2, d2 = {}, e2 = null, l2 = null;
  k2 !== void 0 && (e2 = "" + k2);
  a2.key !== void 0 && (e2 = "" + a2.key);
  a2.ref !== void 0 && (l2 = a2.ref);
  for (b2 in a2)
    n.call(a2, b2) && !p.hasOwnProperty(b2) && (d2[b2] = a2[b2]);
  if (c2 && c2.defaultProps)
    for (b2 in a2 = c2.defaultProps, a2)
      d2[b2] === void 0 && (d2[b2] = a2[b2]);
  return { $$typeof: g, type: c2, key: e2, ref: l2, props: d2, _owner: m.current };
}
reactJsxRuntime_production_min.jsx = q;
reactJsxRuntime_production_min.jsxs = q;
{
  jsxRuntime.exports = reactJsxRuntime_production_min;
}
const jsx = jsxRuntime.exports.jsx;
const NhostReactContext = createContext({});
const NhostReactProvider = (_b) => {
  var _c = _b, {
    nhost,
    initial
  } = _c, props = __objRest(_c, [
    "nhost",
    "initial"
  ]);
  const machine = nhost.auth.client.machine;
  const interpreter = useInterpret(machine, {
    devTools: typeof window !== "undefined" && false,
    context: produce(machine.context, (ctx) => {
      var _a2, _b2;
      if (initial) {
        ctx.user = initial.user;
        ctx.refreshToken.value = (_a2 = initial.refreshToken) != null ? _a2 : null;
        ctx.accessToken.value = (_b2 = initial.accessToken) != null ? _b2 : null;
        ctx.accessToken.expiresAt = new Date(Date.now() + initial.accessTokenExpiresIn * 1e3);
      }
    })
  });
  const isInitialMount = useRef(true);
  useEffect(() => {
    if (isInitialMount.current) {
      isInitialMount.current = false;
    } else {
      if (initial) {
        interpreter.send({
          type: "SESSION_UPDATE",
          data: {
            session: initial
          }
        });
      }
    }
  }, [initial, interpreter]);
  nhost.auth.client.interpreter = interpreter;
  return /* @__PURE__ */ jsx(NhostReactContext.Provider, {
    value: nhost,
    children: props.children
  });
};
const useNhostClient = () => {
  const nhost = useContext(NhostReactContext);
  return nhost;
};
const useAuthInterpreter = () => {
  const nhost = useContext(NhostReactContext);
  const interpreter = nhost.auth.client.interpreter;
  if (!interpreter)
    throw Error("No interpreter");
  return interpreter;
};
const useNhostBackendUrl = () => {
  const nhost = useContext(NhostReactContext);
  return nhost.auth.client.backendUrl.replace("/v1/auth", "");
};
const useAuthLoading = () => {
  const service = useAuthInterpreter();
  return useSelector(service, (state) => !state.hasTag("ready"));
};
const useAuthenticationStatus = () => {
  const service = useAuthInterpreter();
  return useSelector(service, (state) => ({
    isAuthenticated: state.matches({ authentication: "signedIn" }),
    isLoading: !state.hasTag("ready")
  }), (a2, b2) => a2.isAuthenticated === b2.isAuthenticated && a2.isLoading === b2.isLoading);
};
const useAuthenticated = () => {
  const service = useAuthInterpreter();
  const [isAuthenticated, setIsAuthenticated] = useState(!!service.status && service.state.matches({ authentication: "signedIn" }));
  useEffect(() => {
    const subscription = service.subscribe((state) => {
      const newValue = state.matches({ authentication: "signedIn" });
      setIsAuthenticated(newValue);
    });
    return subscription.unsubscribe;
  }, [service]);
  return isAuthenticated;
};
const useAccessToken = () => {
  const service = useAuthInterpreter();
  return useSelector(service, (state) => state.context.accessToken.value);
};
const useSignOut = (stateAll = false) => {
  const service = useAuthInterpreter();
  const signOut = (valueAll) => service.send({ type: "SIGNOUT", all: typeof valueAll === "boolean" ? valueAll : stateAll });
  const isSuccess = !!service.status && service.state.matches({ authentication: { signedOut: "success" } });
  return { signOut, isSuccess };
};
const useSignInEmailPassword = (stateEmail, statePassword, stateOtp) => {
  const service = useAuthInterpreter();
  const signInEmailPassword = (valueEmail, valuePassword) => new Promise((resolve) => {
    service.send({
      type: "SIGNIN_PASSWORD",
      email: typeof valueEmail === "string" ? valueEmail : stateEmail,
      password: typeof valuePassword === "string" ? valuePassword : statePassword
    });
    service.onTransition((state) => {
      if (state.matches({ authentication: { signedOut: "needsEmailVerification" } })) {
        resolve({
          accessToken: null,
          error: null,
          isError: false,
          isSuccess: false,
          needsEmailVerification: true,
          needsMfaOtp: false,
          user: null
        });
      } else if (state.matches({ authentication: { signedOut: "needsMfa" } })) {
        resolve({
          accessToken: null,
          error: null,
          isError: false,
          isSuccess: false,
          needsEmailVerification: false,
          needsMfaOtp: true,
          user: null
        });
      } else if (state.matches({ authentication: { signedOut: "failed" } })) {
        resolve({
          accessToken: null,
          error: state.context.errors.authentication || null,
          isError: true,
          isSuccess: false,
          needsEmailVerification: false,
          needsMfaOtp: false,
          user: null
        });
      } else if (state.matches({ authentication: "signedIn" })) {
        resolve({
          accessToken: state.context.accessToken.value,
          error: null,
          isError: false,
          isSuccess: true,
          needsEmailVerification: false,
          needsMfaOtp: false,
          user: state.context.user
        });
      }
    });
  });
  const sendMfaOtp = (valueOtp) => {
    service.send({
      type: "SIGNIN_MFA_TOTP",
      otp: typeof valueOtp === "string" ? valueOtp : stateOtp
    });
  };
  const user = useSelector(service, (state) => state.context.user, (a2, b2) => (a2 == null ? void 0 : a2.id) === (b2 == null ? void 0 : b2.id));
  const accessToken = useSelector(service, (state) => state.context.accessToken.value);
  const error2 = useSelector(service, (state) => state.context.errors.authentication || null, (a2, b2) => (a2 == null ? void 0 : a2.error) === (b2 == null ? void 0 : b2.error));
  const isSuccess = useAuthenticated();
  const isLoading = useSelector(service, (state) => state.matches({ authentication: { authenticating: "password" } }), (a2, b2) => a2 === b2);
  const needsEmailVerification = useSelector(service, (state) => state.matches({ authentication: { signedOut: "needsEmailVerification" } }), (a2, b2) => a2 === b2);
  const needsMfaOtp = useSelector(service, (state) => state.matches({ authentication: { signedOut: "needsMfa" } }), (a2, b2) => a2 === b2);
  const isError = useSelector(service, (state) => state.matches({ authentication: { signedOut: "failed" } }), (a2, b2) => a2 === b2);
  return {
    accessToken,
    error: error2,
    isError,
    isLoading,
    isSuccess,
    needsEmailVerification,
    needsMfaOtp,
    sendMfaOtp,
    signInEmailPassword,
    user
  };
};
const useSignInEmailPasswordless = (a2, b2) => {
  const stateEmail = typeof a2 === "string" ? a2 : void 0;
  const stateOptions = typeof a2 === "string" ? b2 : a2;
  const service = useAuthInterpreter();
  const signInEmailPasswordless = (valueEmail, valueOptions = stateOptions) => new Promise((resolve) => {
    service.send({
      type: "SIGNIN_PASSWORDLESS_EMAIL",
      email: typeof valueEmail === "string" ? valueEmail : stateEmail,
      options: valueOptions
    });
    service.onTransition((state) => {
      if (state.matches({ authentication: { signedOut: "failed" } })) {
        resolve({
          error: state.context.errors.authentication || null,
          isError: true,
          isSuccess: false
        });
      } else if (state.matches({ authentication: { signedOut: "needsEmailVerification" } })) {
        resolve({ error: null, isError: false, isSuccess: true });
      }
    });
  });
  const error2 = useSelector(service, (state) => state.context.errors.authentication || null, (a22, b22) => (a22 == null ? void 0 : a22.error) === (b22 == null ? void 0 : b22.error));
  const isLoading = !!service.status && service.state.matches({ authentication: { authenticating: "passwordlessEmail" } });
  const isSuccess = !!service.status && service.state.matches({ authentication: { signedOut: "needsEmailVerification" } });
  const isError = !!service.status && service.state.matches({ authentication: { signedOut: "failed" } });
  return { signInEmailPasswordless, isLoading, isSuccess, isError, error: error2 };
};
const useSignInAnonymous = () => {
  const service = useAuthInterpreter();
  const signInAnonymous = () => service.send("SIGNIN_ANONYMOUS");
  const error2 = useSelector(service, (state) => state.context.errors.authentication, (a2, b2) => (a2 == null ? void 0 : a2.error) === (b2 == null ? void 0 : b2.error));
  const isLoading = !!service.status && service.state.matches({ authentication: { authenticating: "anonymous" } });
  const isSuccess = useAuthenticated();
  const isError = !!service.status && service.state.matches({ authentication: { signedOut: "failed" } });
  const user = useSelector(service, (state) => state.context.user, (a2, b2) => (a2 == null ? void 0 : a2.id) === (b2 == null ? void 0 : b2.id));
  const accessToken = useSelector(service, (state) => state.context.accessToken.value);
  return { accessToken, error: error2, isError, isLoading, isSuccess, signInAnonymous, user };
};
const useProviderLink = (options) => {
  const nhost = useContext(NhostReactContext);
  return useMemo(() => new Proxy({}, {
    get(_2, provider) {
      return encodeQueryParameters(`${nhost.auth.client.backendUrl}/signin/provider/${provider}`, rewriteRedirectTo(nhost.auth.client.clientUrl, options));
    }
  }), [nhost, options]);
};
const useChangeEmail = (a2, b2) => {
  const stateEmail = typeof a2 === "string" ? a2 : void 0;
  const stateOptions = typeof a2 !== "string" ? a2 : b2;
  const nhost = useNhostClient();
  const machine = useMemo(() => createChangeEmailMachine(nhost.auth.client), [nhost]);
  const [, send2, service] = useMachine(machine);
  const [isError, setIsError] = useState(false);
  const [needsEmailVerification, setNeedsEmailVerification] = useState(false);
  const [error2, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const changeEmail = async (valueEmail, valueOptions = stateOptions) => new Promise((resolve) => {
    send2({
      type: "REQUEST",
      email: typeof valueEmail === "string" ? valueEmail : stateEmail,
      options: valueOptions
    });
    service.onTransition((state) => {
      if (state.matches({ idle: "error" })) {
        const error22 = state.context.error;
        setIsError(true);
        setError(error22);
        setIsLoading(false);
        resolve({ isError: true, error: error22, needsEmailVerification });
      } else if (state.matches("requesting")) {
        setIsLoading(true);
      } else if (state.matches({ idle: "success" })) {
        setIsError(false);
        setError(null);
        setIsLoading(false);
        setNeedsEmailVerification(true);
        resolve({ isError: false, error: null, needsEmailVerification: true });
      }
    });
  });
  return { changeEmail, isLoading, needsEmailVerification, isError, error: error2 };
};
const useChangePassword = (statePassword) => {
  const nhost = useNhostClient();
  const machine = useMemo(() => createChangePasswordMachine(nhost.auth.client), [nhost]);
  const [current, send2, service] = useMachine(machine);
  const isError = current.matches({ idle: "error" });
  const isSuccess = current.matches({ idle: "success" });
  const error2 = current.context.error;
  const isLoading = current.matches("requesting");
  const changePassword = (valuePassword) => new Promise((resolve) => {
    send2({
      type: "REQUEST",
      password: typeof valuePassword === "string" ? valuePassword : statePassword
    });
    service.onTransition((state) => {
      if (state.matches({ idle: "error" })) {
        resolve({ error: state.context.error, isError: true, isSuccess: false });
      } else if (state.matches({ idle: "success" })) {
        resolve({ error: null, isError: false, isSuccess: true });
      }
    });
  });
  return { changePassword, isLoading, isSuccess, isError, error: error2 };
};
const useResetPassword = (a2, b2) => {
  const stateEmail = typeof a2 === "string" ? a2 : void 0;
  const stateOptions = typeof a2 !== "string" ? a2 : b2;
  const nhost = useNhostClient();
  const machine = useMemo(() => createResetPasswordMachine(nhost.auth.client), [nhost]);
  const [current, send2, service] = useMachine(machine);
  const isError = current.matches({ idle: "error" });
  const isSent = current.matches({ idle: "success" });
  const error2 = current.context.error;
  const isLoading = current.matches("requesting");
  const resetPassword = (valueEmail, valueOptions = stateOptions) => new Promise((resolve) => {
    send2({
      type: "REQUEST",
      email: typeof valueEmail === "string" ? valueEmail : stateEmail,
      options: valueOptions
    });
    service.onTransition((state) => {
      if (state.matches({ idle: "error" })) {
        resolve({ error: state.context.error, isError: true, isSent: false });
      } else if (state.matches({ idle: "success" })) {
        resolve({ error: null, isError: false, isSent: true });
      }
    });
  });
  return { resetPassword, isLoading, isSent, isError, error: error2 };
};
const useUserData = () => {
  const service = useAuthInterpreter();
  return useSelector(service, (state) => state.context.user, (a2, b2) => JSON.stringify(a2) === JSON.stringify(b2));
};
const useAvatarUrl = () => {
  const service = useAuthInterpreter();
  return useSelector(service, (state) => {
    var _a2;
    return (_a2 = state.context.user) == null ? void 0 : _a2.avatarUrl;
  }, (a2, b2) => a2 === b2);
};
const useDefaultRole = () => {
  const service = useAuthInterpreter();
  return useSelector(service, (state) => {
    var _a2;
    return (_a2 = state.context.user) == null ? void 0 : _a2.defaultRole;
  }, (a2, b2) => a2 === b2);
};
const useDisplayName = () => {
  const service = useAuthInterpreter();
  return useSelector(service, (state) => {
    var _a2;
    return (_a2 = state.context.user) == null ? void 0 : _a2.displayName;
  }, (a2, b2) => a2 === b2);
};
const useEmail = () => {
  const service = useAuthInterpreter();
  return useSelector(service, (state) => {
    var _a2;
    return (_a2 = state.context.user) == null ? void 0 : _a2.email;
  }, (a2, b2) => a2 === b2);
};
const useUserId = () => {
  const service = useAuthInterpreter();
  return useSelector(service, (state) => {
    var _a2;
    return (_a2 = state.context.user) == null ? void 0 : _a2.id;
  }, (a2, b2) => a2 === b2);
};
const useIsAnonymous = () => {
  const service = useAuthInterpreter();
  return useSelector(service, (state) => {
    var _a2;
    return (_a2 = state.context.user) == null ? void 0 : _a2.isAnonymous;
  }, (a2, b2) => a2 === b2);
};
const useUserLocale = () => {
  const service = useAuthInterpreter();
  return useSelector(service, (state) => {
    var _a2;
    return (_a2 = state.context.user) == null ? void 0 : _a2.locale;
  }, (a2, b2) => a2 === b2);
};
const useUserRoles = () => {
  const service = useAuthInterpreter();
  return useSelector(service, (state) => {
    var _a2;
    return ((_a2 = state.context.user) == null ? void 0 : _a2.roles) || [];
  }, (a2, b2) => a2.every((i2) => b2.includes(i2) && b2.every((i22) => a2.includes(i22))));
};
const useSendVerificationEmail = (a2, b2) => {
  const stateEmail = typeof a2 === "string" ? a2 : void 0;
  const stateOptions = typeof a2 !== "string" ? a2 : b2;
  const nhost = useNhostClient();
  const machine = useMemo(() => createSendVerificationEmailMachine(nhost.auth.client), [nhost]);
  const [current, send2, service] = useMachine(machine);
  const isError = current.matches({ idle: "error" });
  const isSent = current.matches({ idle: "success" });
  const error2 = current.context.error;
  const isLoading = current.matches("requesting");
  const sendEmail = (valueEmail, valueOptions = stateOptions) => new Promise((resolve) => {
    send2({
      type: "REQUEST",
      email: typeof valueEmail === "string" ? valueEmail : stateEmail,
      options: valueOptions
    });
    service.onTransition((state) => {
      if (state.matches({ idle: "error" })) {
        resolve({ error: state.context.error, isError: true, isSent: false });
      } else if (state.matches({ idle: "success" })) {
        resolve({ error: null, isError: false, isSent: true });
      }
    });
  });
  return { sendEmail, isLoading, isSent, isError, error: error2 };
};
const useConfigMfa = () => {
  const nhost = useNhostClient();
  const machine = useMemo(() => createEnableMfaMachine(nhost.auth.client), [nhost]);
  const [current, send2, service] = useMachine(machine);
  const isError = useMemo(() => current.matches({ idle: "error" }) || current.matches({ generated: { idle: "error" } }), [current]);
  const isGenerating = current.matches("generating");
  const isGenerated = current.matches("generated");
  const isActivating = current.matches({ generated: "activating" });
  const isActivated = current.matches({ generated: "activated" });
  const error2 = current.context.error;
  const qrCodeDataUrl = current.context.imageUrl || "";
  const generateQrCode = () => new Promise((resolve) => {
    send2("GENERATE");
    service.onTransition((state) => {
      if (state.matches("generated")) {
        resolve({
          error: null,
          isError: false,
          isGenerated: true,
          qrCodeDataUrl: state.context.imageUrl || ""
        });
      } else if (state.matches({ idle: "error" })) {
        resolve({
          error: state.context.error || null,
          isError: true,
          isGenerated: false,
          qrCodeDataUrl: ""
        });
      }
    });
  });
  const activateMfa = (code) => new Promise((resolve) => {
    send2({
      type: "ACTIVATE",
      activeMfaType: "totp",
      code
    });
    service.onTransition((state) => {
      if (state.matches({ generated: "activated" })) {
        resolve({ error: null, isActivated: true, isError: false });
      } else if (state.matches({ generated: { idle: "error" } })) {
        resolve({ error: state.context.error, isActivated: false, isError: true });
      }
    });
  });
  return {
    generateQrCode,
    isGenerating,
    qrCodeDataUrl,
    isGenerated,
    activateMfa,
    isActivating,
    isActivated,
    isError,
    error: error2
  };
};
const useNhostAuth = () => {
  const { isLoading, isAuthenticated } = useAuthenticationStatus();
  const user = useUserData();
  return useMemo(() => ({ isLoading, isAuthenticated, user }), [isLoading, isAuthenticated, user]);
};
const useSignUpEmailPassword = (a2, b2, c2) => {
  const stateEmail = typeof a2 === "string" ? a2 : void 0;
  const statePassword = typeof b2 === "string" ? b2 : void 0;
  const stateOptions = c2 || (typeof a2 !== "string" ? a2 : void 0);
  const service = useAuthInterpreter();
  const isError = !!service.status && service.state.matches({ authentication: { signedOut: "failed" } });
  const error2 = useSelector(service, (state) => state.context.errors.registration || null, (a22, b22) => (a22 == null ? void 0 : a22.error) === (b22 == null ? void 0 : b22.error));
  const { isLoading: loading, isAuthenticated: isSuccess } = useAuthenticationStatus();
  const isLoading = useMemo(() => loading && !isSuccess, [loading, isSuccess]);
  const needsEmailVerification = !!service.status && service.state.matches({ authentication: { signedOut: "needsEmailVerification" } });
  const signUpEmailPassword = (valueEmail, valuePassword = statePassword, valueOptions = stateOptions) => new Promise((resolve) => {
    service.send({
      type: "SIGNUP_EMAIL_PASSWORD",
      email: typeof valueEmail === "string" ? valueEmail : stateEmail,
      password: valuePassword,
      options: valueOptions
    });
    service.onTransition((state) => {
      if (state.matches({ authentication: { signedOut: "failed" } })) {
        resolve({
          accessToken: null,
          error: state.context.errors.registration || null,
          isError: true,
          isSuccess: false,
          needsEmailVerification: false,
          user: null
        });
      } else if (state.matches({ authentication: { signedOut: "needsEmailVerification" } })) {
        resolve({
          accessToken: null,
          error: null,
          isError: false,
          isSuccess: false,
          needsEmailVerification: true,
          user: null
        });
      } else if (state.matches({ authentication: "signedIn" })) {
        resolve({
          accessToken: state.context.accessToken.value,
          error: null,
          isError: false,
          isSuccess: true,
          needsEmailVerification: false,
          user: state.context.user
        });
      }
    });
  });
  const user = useSelector(service, (state) => state.context.user, (a22, b22) => (a22 == null ? void 0 : a22.id) === (b22 == null ? void 0 : b22.id));
  const accessToken = useSelector(service, (state) => state.context.accessToken.value);
  return {
    accessToken,
    error: error2,
    isError,
    isLoading,
    isSuccess,
    needsEmailVerification,
    signUpEmailPassword,
    user
  };
};
suppressConsoleMessage("useLayoutEffect does nothing on the server", "error");
class NhostClient extends NhostClient$1 {
  constructor(params) {
    super(__spreadProps(__spreadValues({}, params), { start: false }));
  }
}
export { NhostClient, NhostReactContext, NhostReactProvider, useAccessToken, useAuthInterpreter, useAuthLoading, useAuthenticated, useAuthenticationStatus, useAvatarUrl, useChangeEmail, useChangePassword, useConfigMfa, useDefaultRole, useDisplayName, useEmail, useIsAnonymous, useNhostAuth, useNhostBackendUrl, useNhostClient, useProviderLink, useResetPassword, useSendVerificationEmail, useSignInAnonymous, useSignInEmailPassword, useSignInEmailPasswordless, useSignOut, useSignUpEmailPassword, useUserData, useUserId, useUserLocale, useUserRoles };
